import { defineComponent as _defineComponent } from 'vue'
import { getRawMaterialPlankInfo } from '@/apis/baseMaterial'
import { getBlankTableList } from '@/apis/baseMaterial/blankTable'
import { IPlankKnifeMapType } from '@/apis/baseMaterial/type'
import { addPlankToStore } from '@/apis/bujianStore'
import { buryPoint } from '@/apis/common/buryPoint'
import { saveHistory } from '@/apis/common/saveHistory'
import { getThirdData } from '@/apis/common/thirdData'
import { getSaeSetting } from '@/apis/equipment/index'
import {
  fetchCheckSyncGuiguiData,
  fetchGenerateSmtFile,
  fetchGetBrandAndSupplierInfo,
  fetchGetLayoutData,
  fetchGetProductionNcSetting,
  fetchGuiguiOrderInfo,
  fetchMaterialTransData,
  fetchSaveBaseMaterial,
  fetchSyncGuiguiData,
  getCustomFolderSetting,
} from '@/apis/materialList'
import type { ISmtFileResponse } from '@/apis/materialList/types'
import { getProucePopupState, updateProduceStatus } from '@/apis/paiban'
import { getPrelayoutSetting } from '@/apis/preLayoutSetting'
import { httpRequest } from '@/apis/request'
import { getSurplusListApi, surplusLock } from '@/apis/surplusManage/index'
import { getSpecialRemarks } from '@/apis/tag/index'
import { checkUserPermissionWithToast } from '@/auth/user_function'
import BaseFrom from '@/baseui/from'
import loading from '@/components/common/loading'
import DrawItem from '@/components/draw/drawItem.vue'
import DrawSupplus from '@/components/draw/drawSupplus.vue'
import GBaseModal from '@/components/g-base-modal.vue'
import GCopyLine from '@/components/g-copy-line/index.vue'
import GFolderChooseModal from '@/components/g-folder-choose-modal.vue'
import GOrderProductionMarking from '@/components/g-order-production-marking.vue'
import GPaidFeature from '@/components/g-paid-feature.vue'
import GTableDialog from '@/components/g-table-dialog.vue'
import GWarningModal from '@/components/g-warning-modal.vue'
import holesSlotsPopUp from '@/components/material/holesAndSlotsDetail.vue'
import virtualList from '@/components/materialTable'
import {
  allTableHeaderList,
  headPropList,
} from '@/components/materialTable/src/config/tableConfig'
import type { IPropList } from '@/components/materialTable/src/config/tableConfig'
import newContent from '@/components/newContent.vue'
import { showSyncModal } from '@/components/syncmodal'
import { USER_PERMISSION_KEY } from '@/data/auth'
import { SESSION_STORAGE_KEYS } from '@/data/constant'
import { translateLang } from '@/data/i18n/translateLang'
import { useStore } from '@/hooks/useStore'
import { updateLocalPreference } from '@/store/modules/preferencesSetting'
import { PreferencesSetting } from '@/store/modules/preferencesSetting/types'
import {
  changeLayoutData,
  dealFrameDoorSplice,
  generatorSideHoleSlot,
  judgeIsMergeFrameDoor,
  layoutStart,
  reversalPlank,
} from '@/util/LayoutFuncs.js'
import {
  adjustHoleDirection,
  isOnlyProcessSlotAndHole,
  rotate180Part,
  rotatePart,
} from '@/util/LayoutTool'
import { sendTrialRecord } from '@/util/NcFileRelated'
import {
  getMaterialCategoryKey,
  isBrandRecord,
} from '@/util/brandPlankIdentity'
import { EventBusKey } from '@/util/bus'
import EventBus from '@/util/bus'
import { matchMixPaibanPlan } from '@/util/common'
import {
  checkColorIsExist,
  checkMatCodeIsExist,
  dealHighlightMatCode,
  fetchMaterialMatCodes,
  getSurplusMatchTypes,
  matchHighlightBoardName,
  restoreOriginalMatcode,
  translate,
} from '@/util/commonFun'
import {
  buryPointApi,
  genFinalRecord,
  generatePlankId,
  generateSimplePlankNum,
  generateSimplePlankNumFn,
  isSideMachineHole,
  isSideMachineMillInfo,
  isSideMachineSlot,
  modalMsg,
  splitTime,
  toDecimal,
  uniquePlankNum,
  verifyInputNumber,
} from '@/util/commonFuncs'
import { fileNameSetObj } from '@/util/configure'
import { dealGuiguiJson } from '@/util/dealGuiguiJson.js'
import {
  dealLayoutResultData,
  dealPaibanData,
  dealPaibanDataLabelID,
  dealPreLayoutDataLabelID,
  genPaibanRequestParams,
  genSurplusParams,
} from '@/util/dealPaibanData.js'
import { dealPlankHoleSlot } from '@/util/dealPlankDataFuncs'
import {
  dealGeneralMaterialData,
  dealThinkerxMaterialData,
} from '@/util/dealThinkerxMaterialData'
import { DrawPartView } from '@/util/drawPlank'
import { exportHoleSlotDxf, exportThreeViewDxf } from '@/util/dxf/holeSlotDxf'
import { collector } from '@/util/file/customFolderGenerate'
import {
  clearTextureGrainInfo,
  compositeTexturePlanks,
  decompositeTexturePlanks,
  flipTextureLowPos,
  isTextureAlignmentPlank,
  isVirtualCompositePlank,
  showTextureConfirmModal,
} from '@/util/plankAlignTexture'
import {
  GenerateHoleSlotPdf,
  dealEdgeInfoChange,
  dealExcelManifest,
  dealFormerEdgeChange,
  dealMaterialList,
  dealMorePlateKnife,
  downloadCsvFile,
  getSlotBasicInfo,
} from '@/util/plankCommonFuncs'
import {
  _translateFileNameFn,
  promiseToZip,
  saveDataJsonToOssForRecord,
  saveDataToOSS,
} from '@/util/saveFile'
import { handleGenFileNameStr } from '@/util/tag'
import { getGraghEdge } from '@/util/tag'
import { jsPdfTool } from '@/util/tag/pdfFont'
import { samPleConfig as defaultSampleConfig } from '@/views/materialsList/config/formConfig'
import type {
  IProductionLineType,
  IpaibanFormDataType,
  StandardPlankType,
} from '@/views/materialsList/types/paiban'
import type { ISurplusType } from '@/views/materialsList/types/surplus'
import type { NecessaryTableHeaderType } from '@/views/materialsList/utils/importFile'
import { getPlankToAwaitStoreData } from '@/views/newPaiban/component/m-paiban-store/utlis'
import MTryProductionDialog from '@/views/newPaiban/component/m-try-production-dialog/index.vue'
import {
  downloadFile as downloadNCFile,
  genNcZipByCustomFolder,
  mergeFolder,
} from '@/views/newPaiban/util/downLoadNC'
import { clearCachedRawPlank } from '@/views/newPaiban/util/renderUrlCache'
import { uploadFiles as ossUploadFiles } from '@/views/newPaiban/util/uploadFiles'
import { createTask } from '@/views/taskList/util/dealData'
import { Modal, message } from 'ant-design-vue'
import axios from 'axios'
import { Message, Tooltip } from 'element-ui'
import { cloneDeep, debounce } from 'lodash-es'
import { nanoid } from 'nanoid'
import Sortable from 'sortablejs'
import {
  computed,
  nextTick,
  onBeforeUnmount,
  onMounted,
  ref,
  toRaw,
  watch,
  watchEffect,
} from 'vue'
import { getCurrentInstance } from 'vue'
import Vue from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'
import XLSX from 'xlsx'

import {
  calcBaseMaterial,
  filterSurplusByNoCutPlanks,
  genBaseMaterialsForNotCutParts,
  intersection,
  isBrandPart,
} from '../newPaiban/util/layoutDataDeal'
import { sendDataToWorkShop } from '../workShopProduction/utils'
import MAwaitPaibanStore from './components/m-await-paiban-store.vue'
import MBujianTable from './components/m-bujian-table.vue'
import MCustomizeTableHeader from './components/m-customize-table-header/index.vue'
import CustomizeTableHeader from './components/m-customize-table-header/index.vue'
import MIncorrectFormat from './components/m-incorrect-format.vue'
import mMixPaibanPlanModal from './components/m-mix-paiban-plan-modal.vue'
import MNotPaibanDetail from './components/m-not-paiban-detail.vue'
import plankEditor from './components/m-plank-editer.vue'
import plankFilter from './components/m-plank-filter.vue'
import paibanSetting from './components/paibanSetting.vue'
import {
  doorOptions, // highPlankOptions,
  surplusHeaders,
  texDirOptions,
} from './config/commonConfig'
import { extraPartsTableConfig } from './config/tableConfig'
import { useAddPart, useRecordData } from './hooks'
import type { ChangePart } from './hooks'
import type { IAddPartFormType } from './types/form'
import type {
  GetPromiseType,
  IAutoAddPlankFieldsType,
  IEditableFields,
  IFilterableFieldsType,
  INcSettingType,
  INewMaterialListExtraPartType,
  INewMaterialListSpecialPlankType,
  SamPleFormDataType,
} from './types/material'
import type { PartType, PlankType, TextureType } from './types/part'
import { dealPreLayoutSetting } from './util/preLayoutDeal'
import { compose } from './utils/common'
import {
  checkCsvData,
  dealCsvOrderInfo,
  dealExcelData,
  indispensableHeaderPropList,
} from './utils/importFile'
import {
  calculatePlankAmount,
  calculatePlankArea,
  dealData,
  dealFilterData,
  getFilterPropOriData,
} from './utils/index'
import { processLabelFn, showMaterialHingeinfo } from './utils/show'

type DownloadBarCodeOptions = {
  uniqueBarCode?: boolean
  genSimpleLabelBarcode?: boolean
}

/** 按数量平铺小板，导出时每行 amount=1，条码按更多设置处理 */
interface MaterialColorItemType {
  label: string
  value: string
  children?: MaterialColorItemType[]
}
// 颜色选择数据配置项
type newPlankInfoType = keyof typeof newPlankInfo.value

// 表单项输入检测
type NCSettingType = GetPromiseType<
  ReturnType<typeof fetchGetProductionNcSetting>
>['data'] &
  INcSettingType
// 处理排版数据
interface ProucePopupState {
  mark_action: 0 | 1
  is_produced_orders: boolean
  is_display_mark: boolean
}
interface IBatchUpdateCallbackParams {
  prop: IEditableFields
  isAllRows: boolean
  editValue: string | number | boolean | undefined
}
enum CurrentPerfSettingMap {
  loadMore = 'isLoadMoreTable',
  fold = 'isDefaultFoldData',
  saveHighLightHeader = 'savedHightLightProp',
  isCheckBigPlankSynchronous = 'isCheckBigPlankSynchronous',
  bujianRecommend = 'isBujianRecommend',
  paibanStoreRecommend = 'isPaibanStoreRecommend',
  surplusRecommend = 'isSurplusRecommend',
}
enum allPerfSettingMap {
  loadMore = 'isLoadMoreTable',
  fold = 'pick_up_data',
  saveHighLightHeader = 'saved_highlight_prop',
  isCheckBigPlankSynchronous = 'isCheckBigPlankSynchronous',
  bujianRecommend = 'isBujianRecommend',
  paibanStoreRecommend = 'isPaibanStoreRecommend',
  surplusRecommend = 'isSurplusRecommend',
}
// 保存偏好设置（默认收起数据）
interface OrderInfoType {
  order_ids: string
  order_codes: string
  needPaibanRoomIds: string[]
  room_ids: string[]
  bujianPlankId: Record<
    string,
    Array<{
      plankId: number
      ggid: string
      orderNo: string
      address: string
      oid: string
      plankNum: string | number
      customerName: string
    }>
  >
  needBujianRoomId: string[]
  addition_info: Record<string, any>[]
}
// 处理柜柜跳转进来的参数
type ExcludeType<T, U> = T extends U ? never : T
// 自定义料单表头
enum ListTileType {
  TABLE = 1,
  GRAPH = 0,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'newMaterialListV2',
  setup(__props) {

const vm = getCurrentInstance()

const proxy = vm!.proxy

const route = useRoute()
const router = useRouter()
const store = useStore()

const overSizeTipContent = `系统检查到排版小板中存在超尺板件，下面是特殊板材添加建议，可以手动修改板材长宽后点击表格下方<span class="bold color-0">“一键添加”</span>按钮，快速添加后继续排版，也可以在<span class="bold color-0">原片设置-特殊板材</span>手动添加板件 `

/** vuex中的偏好设置 */
const storePreferencesSetting = computed(
  () => store.state.preferencesSetting?.setting
)

/** 特殊工艺筛选配置，用于 process_label 展示与导出与标签一致 */
const specialRemarksForProcessLabel = computed(
  () => store.state.specialRemarks as Record<string, unknown> | undefined
)

// 高光板选项
const highPlankOptions = computed(() => {
  return (matcode: string) => {
    return [
      {
        value: true,
        label: matchHighlightBoardName(restoreOriginalMatcode(matcode)),
      },
      {
        value: false,
        label: `非${matchHighlightBoardName(restoreOriginalMatcode(matcode))}`,
      },
    ]
  }
})
// 初次导入json
const isFirstLoadJson = ref(true)
// 页面加载状态
const isTaskLoading = ref(false)

const importCount = computed(() => store.state.importCount)

// 数据来源
const dataFrom = computed(() => store.state.dataFrom)

// 是否勾选异形余料
const hasSelectSpecialShapeSurplus = computed(() => {
  const selectedSurplusList = surplusList.value.filter((i) => i.isSelected)
  return selectedSurplusList.some(
    (item) => item.shape == 2 && item.path && item.path.length > 7
  )
})

/**
 * 接任务页面
 *
 */
const hasSendToTask = computed(() => store.state.hasSendToTask)
const sendTaskModal = ref<any>(null)

// 余料详情popover方法-浮层渲染父节点，默认渲染到 body 上
const getPopupContainer = () => {
  return document.body
}

// 显示余料绘制
const drawScale = ref(1)
const drawObj = ref({})
const showSupplusShape = (visible: boolean, supplus: any) => {
  if (visible) {
    if (supplus.long > 257 || supplus.width > 172) {
      let scaleY = supplus.long / 257
      let scaleX = supplus.width / 172
      if (scaleX >= scaleY) {
        drawScale.value = scaleX
      } else {
        drawScale.value = scaleY
      }
    }
    drawObj.value = {
      long: Number(supplus.long),
      width: Number(supplus.width),
      min_long: supplus.min_long == '' ? 0 : Number(supplus.min_long),
      min_width: supplus.min_width == '' ? 0 : Number(supplus.min_width),
      path: supplus.path,
    }
  }
}

// 前往接任务页面
const handleBackToTask = () => {
  const allParts = getAllParts(plankList.value)
  if (!hasSendToTask.value && allParts.length) {
    sendTaskModal.value = (vm?.proxy as any).$antdConfirm({
      title: translateLang('提示'),
      content: translateLang('是否创建对应的任务卡片?'),
      okText: translateLang('确定'),
      cancelText: translateLang('取消'),
      centered: true,
      closable: true,
      onOk: () => {
        isTaskLoading.value = true
        createTask(allParts).then(() => {
          isTaskLoading.value = false
          store.commit('setHasSendToTask', true)
          buryPointApi('task', 'creat_task')
          router.push('/taskList')
        })
      },
      onCancel: (e: any) => {
        handleCancelToTask(e)
      },
    })
  } else {
    router.push('/taskList')
  }
}
const handleCancelToTask = (e: any) => {
  const isCancel = typeof e == 'function'
  sendTaskModal.value && sendTaskModal.value.destroy()
  if (isCancel) {
    router.push('/taskList')
  }
}

/**
 * 数据源
 *
 */

//  出于性能优化，需要将部分字段冻结
const needFreezeProp = [
  'path',
  'oPath',
  'holes',
  'slots',
  'curveHoles',
] as const

// 开料清单源数据
const plankList = ref<PlankType[]>([])
// 开料清单展示数据
const filterPlankList = ref<PlankType[]>([])
// 处理完数据后，进行赋值操作
const setPlankList = (data: PlankType[]) => {
  plankList.value.splice(0, plankList.value.length)
  data.forEach((item) => {
    item.parts.forEach((part) => {
      needFreezeProp.forEach((prop) => {
        if (part[prop] && !Object.isFrozen(part[prop])) {
          Object.freeze(part[prop])
        }
      })
    })
    plankList.value.push(item)
  })
}

const sortTypeObj = ref({
  field: '',
  sortDirection: 'none',
  sortType: '',
})
const handleSort = (fieldObj: any) => {
  sortTypeObj.value = fieldObj
  // 排序操作逻辑 修改filterPlankList
  const { field, sortType, sortDirection } = fieldObj
  const tempPlankList = cloneDeep(filterPlankList.value)

  // 如果排序方向为none，则恢复原始顺序
  if (sortDirection === 'none') {
    // 恢复原始数据顺序，这里需要重新从plankList获取数据
    filterPlankList.value = cloneDeep(plankList.value)
    return
  }

  tempPlankList.forEach((plank) => {
    plank.parts.sort((a: any, b: any) => {
      // 这个实现方式还有问题 暂且保留
      // 根据 isReverse 为 true specHeight specWidth 取反
      // const aValue =
      //   (a.isReverse
      //     ? Number(a[field === 'specHeight' ? 'specWidth' : 'specHeight'])
      //     : Number(a[field])) || 0
      // const bValue =
      //   (b.isReverse
      //     ? Number(b[field === 'specHeight' ? 'specWidth' : 'specHeight'])
      //     : Number(b[field])) || 0
      // ====================
      // 表格的展示逻辑 这里要与展示逻辑保修一致排序
      // if (part.texDir == 'reverse') {
      //   if (field == 'specHeight') str = part['specWidth']
      //   if (field == 'specWidth') str = part['specHeight']
      // }
      const aValue =
        (a.texDir == 'reverse'
          ? Number(a[field === 'specHeight' ? 'specWidth' : 'specHeight'])
          : Number(a[field])) || 0
      const bValue =
        (b.texDir == 'reverse'
          ? Number(b[field === 'specHeight' ? 'specWidth' : 'specHeight'])
          : Number(b[field])) || 0
      if (sortDirection === 'asc') {
        return aValue - bValue
      } else if (sortDirection === 'desc') {
        return bValue - aValue
      } else {
        return 0 // 无序状态返回0，保持原顺序
      }
    })
  })
  // filterPlankList.value = tempPlankList
  setFilterPlankList(tempPlankList)
}

// 因为每次filterPlankList的改变是会被清空再赋值，导致不会记录清空前的数据，所以需要一个变量来记录
let changeData = ref<string[]>([])
// 遍历filterPlankList，将每个plank的parts的isSelected属性为true的板件oriPartUniqueId记录到changeData中
const changeFilterPlankList = (data?: PlankType[]) => {
  let tempData = data || filterPlankList.value
  tempData.forEach((plank) => {
    plank.parts.forEach((part: any) => {
      if (part.isSelected) {
        changeData.value.push(part.oriPartUniqueId)
      } else {
        changeData.value = changeData.value.filter(
          (item) => item !== part.oriPartUniqueId
        )
      }
    })
  })
  // 兜底 去重
  changeData.value = [...new Set(changeData.value)]
}
const setFilterPlankList = (data: PlankType[]) => {
  // 清空当前的响应式数组
  filterPlankList.value.splice(0, filterPlankList.value.length)
  data.forEach((item) => {
    item.parts.forEach((part) => {
      needFreezeProp.forEach((prop) => {
        if (part[prop] && !Object.isFrozen(part[prop])) {
          Object.freeze(part[prop])
        }
      })
      if (changeData.value.includes(part.oriPartUniqueId)) {
        part.isSelected = true
      } else {
        part.isSelected = false
      }
    })
    filterPlankList.value.push(item)
  })
  // filterPlankList.value= data
}
// 根据filterPlankList计算出, 开料清单表格数据
const materialTableData = computed(() => {
  const resultParts: (
    | PlankType
    | (PartType & {
        materialBaseTableIndex: number
        materialBasePartIndex: number
      })
  )[] = []
  if (!filterPlankList.value || !filterPlankList.value.length) return []
  filterPlankList.value.forEach((plank, idx) => {
    // 添加字段标识大板数据
    // 每循环一个大板就填加一个隔断信息表示一种材质的板件
    const headData = Object.assign(plank, {
      isVirtualHead: true,
      materialBaseTableIndex: idx,
      // 添加一个和板件一样的唯一key
      partUniqueId: nanoid(),
    })
    resultParts.push(headData)
    if (plank.isUnfold) {
      plank.parts.forEach((part, partIdx) => {
        const materialBaseTableIndex = idx
        const materialBasePartIndex = partIdx
        needFreezeProp.forEach((prop) => {
          if (part[prop] && !Object.isFrozen(part[prop])) {
            Object.freeze(part[prop])
          }
        })
        resultParts.push({
          ...part,
          materialBaseTableIndex,
          materialBasePartIndex,
        })
      })
    }
  })
  return resultParts
})

/**
 * 导入文件
 *
 */
const inputFileRef = ref<HTMLInputElement | null>(null)
// 导入文件的状态
const isImportLoading = ref(false)
// 打开本地文件系统
const handleOpenFile = () => {
  inputFileRef.value?.dispatchEvent(new MouseEvent('click'))
  store.commit('setRecodeSelectPart', { selects: [], isHistory: true })
  store.commit('setRecodeSelectSurplus', { selects: [], isHistory: true })
}
const lackTableString = ref('')
const isLinkLogin = computed(() => store.state.isLinkLogin)
// 读取本地文件数据
const getFileData = (e: ChangeEvent<HTMLInputElement>) => {
  try {
    isTaskLoading.value = true
    isImportLoading.value = true
    isSelectedAllSurplus.value = true
    // 如果导入了新的数据，接任务状态更新失效
    store.commit('setIsNewPaiban', false)
    // 文件导入时清空所有筛选相关
    store.commit('setFilterObject', {})
    const allFiles = e.target.files
    if (!allFiles || allFiles.length == 0) throw new Error('导入文件数量为空')
    let file = allFiles[0]
    let fileType = file.name.split('.').pop()
    let files = { 0: file }

    // 创建一个文件读取器，用于读取文件内容
    let fileReader = new FileReader()
    store.commit('setHasPrintTag', false)
    store.commit('changeHistoryStatus', false)
    store.commit('setIsShowSample', true)
    // FIX
    if (isLinkLogin) {
      store.commit('setIsShowSample', false)
    }
    if (fileType == 'xls' || fileType == 'xlsx') {
      fileReader.readAsBinaryString(files[0])
      fileReader.onload = async (e) => {
        try {
          if (!e.target) return
          let data = e.target.result
          let workbook = XLSX.read(data, { type: 'binary' })
          let wsname = workbook.SheetNames[0]
          let ws = XLSX.utils.sheet_to_json<Record<string, any>>(
            workbook.Sheets[wsname]
          )
          ws = dealExcelManifest(ws, wsname, this)
          const keyMaps = {
            纹: '纹理',
            量: '数量',
            材: '材质',
          }
          const necessaryKeysList = Object.keys(
            keyMaps
          ) as (keyof typeof keyMaps)[]
          const newWS = ws.map((item) => {
            for (const key in item) {
              const cutIdx = necessaryKeysList.findIndex((it) =>
                key.includes(it)
              )
              if (cutIdx !== -1 && keyMaps[necessaryKeysList[cutIdx]] !== key) {
                item = {
                  ...item,
                  [keyMaps[necessaryKeysList[cutIdx]]]: item[key],
                }
                Reflect.deleteProperty(item, key)
              }
            }
            return item
          })
          // 检测导入数据是否符合要求
          const flag = checkImportData(newWS)
          if (!flag) {
            // 此处关闭的原因是因为这个loading样式和弹窗背景颜色有冲突
            isTaskLoading.value = false
            return
          }

          // 处理导入的数据
          const { plankList: excelPlankList } = dealExcelData(newWS)
          initData(
            excelPlankList as Required<PartType>[],
            {
              isClearHSInfo: true,
              isLoadMore: currentPreferenceSetting.value.isLoadMoreTable,
              isToggle: false,
            },
            true
          )
          // 导入数据时, 删除排版相关数据
          store.commit('clearPaibanData')
          store.commit('setIsTrialProduct', false)
          store.commit('setHasSendToTask', false)
          if (currentPreferenceSetting.value.isLoadMoreTable) {
            store.commit('awaitPaibanStore/clearInMaterialPageIds')
          }
        } catch (err) {
          Vue.prototype.$message({
            message: '解析文件内容失败，请确认文件内容!',
            type: 'error',
          })
          return false
        } finally {
          isTaskLoading.value = false
        }
      }
    } else if (fileType == 'csv') {
      // 导入csv文件
      fileReader.readAsText(files[0], 'GBK')
      fileReader.onload = (e) => {
        try {
          if (e.target?.result == '' || e.target?.result == '\r\n') {
            Vue.prototype.$message({
              message: '没有查询到数据!',
              type: 'warning',
            })
            return
          }
          let temData: string[] = []
          if (e.target?.result && typeof e.target?.result === 'string') {
            if (e.target.result.includes('\r\n')) {
              temData = e.target.result.split(/\r\n/)
            } else if (e.target.result.includes('\n')) {
              temData = e.target.result.split(/\n/)
            }
          }
          // 将读取的数据处理成可以普通表格数据
          const { data, headerItemAddress, showSample } =
            dealCsvOrderInfo(temData)
          // 检测导入的csv数据的表头是否合法
          checkCsvData(data)
            .then(async (res: Record<string, any>[]) => {
              // 检测数据是否合法
              const flag = checkImportData(res)
              if (!flag) {
                isTaskLoading.value = false
                return
              }
              samPleFormData.value = {
                ...samPleFormData.value,
                ...headerItemAddress,
              }
              // 设置是否显示样表表头
              store.commit('setIsShowSample', showSample)
              // 处理导入的数据
              const { plankList: excelPlankList } = dealExcelData(res)
              // 将导入的数据添加到plankList中
              initData(
                excelPlankList as Required<PartType>[],
                {
                  isClearHSInfo: true,
                  isLoadMore: currentPreferenceSetting.value.isLoadMoreTable,
                  isToggle: false,
                },
                true
              )
              // 获取导入的订单信息
              // store.commit('setOrderInfo', orderInfo)
              // 导入数据时, 删除排版相关数据
              store.commit('clearPaibanData')
              store.commit('setIsTrialProduct', false)
              store.commit('setHasSendToTask', false)
              if (currentPreferenceSetting.value.isLoadMoreTable) {
                store.commit('awaitPaibanStore/clearInMaterialPageIds')
              }
            })
            .catch((err) => {
              // 此处关闭的原因是因为这个loading样式和弹窗背景颜色有冲突
              isTaskLoading.value = false
              const {
                showTableDialog: showTableDialogTemp,
                isShowLackNeedTableHeader: isShowLackNeedTableHeaderTemp,
                isShowLackNeedTableHeaderData:
                  isShowLackNeedTableHeaderDataTemp,
                lackTableString: lackTableStringTemp,
              } = err
              showTableDialog.value = showTableDialogTemp
              isShowLackNeedTableHeader.value = isShowLackNeedTableHeaderTemp
              isShowLackNeedTableHeaderData.value =
                isShowLackNeedTableHeaderDataTemp
              lackTableString.value = lackTableStringTemp
            })
        } catch (err) {
          Vue.prototype.$message({
            message: '解析文件内容失败，请确认文件内容!',
            type: 'error',
          })
          return false
        } finally {
          isTaskLoading.value = false
        }
      }
    } else if (fileType == 'json') {
      fileReader.readAsText(file)
      fileReader.onloadend = async () => {
        try {
          if (typeof fileReader.result !== 'string')
            throw new Error('读取文件格式错误')
          const data = JSON.parse(fileReader.result)
          await dealJsonData(data, importCount.value > 1)
        } finally {
          isTaskLoading.value = false
        }
      }
      store.commit('setHasSendToTask', false)
      if (currentPreferenceSetting.value.isLoadMoreTable) {
        store.commit('awaitPaibanStore/clearInMaterialPageIds')
      }
    } else {
      store.commit('setHasPrintTag', true)
      isTaskLoading.value = false
      Vue.prototype.$message({
        message: '请选择正确的文件!',
        type: 'error',
      })
    }
    sessionStorage.setItem('isImportOrder', 'true')
    currentPreferenceSetting.value.isLoadMoreTable
      ? store.commit(
          'setImportCount',
          importCount.value ? importCount.value + 1 : 1
        )
      : store.commit('setImportCount', 1)
    buryPointApi('material', 'import_material')
  } catch (err) {
    console.log('导入文件出错', err)
    isSelectedAllSurplus.value = false
  } finally {
    // 事件处理完成后需要置空选择文件，否则无法重复选择当前文件
    e.target.value = ''
    isImportLoading.value = false
  }
}

//是否显示导入数据格式错误消息框
const showMIncorrectFormat = ref(false)
//是否显示导入出错消息框
const showTableDialog = ref(false)

//必要表头缺少对应数据弹出消息框
const isShowLackNeedTableHeaderData = ref(false)
//缺少必要表头弹出消息框
const isShowLackNeedTableHeader = ref(false)
//导入列表时，必要表头项缺失数据
const necessaryTableLackString = ref<
  Record<string, NecessaryTableHeaderType[]>
>({})
//导入列表时，必要表头项数据格式不正确
const necessaryTableIncorrectFormat = ref<
  Record<string, NecessaryTableHeaderType[]>
>({})

//清空导入表头数据格式错误
const handleClearMIncorrectFormatData = () => {
  showMIncorrectFormat.value = false
  necessaryTableIncorrectFormat.value = {}
}

//清空导入表头缺少数据
const handleClearMissingData = () => {
  showTableDialog.value = false
  isShowLackNeedTableHeaderData.value = false
  necessaryTableLackString.value = {}
  lackTableString.value = ''
}

// 检测导入的数据是否正确
const checkImportData = (data: Record<string, any>[]) => {
  if (data.length == 0) {
    Vue.prototype.$message({
      message: translateLang('没有查询到数据!'),
      type: 'warning',
    })
    return false
  }
  //检测导入数据每一行的必要表头的数据是否缺少
  const customIndispensableHeader: IPropList[] =
    storePreferencesSetting.value?.needSaveData?.filter(
      (item) =>
        item.prop && indispensableHeaderPropList.includes(item.prop as any)
    ) ?? []
  data.forEach((item, index) => {
    let excessiveList: NecessaryTableHeaderType[] = []
    let incorrectFormatList: NecessaryTableHeaderType[] = []
    customIndispensableHeader.forEach((customItem) => {
      const customLabel = String(translate(customItem.customLabel as any) ?? '')
      const labelText = String(translate(customItem.label as any) ?? '')
      const headerKeyList = [customLabel, labelText].filter(Boolean)
      if (!headerKeyList.length) return
      const displayValue = customLabel || labelText
      const matchedHeaderKey = headerKeyList.find(
        (key) => item[key] !== undefined
      )
      const matchedCellValue = matchedHeaderKey
        ? item[matchedHeaderKey]
        : undefined
      // 判断缺失的表头项
      if (matchedHeaderKey === undefined) {
        showMIncorrectFormat.value = true
        incorrectFormatList.push(displayValue)
      }
      if (
        matchedCellValue !== undefined &&
        String(matchedCellValue).trim() === ''
      ) {
        showTableDialog.value = true
        isShowLackNeedTableHeaderData.value = true
        isShowLackNeedTableHeader.value = false
        excessiveList.push(displayValue)
      } else if (
        ['thick', 'specHeight', 'specWidth', 'amount'].includes(
          customItem.prop as string
        )
      ) {
        if (!isNumericPositive(matchedCellValue) && matchedCellValue) {
          showMIncorrectFormat.value = true
          incorrectFormatList.push(displayValue)
        }
      } else if (customItem.prop === 'texDir' && matchedCellValue) {
        if (
          !['横纹', '竖纹', '无纹理'].includes(String(matchedCellValue).trim())
        ) {
          showMIncorrectFormat.value = true
          incorrectFormatList.push(displayValue)
        }
      }
    })
    if (excessiveList.length !== 0) {
      necessaryTableLackString.value[index] = excessiveList
    }
    if (incorrectFormatList.length !== 0) {
      necessaryTableIncorrectFormat.value[index] = incorrectFormatList
    }
  })
  if (showTableDialog.value || showMIncorrectFormat.value) return false
  return true
}
//判断是否为数字且大于0
const isNumericPositive = (value: string | number) => {
  const number = Number(value)
  return !isNaN(number) && number > 0
}

/**
 * 删除板件
 *
 */
// 已经勾选的料单板件
const selectedParts = computed(() => {
  return getSelectedData(filterPlankList.value)
})
// 参与排版的补件和待排版库板件
const bujianDataForPaiban = ref<PartType[]>([])
const awaitStoreDataForPaiban = ref<PartType[]>([])
const hasBrandPartForPaiban = ref(false)
// 补件库/待排版库参与排版的品牌小板，用于自定义大板顺序中品牌大板的匹配展示
const extraBrandPartsForPaiban = ref<PartType[]>([])
const getParticipationPartsForPaiban = async () => {
  const bujianData = await bujianTableRef.value?.analyzeLayoutToPaiban()
  bujianDataForPaiban.value = (bujianData?.plank_data ??
    []) as unknown as PartType[]
  // 来自柜柜的补件
  if (
    bujianDataForPaiban.value.some(
      (part) => part.colorId && (!part.brandName || !part.supplierName)
    )
  ) {
    await fetchAndSetBrandInfo(bujianDataForPaiban.value)
  }
  awaitStoreDataForPaiban.value =
    ((await awaitStoreRef.value?.getAwaitStorePlank()) ?? []) as PartType[]
  return {
    parts: [
      ...selectedParts.value,
      ...bujianDataForPaiban.value,
      ...awaitStoreDataForPaiban.value,
    ],
  }
}
const updateHasBrandPartForPaiban = (
  parts: PartType[],
  bujianData: PartType[],
  awaitStoreData: PartType[]
) => {
  hasBrandPartForPaiban.value = parts.some((part) => isBrandPart(part))
  extraBrandPartsForPaiban.value = [...bujianData, ...awaitStoreData].filter(
    (part) => isBrandPart(part)
  )
}
// 是否显示删除板件提示框框
const isShowDeletePartModal = ref(false)
// 删除板件状态
const isDeletePartLoading = ref(false)
// 打开删除板件弹窗
const handleOpenDeletePartModal = () => {
  try {
    if (selectedParts.value.length) {
      isShowDeletePartModal.value = true
      return
    }
    Vue.prototype.$message({
      message: translateLang('请先至少选中一个板件再进行此操作!'),
      type: 'error',
    })
  } catch (error) {
    console.log('获取勾选板件出错', error)
  }
}
// 确认删除
const handleConfirmDeletePart = () => {
  try {
    isDeletePartLoading.value = true
    handleDeletePart()
    isShowDeletePartModal.value = false
    Vue.prototype.$message({
      message: translateLang('删除成功'),
      type: 'success',
    })
  } catch (error) {
    console.log('删除板件出错', error)
  } finally {
    isDeletePartLoading.value = false
  }
}

const handleDeletePart = () => {
  buryPointApi('material', 'delete_plate')
  const newFilterPlankList = deletePart(
    filterPlankList.value,
    selectedParts.value
  )
  const newPlankList = deletePart(plankList.value, selectedParts.value)
  const storeOrderGroup = selectedParts.value.reduce(
    (res: any, item: PartType) => {
      const { orderId } = item
      if (!res[orderId]) {
        res[orderId] = 0
      }
      res[orderId]++
      return res
    },
    {}
  )
  Object.keys(storeOrderGroup).forEach((orderId) => {
    if (store.state.orderInfo.batch?.[orderId]) {
      store.commit(
        'setOrderInfo',
        Object.assign(store.state.orderInfo, {
          batch: {
            [orderId]:
              store.state.orderInfo.batch[orderId] - storeOrderGroup[orderId],
          },
        })
      )
    }
  })
  setFilterPlankList(newFilterPlankList)
  setPlankList(newPlankList)
}

// 删除所有的板件
const handleDeleteAllParts = () => {
  const allSelectedParts = getSelectedData(plankList.value)
  const newFilterPlankList = deletePart(filterPlankList.value, allSelectedParts)
  const newPlankList = deletePart(plankList.value, allSelectedParts)
  setFilterPlankList(newFilterPlankList)
  setPlankList(newPlankList)
  store.commit('setPreLayoutData', [])
}

// 删除板件
const deletePart = (plankList: PlankType[], parts: PartType[]) => {
  if (!parts || !parts.length) return plankList

  const hasSelectedPartIds = parts.map((part) => part.partUniqueId)

  const newPlankList = plankList
    .map((plank) => {
      const parts = plank.parts.filter(
        (part) => !hasSelectedPartIds.includes(part.partUniqueId)
      )
      return {
        ...plank,
        parts,
      }
    })
    .filter((plank) => plank.parts.length !== 0)
  return newPlankList as PlankType[]
}

/**
 * 复制板件
 */
const handleCopyLine = (part: PartType) => {
  try {
    // 获取所有的parts
    const allParts = getAllParts(plankList.value)
    const categoryKey = getMaterialCategoryKey(part)
    const plank = plankList.value.find(
      (category) => category.categoryKey === categoryKey
    )
    if (!plank) throw '未找到大板'
    let idx = plank.parts.findIndex(
      (it) => it.partUniqueId === part.partUniqueId
    )
    idx++
    // const newPart: Partial<PartType> = cloneDeep(part)
    const newPart: any = cloneDeep(part)
    // 删除标识板件的数据
    delete newPart.plankID
    delete newPart.simplePlankNum
    delete newPart.ggid
    // 复制板 清除骨骼门标识
    delete newPart.frame_door
    newPart.amount = 1
    const plankNum = uniquePlankNum.createUniquePlankNum()
    uniquePlankNum.plankNumCollect.clear()
    newPart.plankNum = plankNum
    newPart.oriPlankNum = plankNum
    newPart.plankID = generatePlankId(allParts)
    const partUniqueId = nanoid()
    newPart.partUniqueId = partUniqueId
    newPart.oriPartUniqueId = partUniqueId
    generateSimplePlankNum(newPart)
    plank.parts.splice(idx, 0, newPart as Required<PartType>)
    const newPlankList = dealFilterData(
      plankList.value,
      filterObj.value,
      searchCondition.value,
      specialRemarksForProcessLabel.value
    )
    if (part.isSelected) {
      // 说明是复制选中的板件，需要将新复制的板件的oriPartUniqueId添加到changeData中 也被勾选上
      changeData.value.push(newPart.oriPartUniqueId)
    }
    setFilterPlankList(newPlankList)
    const msg = translateLang('复制{name}数据成功', {
      name: part.partName,
    })
    Vue.prototype.$message({
      message: msg,
      type: 'success',
    })
  } catch (error) {
    console.log('复制板件失败', error)
  }
}

// 获取勾选的板件
const getSelectedData = (plankList: PlankType[]) => {
  return plankList
    .map((plank) => plank.parts.filter((part) => part.isSelected))
    .flat(1)
    .map((part) => {
      return {
        ...part,
        matCode: part.is_high_gloss_plank
          ? `高光_${part.matCode}`
          : part.matCode,
      }
    })
}

// 获取所有的板件
const getAllParts = (plankList: PlankType[]) => {
  const allParts = plankList
    ?.map((item) => {
      return item.parts.map((part) => {
        return {
          ...part,
          matCode: part.is_high_gloss_plank
            ? `高光_${part.matCode}`
            : part.matCode,
          sholes: part.sholes.map((hole) => {
            return {
              ...hole,
              side: Number(hole.side),
            }
          }),
          sslots: part.sslots.map((slot) => {
            return {
              ...slot,
              side: Number(slot.side),
            }
          }),
        }
      })
    })
    .flat(1)
  return allParts || []
}

// 排版页数据
const paibanData = computed(() => store.state.paibanData)

// 前往排版页
const handleGoPaiban = () => {
  buryPointApi('material', 'view_layout')
  router.push('/newPaiban')
}

/**
 * 下载样表，导出pdf
 *
 */
// 下载csv样表
const handleDownloadSample = (isNeedDeal = true) => {
  const { uniqueBarCode, genSimpleLabelBarcode } =
    storePreferencesSetting.value ?? {}

  isTaskLoading.value = true
  // 添加埋点
  if (isNeedDeal) {
    buryPointApi('material', 'download_sample')
  } else {
    buryPointApi('material', 'download_sample_science')
  }
  // 将数据处理成csv格式
  dealDownloadData(filterPlankList.value, isNeedDeal, {
    uniqueBarCode: !!uniqueBarCode,
    genSimpleLabelBarcode: !!genSimpleLabelBarcode,
  })
    .then((res) => {
      // 下载csv文件
      downloadCsvFile(res, orderInfo.value.order_address)
    })
    .catch((err) => {
      console.log('err', err)
      Vue.prototype.$message({
        message: '下载失败',
        type: 'error',
      })
    })
    .finally(() => {
      isTaskLoading.value = false
    })
}

const texDirMap = {
  reverse: '横纹',
  normal: '竖纹',
  notcare: '无纹理',
} as const

function expandPartsForDownload(
  parts: PartType[],
  options: DownloadBarCodeOptions
) {
  const { uniqueBarCode, genSimpleLabelBarcode } = options
  const expandedParts: PartType[] = []
  const idBaseParts = [...parts]
  uniquePlankNum.plankNumCollect.clear()

  parts.forEach((part) => {
    // 两个条码设置都未开启时，不平铺，保留原数据（含 amount）
    if (!uniqueBarCode && !genSimpleLabelBarcode) {
      expandedParts.push(part)
      return
    }

    if (genSimpleLabelBarcode) {
      // 生成简易条码
      const rowPart = { ...cloneDeep(part) } as PartType
      const { simplePlankNum } = generateSimplePlankNumFn(rowPart)
      rowPart.plankNum = simplePlankNum ?? rowPart.simplePlankNum
      expandedParts.push(rowPart)
      return
    }
    if (uniqueBarCode) {
      // 生成唯一条码
      const count = Math.max(1, Number(part.amount) || 1)
      for (let i = 0; i < count; i++) {
        const rowPart =
          count === 1
            ? ({ ...part, amount: 1 } as PartType)
            : ({ ...cloneDeep(part), amount: 1 } as PartType)
        if (count > 1) {
          // 第一行保留原条码
          if (i > 0) {
            const plankNum = uniquePlankNum.createUniquePlankNum()
            rowPart.plankNum = plankNum
            rowPart.oriPlankNum = plankNum
          }
        }
        expandedParts.push(rowPart)
      }
    }
  })
  if (uniqueBarCode) {
    // 只重新赋值重复的条码
    const seen = new Set<string>()
    expandedParts.forEach((part) => {
      if (part.plankNum && seen.has(part.plankNum)) {
        part.plankNum = uniquePlankNum.createUniquePlankNum()
        part.oriPlankNum = part.plankNum
      }
      seen.add(part.plankNum)
    })
  }

  uniquePlankNum.plankNumCollect.clear()

  return expandedParts
}

function buildPartDownloadRow(
  part: PartType,
  customHead: Array<string | undefined>,
  needSaveData: IPropList[]
) {
  const row: string[] = []
  customHead.forEach((item) => {
    if (!item) return
    const headerProp = needSaveData.find((it) => it.customLabel === item)?.prop
    if (!headerProp) return
    let headerValue = part[headerProp as keyof PartType]
    headerValue = headerValue ? headerValue : ''
    if (typeof headerValue === 'number' || typeof headerValue === 'string') {
      headerValue = headerValue.toString().replaceAll('\n', '')
    }
    if (headerProp === 'texDir') {
      row.push(translateLang(texDirMap[part[headerProp]]))
    } else if (headerProp === 'specWidth' || headerProp === 'specHeight') {
      if (part.texDir === 'reverse') {
        row.push(
          part[
            headerProp === 'specHeight' ? 'specWidth' : 'specHeight'
          ].toString()
        )
      } else {
        row.push(part[headerProp].toString())
      }
    } else if (headerProp === 'specialShape') {
      row.push(
        part[headerProp] ? translateLang('异形') : translateLang('非异形')
      )
    } else if (headerProp === 'type') {
      row.push(
        part[headerProp] === 'Plank'
          ? translateLang('非门板')
          : translateLang('门板')
      )
    } else if (headerProp === 'is_high_gloss_plank') {
      row.push(
        part[headerProp]
          ? matchHighlightBoardName(part.matCode)
          : `非${matchHighlightBoardName(part.matCode)}`
      )
    } else if (headerProp.includes('Edge')) {
      const theEdge = (part[headerProp as keyof PartType] as string) || '0'
      if (part.edgePreMillingInfo?.width) {
        row.push(`${theEdge}(${part.edgePreMillingInfo.width})`)
      } else {
        row.push(theEdge)
      }
    } else if (headerProp === 'hingeInfo') {
      row.push(showMaterialHingeinfo(part))
    } else if (headerProp === 'process_label') {
      row.push(processLabelFn(part, specialRemarksForProcessLabel.value))
    } else if (headerProp === 'textureGrainInfo') {
      row.push(part.textureGrainInfo?.groupName ?? '')
    } else {
      row.push(headerValue.toString())
    }
  })
  return row
}

// 处理需要下载的数据
const dealDownloadData = (
  plankList: PlankType[],
  isNeedDeal = true,
  barCodeOptions: DownloadBarCodeOptions = {}
) => {
  return new Promise<string[][]>((resolve) => {
    // 初始化表头
    const downloadData: string[][] = []
    const needSaveData = storePreferencesSetting.value
      ?.needSaveData as IPropList[]
    const customHead = needSaveData
      ?.filter((item) => item.prop && item.prop !== 'select')
      .map((item) => item.customLabel)
    downloadData[0] = customHead.map((item) => {
      return vm?.proxy.$t(item!) as string
    })
    const flatParts = plankList.map((plank) => plank.parts).flat(1)
    const partsToExport = expandPartsForDownload(flatParts, barCodeOptions)
    partsToExport.forEach((part) => {
      downloadData.push(buildPartDownloadRow(part, customHead, needSaveData))
    })
    const result = downloadData.map((item) => {
      return item.map((itemData) => {
        if (typeof itemData === 'string') {
          itemData = itemData.replaceAll('\n', '')
        }
        // 判断大于十位的字符串数字是否需要加制表符，不加的话，在excel中会被转为科学计数
        if (
          typeof itemData === 'string' &&
          !isNaN(Number(itemData)) &&
          itemData.length >= 10 &&
          isNeedDeal
        ) {
          itemData = `\t${itemData}`
        }
        // 含横杠且两侧为数字的编码（如 6105-7），Excel 打开 CSV 时会误判为日期
        if (typeof itemData === 'string' && /^\d+-\d+$/.test(itemData)) {
          itemData = `\t${itemData}`
        }
        return itemData
      })
    })
    resolve(result)
  })
}

// 是否正在导出孔槽图
const isExportHoleSlotPdf = ref(false)
const isExportHoleSlotDxf = ref(false)

// 导出孔槽图
const handleExportHoleSlotPdf = (
  type: 'common' | 'threeView',
  isOther?: 'other'
) => {
  // 判断是否有板件
  if (filterPlankList.value.length === 0) {
    Vue.prototype.$message({
      message: translateLang('暂无板件,无法进行导出'),
      type: 'warning',
    })
    return
  }

  const allParts = filterPlankList.value.map((plank) => plank.parts).flat(1)
  buryPoint({
    function_module: 'material',
    function_point: 'export_hole_grove',
  })
  switch (type) {
    // 导出一三样式孔槽图
    case 'common':
      exportHoleSlotPdf(allParts, isOther)
      break
    // 导出三视图
    case 'threeView':
      exportThreeView(allParts)
      break
  }
}

// 导出样式一，三
const exportHoleSlotPdf = async (data: PartType[], isOther?: 'other') => {
  try {
    // 加载字体文件
    await jsPdfTool.loadFont('msyh', 'zh', 'normal')
    // 创建一个用于创建孔槽pdf的实例
    const drawInstance = new GenerateHoleSlotPdf('landscape')
    let index = 0
    isExportHoleSlotPdf.value = true
    data.forEach((part, index) => {
      drawInstance.generate(part, isOther)
      drawInstance.pdf.addPage()
      if (index === data.length - 1) {
        // 删除多余页数
        drawInstance.pdf.deletePage(drawInstance.pdf.getNumberOfPages())
        drawInstance.save(
          orderInfo.value.order_address || new Date().toLocaleString()
        )
      }
    })
  } catch (error) {
    console.log(error)
    Vue.prototype.$message({
      message: translateLang('导出板件孔槽图时遇到未知错误，请联系我们解决'),
      type: 'error',
    })
  } finally {
    isExportHoleSlotPdf.value = false
  }
  // const createdPdfTask: IdleRequestCallback = (deadline) => {
  //   console.log('deadline', deadline.timeRemaining())
  //   if (deadline.timeRemaining() <= 10) {
  //     requestIdleCallback(createdPdfTask)
  //   } else {
  //     if (index <= data.length - 1) {
  //       const part = data[index]
  //       // 绘制孔槽图
  //       drawInstance.generate(part, isOther)
  //       drawInstance.pdf.addPage()
  //       index++
  //       requestIdleCallback(createdPdfTask)
  //     } else {
  //       drawInstance.pdf.save('孔槽图.pdf')
  //       isExportHoleSlotPdf.value = false
  //     }
  //   }
  // }
  // // 使用requestIdleCallback,处理下载时，页面卡顿的问题
  // requestIdleCallback(createdPdfTask)
}

// 导出三视图(样式二)
const exportThreeView = async (data: PartType[]) => {
  buryPointApi('material', 'plank_hole_slot_three_views')
  // 加载字体
  await jsPdfTool.loadFont('msyh', 'zh', 'normal')
  try {
    // 创建一个用于绘制三视图的实例
    const drawView = new DrawPartView()
    data.forEach((part, idx) => {
      const tableInfo = {
        date: ' ',
        version: ' ',
        modifiedCount: '',
        designer: ' ',
        size: `${Number(part.oRect.width).toFixed(1)}*${Number(
          part.oRect.height
        ).toFixed(1)}*${Number(part.thick).toFixed(1)}`,
        pic: ' ',
        matCode: part.matCode,
        check: ' ',
        color: part.texture,
        count: part.amount.toString(),
        percent: ' ',
        approval: ' ',
        index: idx + 1,
        total: data.length,
        plankNum: part.plankNum,
        orderNo: part.orderNo,
        partName: part.partName,
        proCount: ' ',
      }
      const newPart = cloneDeep(part)
      // 强制 180 度旋转，主要是部分用户觉得我们的槽位置不对，产品要求 180 度旋转
      rotate180Part(newPart)
      if (part.specWidth < part.specHeight) {
        // FIXE: 旋转板件，需要修改原方法，不应该直接修改原数据
        rotatePart(newPart)
      }
      drawView.drawThreeView(newPart, () => {
        drawView.drawInfoTable(tableInfo)
      })
      drawView.pdf.addPage()
    })
    // 删除尾页
    drawView.pdf.deletePage(drawView.pdf.getNumberOfPages())
    drawView.save(`${orderInfo.value.order_address}-三视图`)
  } catch (error) {
    console.log(error)
    Vue.prototype.$message({
      message: translateLang('导出孔槽三视图失败,请联系售后处理'),
      type: 'error',
    })
  }
}

const handleExportHoleSlotDxf = (
  type: 'common' | 'threeView',
  isOther?: 'other'
) => {
  const hasPermission = checkUserPermissionWithToast(
    USER_PERMISSION_KEY.EXPORT_THE_STYLE_TWO_HOLE_SLOT_DIAGRAM_DXF,
    translateLang('该功能为付费功能，请联系销售开通后使用~')
  )
  if (!hasPermission) {
    return
  }

  if (filterPlankList.value.length === 0) {
    Vue.prototype.$message({
      message: translateLang('暂无板件,无法进行导出'),
      type: 'warning',
    })
    return
  }

  const allParts = filterPlankList.value.map((plank) => plank.parts).flat(1)
  buryPoint({
    function_module: 'material',
    function_point: 'export_hole_grove_dxf',
  })
  isExportHoleSlotDxf.value = true
  try {
    switch (type) {
      case 'common':
        exportHoleSlotDxf(
          allParts,
          isOther,
          `${orderInfo.value.order_address}-孔槽图DXF`
        )
        break
      case 'threeView':
        exportThreeViewDxf(
          allParts,
          undefined,
          `${orderInfo.value.order_address}-三视图DXF`
        )
        break
    }
  } catch (error) {
    console.log(error)
    Vue.prototype.$message({
      message: translateLang('导出板件孔槽图时遇到未知错误，请联系我们解决'),
      type: 'error',
    })
  } finally {
    isExportHoleSlotDxf.value = false
  }
}

/**
 *
 */
// 自定义表头组件实例
const customTableHeaderModalRef = ref<InstanceType<
  typeof CustomizeTableHeader
> | null>(null)
// 打开设置开料清单表头
const handleSettingTableHeader = () => {
  // 打开弹窗
  customTableHeaderModalRef.value?.openModal()
  // 启动sortable
  customTableHeaderModalRef.value?.showEditTableHeader()
  buryPointApi('material', 'set_tableHead')
}

// 确定修改开料清单表头数据，需要清空筛选条件
const handleConfirmChangeTableHeader = () => {
  searchCondition.value.searchKey = ''
  searchCondition.value.minSize = ''
  searchCondition.value.maxSize = ''
  filterObj.value = {}
  const newPlankList = dealFilterData(
    plankList.value,
    undefined,
    undefined,
    specialRemarksForProcessLabel.value
  )
  setFilterPlankList(newPlankList)

  // 判断当前表头是否保存过
  if (!currentPreferenceSetting.value.savedHightLightProp) {
    // 之前没保存过，需要保存
    savePreferences({ target: { checked: true } } as any, 'saveHighLightHeader')
  }
  // 表头使用数据埋点
  currentHeadPropList.value.forEach((item) => {
    if (item.prop != 'select') buryPointApi('material', `head_${item.prop}`)
  })
}

/**
 * 板件筛选
 *
 */
// 搜索条件
const searchCondition = ref<{
  searchKey: string
  minSize: string | number
  maxSize: string | number
  searchKeyType: string
}>({
  searchKey: '',
  minSize: '',
  maxSize: '',
  searchKeyType: 'address',
})
// 尺寸筛选
const handleChangeSize = () => {
  const { minSize, maxSize, searchKey } = searchCondition.value
  const newMinSize = Number(minSize)
  const newMaxSize = Number(maxSize)
  if (searchKey) {
    searchCondition.value.searchKey = ''
  }
  try {
    if (
      ((newMinSize || newMinSize >= 0) &&
        newMaxSize &&
        newMinSize <= newMaxSize) ||
      (minSize === '' && maxSize === '')
    ) {
      // isTaskLoading.value = true
      const newPlankList = dealFilterData(
        plankList.value,
        filterObj.value,
        searchCondition.value,
        specialRemarksForProcessLabel.value
      )
      setFilterPlankList(newPlankList)
      buryPointApi('material', 'plank_size_filter')
    }
  } catch (error) {
    console.log('尺寸筛选出错')
  } finally {
    // TODO: 使用定时器看效果
    // setTimeout(() => {
    //   isTaskLoading.value = false
    // }, 2000)
  }
}

// 使用节流优化尺寸筛选
const throttleChangeSize = debounce(handleChangeSize, 1000)
const searchOptionsList = ref([
  {
    label: '项目地址',
    value: 'address',
  },
  {
    label: '板件名称',
    value: 'partName',
  },
  {
    label: '板号',
    value: 'plankID',
  },
  {
    label: '板件条码',
    value: 'plankNum',
  },
  {
    label: '订单备注',
    value: 'order_remark',
  },
  {
    label: '房间备注',
    value: 'remark',
  },
  {
    label: '板件备注',
    value: 'plank_remarks',
  },
  {
    label: '特殊工艺',
    value: 'process_label',
  },
])

function syncSearchOptionsListCustomLabels() {
  searchOptionsList.value = searchOptionsList.value.map((item) => {
    const customLabel = storePreferencesSetting.value?.needSaveData?.find(
      (needItem) => needItem.prop === item.value
    )?.customLabel
    return {
      ...item,
      customLabel,
    }
  })
}

watch(
  () => storePreferencesSetting.value?.needSaveData,
  () => {
    syncSearchOptionsListCustomLabels()
  },
  { deep: true }
)

let currentSearchKeyType = computed(() => {
  return searchOptionsList.value.find(
    (item) => item.value === searchCondition.value.searchKeyType
  )
})
const handleChangeSearchKeyType = () => {
  // 清空搜索值
  searchCondition.value.searchKey = ''
  handleSearchKeyword()
  updateLocalPreference({
    searchKeyType: searchCondition.value.searchKeyType,
  } as any)
}
// 板件板号搜索
const handleSearchKeyword = () => {
  try {
    // isTaskLoading.value = true
    const { minSize, maxSize, searchKey } = searchCondition.value
    _hmt.push(['_trackEvent', '料单板件搜索', 'click', searchKey])
    // 与尺寸搜索条件互斥
    if (minSize || maxSize) {
      searchCondition.value.maxSize = ''
      searchCondition.value.minSize = ''
    }
    const newPlankList = dealFilterData(
      plankList.value,
      filterObj.value,
      searchCondition.value,
      specialRemarksForProcessLabel.value
    )
    setFilterPlankList(newPlankList)
    buryPointApi('material', 'plank_search')
  } catch (error) {
    console.log('板件搜索出错', error)
  } finally {
    // setTimeout(() => {
    //   isTaskLoading.value = false
    // }, 1000)
  }
}

/**
 * 保存历史
 *
 */

// 控制保存历史弹窗的显示
const isShowSaveHistoryModal = ref(false)
// 自定义输入保存历史名称
const historyName = ref('')
// 打开保存至历史弹窗
const handleOPenSaveHistoryModal = () => {
  if (!plankList.value.length) {
    Vue.prototype.$message({
      message: translateLang('没有可以保存的信息') + '!',
      type: 'error',
    })
    return
  }
  historyName.value = `${translateLang('历史方案')} ${splitTime()}`
  isShowSaveHistoryModal.value = true
}
// 保存历史的状态
const isSavePaiBanLoading = ref(false)
// 保存至历史
const handleSaveHistory = () => {
  isSavePaiBanLoading.value = true
  const { obj, name } = ossFilesParams.value
  _hmt.push(['_trackEvent', '保存历史', 'click'])
  buryPointApi('material', 'save_history')
  const rawObj = toRaw(obj)
  ossUploadFiles(
    rawObj,
    name,
    (url: string) => {
      saveMaterialPaiban(url, 0)
      isSavePaiBanLoading.value = false
      isShowSaveHistoryModal.value = false
    },
    () => {
      isSavePaiBanLoading.value = false
    }
  )
}

const saveMaterialPaiban = async (
  url: string,
  autoSave: 0 | 1,
  isNcFile?: string
) => {
  let normalParams = {
    used_rate: '',
    order_codes: '',
  }
  const process_setting_id = selectProLine.value.id
  let file_type = 'paiban'
  let order_list = []
  const isElectric =
    proLineList.value.find((item) => process_setting_id === item.id)?.data
      ?.cuttingEquipment === 'electronicSaw'
  if (!isElectric) {
    normalParams = {
      used_rate: '',
      order_codes: orderInfo.value.order_codes
        ? orderInfo.value.order_codes
        : '',
    }
    file_type = 'material'
    order_list = orderInfo.value.order_ids
      ? orderInfo.value.order_ids.split(',').map(Number)
      : []
  }
  const state = paibanSettingState.value
  /** 时间戳加在 filterObj 文件名 */
  const fileName = `filterObj_${new Date().getTime()}`
  const path = 'cloud_paiban/filterObj'
  const filterObjUrl = await saveDataToOSS(filterObj.value, fileName, path)

  const obj: any = {
    name: historyName.value,
    plank_info: {
      plankTypeList: null,
      historyUrl: url,
      ...normalParams,
      filterObj: filterObjUrl,
      process_setting_name:
        state && state.isPreLayout
          ? '预排版方案'
          : autoSave
          ? selectProLine.value.name
          : '',
    },
    process_setting_id: autoSave ? process_setting_id : -1,
    order_list,
    file_type,
    save_node: 1,
    auto_save: autoSave,
    room_ids: '',
  }
  if (isNcFile) {
    obj.plank_info.isNcFile = isNcFile
    // 历史方案名称
    let name = `${historyName.value}_FromWebPage_生产线(${
      selectProLine.value?.name ?? ''
    })`
    obj.name = name
  }
  if (
    orderInfo.value.needPaibanRoomIds &&
    orderInfo.value.needPaibanRoomIds.length > 0
  ) {
    obj.room_ids = orderInfo.value.needPaibanRoomIds
  }
  try {
    const res = await saveHistory(obj)
    if (res.status == 1) {
      if (!obj.auto_save) {
        Vue.prototype.$message({
          message: translateLang('保存成功!'),
          type: 'success',
        })
      }
    } else {
      Vue.prototype.$message({
        message: res.message,
        type: 'error',
      })
    }
  } finally {
    isConfirmLoading.value = false
    showSaveDialog.value = false
  }
}

// 已勾选的板件
const recodeSelectPart = computed(() => store.state.recordSelectPart)
// 已勾选的余料
const selectedSurplus = computed(() => store.state.recodeSelectSurplus)
const ncSetting = computed<INcSettingType>(() => store.state.ncSetting)
// oss服务器参数
const ossFilesParams = computed(() => {
  // 这里调用setPlankList是因为在排序的时候，filterPlankList.value会发生变化，但是plankList.value不会变化，所以需要调用setPlankList来更新plankList.value
  // 并且排序要在保存的时机才去修改plankList.value 不然排序会无法回到最开始的无序状态
  // 这里需要修改filterplankList中的小板的oriTexture， 因为使用了混排时，在开料清单中小板的oriTexture的值是定义的颜色（这个是为了开料清单中的展示）
  const newFilterPlankList = filterPlankList.value.map((plank) => {
    return {
      ...plank,
      parts: plank.parts.map((part) => {
        return {
          ...part,
          oriTexture: part.texture,
        }
      }),
    }
  })
  setPlankList(newFilterPlankList)
  const obj = {
    layoutData: getAllParts(plankList.value),
    paibanData: [],
    recodeSelectPart: recodeSelectPart.value,
    recodeSelectSurplus: selectedSurplus.value,
    thinkerxMaterialKeys: store.state.thinkerxMaterialKeys,
    filterPlankList: toRaw(filterPlankList.value),
    process_setting_id: 0,
    process_setting_name: '',
    sampleFormData: {},
  }
  if (paibanData.value.length > 0 && !ncSetting.value.isPreLayout) {
    obj.process_setting_id = ncSetting.value.process_setting_id ?? -1
    obj.process_setting_name = ncSetting.value.process_setting_name
    const isElec = selectProLine.value.data.cuttingEquipment === 'electronicSaw'
    !isElec && (obj.paibanData = paibanData.value)
  }
  if (isShowSample.value) {
    obj.sampleFormData = store.state.sampleTableData.value
  }

  return { name: historyName.value, obj }
})

/**
 * 待排版库相关操作
 *
 */
const isShowAddAWaitStoreDialog = ref(false) // 是否显示待排版库添加弹窗
const isAddAwaitStoreLoading = ref(false) // 是否正在添加
const awaitStoreRef = ref<InstanceType<typeof MAwaitPaibanStore> | null>(null)
/** 打开存入待排版库弹窗 */
const handleOpenPushStoreDialog = () => {
  if (!selectedParts.value?.length)
    return Vue.prototype.$message({
      message: translateLang('请至少选择一块板件'),
      type: 'warning',
    })
  isShowAddAWaitStoreDialog.value = true
}
/** 存储板件到待排版库 */
const handleStorageToAwaitStore = async () => {
  isAddAwaitStoreLoading.value = true
  const storeData = await getPlankToAwaitStoreData(
    selectedParts.value,
    undefined,
    false
  )
  if (!storeData) return
  const result = await addPlankToStore(storeData)
  isAddAwaitStoreLoading.value = false
  isShowAddAWaitStoreDialog.value = false
  if (result.status !== 1)
    return Vue.prototype.$message({
      message: result.msg || translateLang('出现未知错误，入库失败'),
      type: 'error',
    })
  Vue.prototype.$message({
    message: translateLang('入库成功'),
    type: 'success',
  })
  // 入库完成后将原始数据中的板件删除
  handleDeletePart()
  // 完成入库重新请求新的待排版库数据
  await store.dispatch('awaitPaibanStore/getServePlankData')
  // 重新匹配新的板件
  awaitStoreRef.value?.getAwaitStoreList()
  buryPointApi({
    function_module: 'await_store',
    function_point: 'batch_push_store',
  })
}
/**
 * 余料相关操作
 *
 */
const isShowSurplusList = computed(() => store.state.isShowSurplusList)
// 记录匹配到的余料的数量信息
const surplusInfo = computed(() => {
  const surplusInfo = {
    surplusNum: 0,
    selectedSurplusNum: 0,
  }
  surplusInfo.selectedSurplusNum = surplusList.value.filter(
    (sur) => sur.isSelected
  ).length
  surplusInfo.surplusNum = surplusList.value.length
  return surplusInfo
})
// 获取有自定义修边的余料
const isCustomSurplusEdge = computed(() => {
  // && sur?.surplus_trim_edge.includes(',')
  return (
    surplusList.value.some((sur) => sur.isSelected && sur?.surplus_trim_edge) ||
    (storePreferencesSetting.value?.surplus_trim_data?.isCustomTrim &&
      storePreferencesSetting.value?.surplus_trim_data?.trimmingMethod ===
        'custom')
  )
})
// 记录匹配到的余料数据
const surplusList = ref<ISurplusType[]>([])
const surplusListRef = ref<HTMLElement | null>(null)
let surplusSortable: Sortable | null = null

function destroySurplusSortable() {
  if (!surplusSortable) return
  surplusSortable.destroy()
  surplusSortable = null
}

/** 余料列表行拖拽排序，同步更新 surplusList 顺序 */
function initSurplusSortable(force = false) {
  nextTick(() => {
    const el = surplusListRef.value
    if (!el || !surplusList.value.length) {
      destroySurplusSortable()
      return
    }
    // 已绑定同一容器时不重复创建，避免 destroy 后全局残留 null 实例触发报错
    if (!force && surplusSortable && surplusSortable.el === el) {
      return
    }
    destroySurplusSortable()
    surplusSortable = Sortable.create(el, {
      animation: 150,
      handle: '.surplus-drag-handle',
      draggable: '.surplus-row',
      // 关闭空列表插入检测，避免已销毁实例 options 为 null 时报错
      emptyInsertThreshold: 0,
      ghostClass: 'surplus-drag-ghost',
      chosenClass: 'surplus-drag-chosen',
      dragClass: 'surplus-drag-active',
      onEnd(evt) {
        const { oldIndex, newIndex } = evt
        if (oldIndex == null || newIndex == null || oldIndex === newIndex) {
          return
        }
        const [moved] = surplusList.value.splice(oldIndex, 1)
        surplusList.value.splice(newIndex, 0, moved)
        buryPointApi('material', 'drag_sort')
      },
    })
  })
}

watch([isShowSurplusList, () => surplusList.value.length], ([show, len]) => {
  if (show && len > 0) {
    initSurplusSortable()
  } else {
    destroySurplusSortable()
  }
})

onBeforeUnmount(() => {
  destroySurplusSortable()
})

// 添加余料（跳转到余料仓）
const handleAddNewSurplus = () => {
  router.push({
    path: '/supplusStorage',
    query: {
      isNeedSurplus: '1',
    },
  })
}

// 当前是否勾选了全选余料
const isSelectedAllSurplus = ref(true)
// 获取余料
const getSurplusList = async () => {
  try {
    // 未开启了余料大板显示，则返回一个空数组
    if (!currentPreferenceSetting.value.isSurplusRecommend) {
      surplusList.value = []
      // throw new Error('未开启余料大板显示')
      return
    }
    /** @description 添加不同的搜索材质 */
    const appendMatchList = (
      matchList: any[],
      plank: any,
      color: string,
      thick = plank.thick
    ) => {
      getSurplusMatchTypes(plank.high_plank, plank.matCode).forEach((type) => {
        matchList.push({
          type,
          thick,
          color,
        })
      })
    }

    // 将处理完的数据, 获取其分类进行余料的匹配
    let match_list: any[] = []
    filterPlankList.value.forEach((plank) => {
      appendMatchList(match_list, plank, plank.texture)
    })
    if (selectedMixPaibanPlans.value.length) {
      filterPlankList.value.forEach((plank) => {
        const plan = selectedMixPaibanPlans.value.find((plan) =>
          matchMixPaibanPlan(plan, plank)
        )
        if (plan) {
          if (
            plank.isAllSelect ||
            plank.parts.some((part) => part.isSelected)
          ) {
            appendMatchList(
              match_list,
              plank,
              plan.targetTexture,
              Number(plank.thick)
            )
            plan.originTexture.forEach((color) => {
              appendMatchList(match_list, plank, color, Number(plank.thick))
            })
          }
        }
      })
    }

    const params = {
      match_list,
      limit: 9999,
    }

    // 获取余料列表
    const res = await getSurplusListApi(params)
    if (res.status == 1) {
      let dataList = res.data.data
      for (let k = 0; k < dataList.length; ++k) {
        dataList[k].isSelected = isSelectedAllSurplus.value
        dataList[k].showAmount = dataList[k].amount
      }
      if (surplusList.value.length) {
        // 表示不是第一次赋值，那就有可能用户做了一些勾选以及取消勾选操作，
        // 即当前isSelectedAllSurplus.value为false，不能一一赋值给余料列表
        // 要保留用户勾选的 不然就会出现 排版明明勾选了余料但是却未使用
        dataList.forEach((item) => {
          const surplus = surplusList.value.find((sur) => sur.id === item.id)
          if (surplus) {
            item.isSelected = surplus.isSelected
          }
        })
      }
      /** @description 余料的名称需要是直接用[高光_]避免后续匹配不到，显示才用柜柜配置的别名 */
      const normalizeSurplusType = (type: string) => {
        if (!type || type.includes('高光_') || !type.includes('_')) {
          return type
        }
        const matCode = type.split('_').slice(1).join('_')
        const aliasType = dealHighlightMatCode(`高光_${matCode}`)
        if (aliasType === type) {
          return `高光_${matCode}`
        }
        return type
      }
      surplusList.value = dataList.map((item) => ({
        ...item,
        type: normalizeSurplusType(item.type),
        create_time: item.create_time.split(' ')[0],
        branch_name: item.branch_name || '-',
        is_high_gloss_plank: normalizeSurplusType(item.type)?.includes('高光_')
          ? true
          : false,
        from_address: item.from_address,
        from_order_num: item.from_order_num,
      }))

      // 处理余料排序（按照长度排序由短到长）
      surplusList.value = surplusList.value.sort((a, b) => {
        return a.long - b.long
      })

      handleSurplusLockShow()
      if (isShowSurplusList.value && surplusList.value.length) {
        initSurplusSortable(true)
      }
    }
  } catch (error) {
    console.log('获取余料出错', error)
  }
}
// 开启余料锁定 余料展示相关处理
const handleSurplusLockShow = () => {
  if (preferencesSetting.value.surplus_lock) {
    // 非本订单锁定余料不展示在开料清单
    const orderAddress = orderInfo.value.order_address.replace(
      /\(.*?\)|历史记录/g,
      ''
    )
    surplusList.value = surplusList.value
      .filter(
        (item) =>
          item.lock_status == 0 ||
          (item.lock_status &&
            item.lock_order &&
            item.lock_order == orderAddress)
      )
      .map((item) => ({
        ...item,
        lock_order: orderAddress,
      }))
    // 获取排版页使用的余料id
    let useSurplusId = paibanData.value
      .map(
        (item: any) => !item.surplusInfo?.isNotSurplus && item.surplusInfo?.id
      )
      .filter((id: number) => id)
    if (!useSurplusId.length) {
      // 兼容 当排版页未使用余料时，使用开料清单选中的余料
      useSurplusId = surplusList.value
        .filter((item) => item.isSelected)
        .map((item) => item.id)
    }

    useSurplusId = Array.from(new Set(useSurplusId))
    // 勾选排版方案使用的余料
    isSelectedAllSurplus.value = useSurplusId.length == surplusList.value.length
    surplusList.value.forEach((item) => {
      item.isSelected = useSurplusId.includes(item.id)
    })
  }
}

// 选中单个余料
const handleSelectSurplus = () => {
  recordSelectSurplus()
  if (selectedSurplus.value.selects.length === surplusList.value.length) {
    isSelectedAllSurplus.value = true
  } else {
    isSelectedAllSurplus.value = false
  }
}
// 选中所有的余料
const handleSelectAllSurplus = () => {
  surplusList.value.forEach((sur) => {
    sur.isSelected = isSelectedAllSurplus.value
    // dealSurplusPathByTrimSide(sur, ncSetting.value)
  })
  recordSelectSurplus()
}

// 记录选中的余料
const recordSelectSurplus = () => {
  const selects: number[] = []
  surplusList.value.forEach((sur) => {
    if (sur.isSelected) {
      sur.showAmount = sur.showAmount ? sur.showAmount : 0
      selects.push(sur.id)
    }
  })
  store.commit('setRecodeSelectSurplus', { selects, isHistory: false })
}

// 监听filterPlankList,修改后去获取余料
watchEffect(() => {
  if (filterPlankList.value.length) {
    getSurplusList()
  }
})

// 修改余料数量时，限制最大值
const checkSurplusNum = (
  e: ChangeEvent<HTMLInputElement>,
  surplus: ISurplusType
) => {
  const { value } = e?.target
  surplus.showAmount = value ?? surplus.amount
}
// 修改余料列表展开收起状态
const onChangeIsShowSurplusList = (payload?: boolean) => {
  store.commit('onChangeIsShowSurplusList', isShowSurplusList.value)
}

const surplusCellRefs = ref<HTMLDivElement[] | null>(null)

/**
 * 补件相关操作
 */

// 筛选出补件的板件FIX
const handleBujianPlanks = (bujianArr: Array<Array<PartType>>) => {
  // 记录板件数量，因为有相同ggid重复补件
  let rec: Record<string, number> = {}
  let arr: PartType[] = []
  for (let i = 0; i < bujianArr.length; i++) {
    for (let j in orderInfo.value.bujianPlankId) {
      if (bujianArr[i][0].roomID == Number(j)) {
        const plankArr: PartType[] = []
        bujianArr[i].forEach((e: any) => {
          const bujianPlankArr = orderInfo.value.bujianPlankId[j].filter(
            (item: any) => {
              if (
                e.plankID == item.plankId &&
                dealGGid(e.ggid) == dealGGid(item.ggid)
              ) {
                if (rec.hasOwnProperty(dealGGid(item.ggid))) {
                  rec[dealGGid(item.ggid)] += 1
                } else {
                  rec[dealGGid(item.ggid)] = 1
                }
                return true
              }
            }
          )
          if (bujianPlankArr.length) {
            plankArr.push({
              ...e,
              _bujianAddress: bujianPlankArr[0].address,
              _bujianOid: bujianPlankArr[0].oid,
              _bujianOrderNo: bujianPlankArr[0].orderNo,
              _bujianPlankNum: bujianPlankArr[0].plankNum,
              _bujianCustomerName: bujianPlankArr[0].customerName,
            })
          }
        })
        const newPlankArr = plankArr.map((item) => {
          // 增加补件标注
          return {
            ...item,
            _bujianAddress: item._bujianAddress,
            _bujianOid: item._bujianOid,
            _bujianOrderNo: item._bujianOrderNo,
            _isBujian: true,
            _bujianPlankNum: item._bujianPlankNum,
            _bujianCustomerName: item._bujianCustomerName,
            plankNum: item._bujianPlankNum as string,
          }
        })
        arr = arr.concat(newPlankArr)
      }
    }
  }
  arr = arr.map((item) => {
    return {
      ...item,
      amount: rec[dealGGid(item.ggid)],
    }
  })
  return arr
}

// 对ggid做处理
const dealGGid = (ggid: string) => {
  let finalGgid = ggid.split('/').pop()!
  if (String(finalGgid).startsWith('÷')) finalGgid = finalGgid?.substr(1)

  if (String(finalGgid).length > 8) {
    finalGgid = String(finalGgid).slice(0, -2)
  }
  return finalGgid
}

/**
 * 料单数据展示
 */

// 展示空数据
const emptyShow = ref(false)

// 显示样表
const isShowSample = computed(() => store.state.isShowSample)

// 样表表头数据
const samPleFormData = ref<SamPleFormDataType>({
  address: '',
  clientData: '',
  factoryOrderNum: '',
  roomName: '',
  orderRemark: '',
})

// 样表配置项
const samPleConfig = ref({ ...defaultSampleConfig })

// 判断开料清单数据是否为空
const isTableEmpty = ref(false)

//筛选条件
const filterObj = computed<Partial<Record<IFilterableFieldsType, string[]>>>({
  set(target) {
    store.commit('setFilterObject', target)
  },
  // 筛选条件
  get() {
    if (
      store.state.filterObject &&
      Object.keys(store.state.filterObject).length
    ) {
      dealPlankListForcomputed()
    }
    return store.state.filterObject
  },
})

const dealPlankListForcomputed = () => {
  const newPlankList = dealFilterData(
    plankList.value,
    store.state.filterObject,
    searchCondition.value,
    specialRemarksForProcessLabel.value
  )
  setFilterPlankList(newPlankList)
}

// 料单表格宽度
const virtualHeadRowWidth = ref(0)
// 获取料单表格宽度
const handleGetTableWidth = (width: number) => {
  virtualHeadRowWidth.value = width
}

/**
 * 添加板件操作
 */
// 需要回显的数据
const needReviewData = computed(() => store.state.needReviewData)
// 添加板件校验成功后的回调，用于对新添加的板件进行保存
const confirmAddPart = async () => {
  const newPart = addPart(newPlankInfo.value as Required<PartType>)
  // 将数据保存到本地的local中
  // localStorage.setItem('preBoard', JSON.stringify(newPart))
  // 避免用户退出登录后登录另一个账号还回显同样的内容，将数据改存到session中
  sessionStorage.setItem('preBoard', JSON.stringify(newPart))
  // 添加成功
  Message({
    message: `<span id="material_save_success">${translateLang(
      '添加成功'
    )}!</span>`,
    type: 'success',
    dangerouslyUseHTMLString: true,
  })

  initData([newPart], {
    isLoadMore: true,
    isClearHSInfo: false,
    isToggle: false,
  })
}

// 打开弹窗时的额外操作
const openModal = () => {
  // 原来的逻辑存在板件颜色和材质的回显，但是保存并继续的时候没有回显，所以还是需要在这里赋值一下，后面的重新赋值不管
  // 定义需要的字段的默认值 不需要回显的时候把字段删掉就好了
  const defaultBoardInfo = {
    partName: '', //板件名称
    matCode: '', // 材质
    is_high_gloss_plank: false, // 高光板
    texture: '', // 颜色
    thick: '', // 厚度
    texDir: 'normal', // 纹理
    specHeight: null, // 成品长度
    specWidth: null, // 成品宽度
    plank_remarks: '', // 板件备注
  } as any

  // 从 localStorage 获取数据
  // const preBoard = JSON.parse(localStorage.getItem('preBoard') || '{}')
  const preBoard = JSON.parse(sessionStorage.getItem('preBoard') || '{}')
  const edges = ['frontEdge', 'backEdge', 'leftEdge', 'rightEdge']
  // preBoard 存在边距数据才赋值
  if (preBoard) {
    edges.forEach((edge) => {
      if (preBoard[edge] !== 0) {
        defaultBoardInfo[edge] = ''
      }
    })
  }
  // 显式提取需要的字段，避免污染
  const EchoBoard = Object.keys(defaultBoardInfo).reduce((acc: any, key) => {
    acc[key] = preBoard[key] ?? defaultBoardInfo[key]
    return acc
  }, {})

  // 合并到 newPlankInfo
  newPlankInfo.value = {
    ...newPlankInfo.value,
    ...EchoBoard,
  }
  // 需要回显的特殊值赋值
  newPlankInfo.value = {
    ...newPlankInfo.value,
    ...needReviewData.value,
  }
}

// 添加板件的hooks
const {
  newPlankInfo,
  isShowAddPartDrawer,
  isAddLoading,
  handleOpenAddDrawer,
  handleCloseDrawer,
  handleConfirmAddPart,
  clearNewPlankInfo,
} = useAddPart({
  openModalCallback: openModal,
  addPartSuccessCallback: confirmAddPart,
})

// 添加板件
const addPart = (part: IAddPartFormType) => {
  const newPart: PartType = { ...(part as unknown as PartType) }

  // 对特殊类型的数据进行处理
  needFixTypeProps.forEach((prop) => {
    newPart[prop] = Number(newPart[prop]) ?? 0
  })

  newPart.isManual = true
  newPart.fullSize = {
    width: 0,
    height: 0,
  }
  newPart.oRect = {
    x: 0,
    y: 0,
    width: Number(newPart.specWidth),
    height: Number(newPart.specHeight),
  }
  newPart.rect = {
    x: 0,
    y: 0,
    width: toDecimal(
      newPart.specWidth - newPart.leftEdge - newPart.rightEdge,
      2
    ),
    height: toDecimal(
      newPart.specHeight - newPart.frontEdge - newPart.backEdge,
      2
    ),
  }
  newPart.realRect = {
    x: 0,
    y: 0,
    width: toDecimal(
      newPart.specWidth - newPart.leftEdge - newPart.rightEdge,
      2
    ),
    height: toDecimal(
      newPart.specHeight - newPart.frontEdge - newPart.backEdge,
      2
    ),
  }

  newPart.realCurve = [
    { x: 0, y: 0 },
    { x: newPart.oRect.width, y: 0 },
    { x: newPart.oRect.width, y: newPart.oRect.height },
    { x: 0, y: newPart.oRect.height },
  ]
  newPart.typeSymbol = `${newPart.matCode}:${newPart.thick}:${newPart.texture}`
  newPart.isSelected = true
  newPart.hsInfo = '0孔0槽'
  newPart.specialShape = false
  newPart.holes = []
  newPart.sholes = []
  newPart.slots = []
  newPart.sslots = []
  newPart.leftEdge = newPart.leftEdge ?? 0
  newPart.rightEdge = newPart.rightEdge ?? 0
  newPart.frontEdge = newPart.frontEdge ?? 0
  newPart.backEdge = newPart.backEdge ?? 0
  newPart.edgeInfo = `←${newPart.leftEdge}↓${newPart.backEdge}→${newPart.rightEdge}↑${newPart.frontEdge}`
  newPart.realCurveEx = []
  newPart.matRotatable = newPart.texDir === 'notcare' ? true : false
  newPart.address = '手动添加的板件'
  newPart.name = '手动添加的板件'
  const plankNum = uniquePlankNum.createUniquePlankNum()
  newPart.plankNum = plankNum
  newPart.oriPlankNum = plankNum
  const { simplePlankNum, simplePlankNumF } = generateSimplePlankNumFn(newPart)
  newPart.simplePlankNum = simplePlankNum ?? newPart.simplePlankNum
  newPart.simplePlankNumF = simplePlankNumF ?? newPart.simplePlankNumF
  const partUniqueId = nanoid()
  newPart.partUniqueId = partUniqueId
  newPart.oriPartUniqueId = partUniqueId
  newPart.type = 'Plank'
  buryPoint({ function_module: 'material', function_point: 'add_plate' })

  return newPart
}

// 料单颜色列表
const materialColorList = computed(() => store.state.materialColorList)

const materialColorOptions = ref<MaterialColorItemType[]>([])

// 材质列表
const matCodeList = ref<{ label: string; value: string }[]>([])

// 选择材质
const handleSelectMatCode = () => {
  store.commit('setNewMaterialMatCode', newPlankInfo.value.matCode)
  store.commit('setNeedReviewData', {
    ...needReviewData.value,
    matCode: newPlankInfo.value.matCode,
  })
}
// 颜色列表加载状态
const isLoadingColors = computed(() => store.state.isLoadingColors)
// 通过enter键创建材质
const handleCreateMatCode = (e: ChangeEvent<HTMLInputElement>) => {
  try {
    const val = e.target.value
    // 去掉空格
    const matCode = val?.replaceAll(/\s/g, '')
    if (!matCode)
      return Vue.prototype.$message({
        message: translateLang('材质不能为空'),
        type: 'warning',
      })
    // 判断数组是否已经存在当前添加的数据
    const isExist = checkMatCodeIsExist(matCode, matCodeList.value)
    if (!isExist) {
      // 获取本地的材质数据
      const otherMatCodes = localStorage.getItem('matcodeList')
        ? JSON.parse(localStorage.getItem('matcodeList')!)
        : []
      otherMatCodes.push(matCode)
      localStorage.setItem('matcodeList', JSON.stringify(otherMatCodes))
      // 将数据添加到数组中，并且显示
      const matCodeSelectOption = {
        label: matCode,
        value: matCode,
      }
      matCodeList.value.push(matCodeSelectOption)
    }
    newPlankInfo.value.matCode = matCode
    store.commit('setNewMaterialMatCode', matCode)
  } catch (error) {
    console.log('创建材质失败', error)
  }
}

// 选择颜色
const handleSelectTexture = (e: string[]) => {
  newPlankInfo.value.texture = e ? e[e.length - 1] : ''
  store.commit('setNewMaterialColorList', e)
  store.commit('setNeedReviewData', {
    ...needReviewData.value,
    texture: newPlankInfo.value.texture,
  })
}

// 通过enter键创建颜色
const handleCreateTexture = (e: ChangeEvent<HTMLInputElement>) => {
  try {
    const val = e.target.value
    // 去掉空格
    const texture = val?.replaceAll(/\s/g, '')
    if (!texture) {
      Vue.prototype.$message({
        message: translateLang('颜色不能为空'),
        type: 'warning',
      })
      return
    }
    // 判断数组是否已经存在当前添加的数据
    const isExist = checkColorIsExist(texture, materialColorOptions.value)
    if (!isExist) {
      // 获取本地的材质数据
      const otherColors = localStorage.getItem('colorList')
        ? JSON.parse(localStorage.getItem('colorList')!)
        : []
      otherColors.push(texture)
      localStorage.setItem('colorList', JSON.stringify(otherColors))
      const lastIndex = materialColorOptions.value.length - 1
      materialColorOptions.value[lastIndex].children?.push({
        label: texture,
        value: texture,
      })
    }
    newPlankInfo.value.texture = texture
  } catch (error) {
    console.log('创建颜色失败', error)
  }
}
// 颜色级联选择过滤前的处理
const onBeforeFilter = () => {}

// 获取响应式数据的类型
const inputCheck = (
  prop: Exclude<newPlankInfoType, 'is_high_gloss_plank'>,
  digits: string
) => {
  ;(newPlankInfo.value[prop] as any) = verifyInputNumber(
    newPlankInfo.value[prop]!,
    newPlankInfo.value,
    [prop],
    digits
  )
}

// 选择纹理
const handleSelectTexDir = (value: string) => {
  newPlankInfo.value.srcTexDir = value as TextureType
}

/**
 * 超尺状态检测
 */

// 超尺状态时，查看原片信息
const showAddBaseMModal = ref(false)

// 查看板件详情弹窗
const isShowPlateDetails = ref(false)

// 打开添加特殊大板弹窗
const showAddSpecialPlate = ref(false)

// 展示大板详情数据
const showBigPlateDetail = ref(false)

// 板件数据错误弹窗
const plankErrVisible = ref(false)
// 板件数据错误提示
const plankErrMsg = ref(translateLang('板件内部数据存在异常，无法进行排版生产'))

// 是否展示同步柜柜原片数据弹窗
const showSyncGuiguiBaseMModal = ref(false)
// 原片管理数据是否有更新
const BaseMIsSame = ref(true)

// 同归柜柜数据loadding状态
const syncGuiguiBaseMLoading = ref(false)

// 同步、取消同步
const syncGuiguiBaseM = async (isSync: boolean) => {
  const params = {
    target: {
      checked: currentPreferenceSetting.value.isCheckBigPlankSynchronous,
    },
  }
  try {
    await savePreferences(params as any, 'isCheckBigPlankSynchronous')
    if (isSync) {
      syncGuiguiBaseMLoading.value = true
      // 此处无需等待
      const res = await fetchSyncGuiguiData({ uid: userInfo.value.id })
      if (res.status !== 1) {
        Vue.prototype.$message({
          message: translateLang('同步失败'),
          type: 'error',
        })
        return
      } else {
        Vue.prototype.$message({
          message: translateLang('同步成功'),
          type: 'success',
        })
      }
    }
    BaseMIsSame.value = true
    dealLayoutData(paibanSettingState.value)
  } catch (error) {
    console.log('同步柜柜数据失败', error)
  } finally {
    syncGuiguiBaseMLoading.value = false
    showSyncGuiguiBaseMModal.value = !showSyncGuiguiBaseMModal.value
  }
}
// 检测柜柜数据是否更新
const detectGuiguiBaseMIsUpdate = () => {
  fetchCheckSyncGuiguiData()
    .then((res) => {
      if (res.status === 1) {
        BaseMIsSame.value = res.data.is_same
      }
    })
    .catch((error) => {
      console.log('检测柜柜数据同步失败', error)
    })
}

/**
 * 开始排版相关操作
 */

// 排版时用到的数据
const paibanParams = ref({
  isPaibaning: false,
  isSendToFactory: false,
  partCount: 0,
})
// 生产线列表
const proLineList = computed<IProductionLineType[]>(
  () => store.state.proLineList
)

const isShowPaibanModal = ref(false)

// 预排版设置
const preLayoutSetting = computed(() => store.state.preLayoutSetting)

// 打开排版弹窗
const handleOpenPaibanModal = async () => {
  if (!selectedParts.value.length) {
    Vue.prototype.$message({
      message: translateLang('请先至少选中一个板件再进行此操作!'),
      type: 'error',
    })
    return
  }

  // 检查是否有错误数据的板件
  const errPart = detactionPlank()

  console.log('errPart', errPart)
  if (errPart.length) {
    let msg = errPart.map((item) =>
      item.partName ? item.partName : translateLang('未找到板件名称')
    )
    const errorMsg =
      translateLang('板件数据错误，请仔细检查，避免生产损失') +
      JSON.stringify(msg)
    return Vue.prototype.$message({
      message: errorMsg,
      type: 'error',
    })
  }

  // 处理参与排版的板件数据（补件和待排版库板件）
  const { parts } = await getParticipationPartsForPaiban()
  updateHasBrandPartForPaiban(
    parts,
    bujianDataForPaiban.value,
    awaitStoreDataForPaiban.value
  )
  // 统计参与排版的板件
  paibanParams.value.partCount = countParts() || 0

  // 判断混排方案是否发生改变
  if (hasMixPaibanPlansChanged.value) {
    await showSyncModal({
      modalComponent: GBaseModal,
      title: translateLang('系统提示'),
      contain: translateLang(
        '系统检测混排方案设置发生改变，请重新选择本次混排方案！'
      ),
      okText: translateLang('设置混排方案'),
      cancelText: translateLang('不用,直接排版'),
      confirmCallback: () => {
        handleOpenMixPaibanPlanModal()
      },
      cancelCallback: () => {
        store.commit('materialListStore/setSelectedMixPaibanPlans', [])
        isShowPaibanModal.value = true
        paibanMessage.value = {}
      },
    })
    return
  }

  isShowPaibanModal.value = true
  paibanMessage.value = {}
}

const isShowMixPaibanPlanModal = ref(false)
// 打开混排方案弹窗
const handleOpenMixPaibanPlanModal = () => {
  isShowMixPaibanPlanModal.value = true
}

// 比较已使用方案和最新的方案是否有变化
const hasMixPaibanPlansChanged = computed(() => {
  if (!store.state.preferencesSetting!.setting.enableMixPaiban) return false
  const allMixPaibanPlans =
    store.state.preferencesSetting!.setting.mixPaibanSettings
  return selectedMixPaibanPlans.value.some((plan) => {
    const findPlan = allMixPaibanPlans?.find((item) => item.id === plan.id)
    if (!findPlan) return true
    const { isSelected, allColors, ...finalPlan } = plan
    return JSON.stringify(findPlan) !== JSON.stringify(finalPlan)
  })
})
// 获取已勾选的排版方案
const selectedMixPaibanPlans = computed(() => {
  return store.state.materialListStore!.selectedMixPaibanPlans
})

// 当勾选的混排方案发生改变后，对板件进行处理,修改满足要求的小板的颜色
watch(
  () => selectedMixPaibanPlans.value,
  (val) => {
    if (
      !hasMixPaibanPlansChanged.value &&
      storePreferencesSetting.value?.enableMixPaiban
    ) {
      // 根据混排方案，对板件进行处理,修改满足要求的小板的颜色
      const newFilterPlankList = filterPlankList.value.map((plank) => {
        const { texture, parts, matCode } = plank
        const plan = val.find((plan) =>
          matchMixPaibanPlan(plan, { matCode, texture })
        )
        // 这个大板符合混排方案，则同步修改小板数据
        let newParts = parts
        if (plan) {
          const { targetTexture } = plan
          newParts = parts.map((part) => {
            return {
              ...part,
              oriTexture: part.isSelected ? targetTexture : texture,
            }
          })
        } else {
          // 取消了方案
          newParts = parts.map((part) => {
            return {
              ...part,
              oriTexture: texture,
            }
          })
        }
        return {
          ...plank,
          parts: newParts,
        }
      })

      if (newFilterPlankList.length) {
        const newFilterPlanks = dealFilterData(
          newFilterPlankList,
          undefined,
          undefined,
          specialRemarksForProcessLabel.value
        )
        setFilterPlankList(newFilterPlanks)
      }
    }
  },
  {
    deep: true,
  }
)

// 获取满足当前订单的混排方案
const currentMixPaibanPlans = computed(() => {
  const result: typeof selectedMixPaibanPlans.value = []
  const mixPaibanSettings =
    store.state.preferencesSetting!.setting.mixPaibanSettings
  // 根据勾选小板,获取到符合的混排方案
  // 直接访问 filterPlankList.value，确保追踪到数组引用变化
  filterPlankList.value.forEach((plank) => {
    const { matCode, texture, isAllSelect, parts } = plank
    const plan = mixPaibanSettings?.find(
      (setting) =>
        setting.matCode === matCode && setting.originTexture.includes(texture)
    )
    if (!plan || result.find((res) => res.id === plan.id)) return
    if (isAllSelect || parts?.find((part) => part.isSelected))
      return result.push({
        ...plan,
        allColors: [...plan.originTexture, plan.targetTexture],
      })
  })
  result.sort((a, b) => {
    return (
      mixPaibanSettings!.findIndex((setting) => setting.id === a.id) -
      mixPaibanSettings!.findIndex((setting) => setting.id === b.id)
    )
  })
  // 这样写不好！！
  selectedMixPaibanPlans.value.forEach((res) => {
    const plan = result.find((plan) => plan.id === res.id)
    if (!plan && result.length) res.isSelected = false
    else if (!result.length && filterPlankList.value.length)
      res.isSelected = false
  })
  const r1 = result.map((plan) => {
    return {
      ...plan,
      isSelected: hasMixPaibanPlansChanged.value
        ? false
        : selectedMixPaibanPlans.value.find((res) => res.id === plan.id)
            ?.isSelected ?? false,
    }
  })
  return r1
})

// 确定使用混排方案
const handleMixPaibanPlanOk = (
  payload: typeof selectedMixPaibanPlans.value
) => {
  store.commit('materialListStore/setSelectedMixPaibanPlans', payload)
}

// 统计参与排版的板件数
const countParts = () => {
  try {
    const result = selectedParts.value.reduce((acc, part) => {
      return acc + Number(part.amount)
    }, 0)
    const bujianCount = bujianDataForPaiban.value.length || 0
    const awaitStoreCount = awaitStoreDataForPaiban.value.length || 0

    return result + bujianCount + awaitStoreCount
  } catch (error) {
    console.log('计算板件数失败', error)
  }
}

// 检查是否有错误数据的板件
const detactionPlank = () => {
  const parts = selectedParts.value.filter((part) => {
    const { edgeInfo, oRect } = part
    const [left, bottom, right, top] = edgeInfo
      .split(/←|↓|→|↑/)
      .filter((it) => it)
      .map((e) => (e ? Number(e) : 0))
    const w = left + right
    const h = bottom + top
    const ow = +oRect.width
    const oh = +oRect.height
    return ow - w <= 0 || oh - h <= 0
  })
  return parts
}

// 是否展示保存历史弹窗
const showSaveDialog = ref(false)

// 关闭开始排版弹窗
const handleCancelPiaban = () => {
  isPaibanErr.value = false
  isShowPaibanModal.value = false
  isConfirmLoading.value = false
}

// 排版错误状态
const isPaibanErr = ref(false)
// 排版错误，锯切没有刀
const isNotSawKnife = ref(false)
// 关闭排版超时弹窗,重新排版
const handleCancelPaibanTimeout = () => {
  isPaibanErr.value = false
}

// 确定排版加载状态
const isConfirmLoading = ref(false)

/** 排版前重置一些必要的参数 */
const resetPaibanData = () => {
  // 清空store中保存的特殊大板信息
  store.commit('setSpecialPlankParams', [])
  store.commit('setLockedPlank', [])
  store.commit('setPaibanKey', [])
  store.commit('setBeforeTitleSorts', [])
}

const paibanFormData = ref<IpaibanFormDataType>({
  layoutMethod: '',
  paibanWay: '',
  process_line_id: 0,
  surplusTailorWay: 'maxRect',
  surplusAutoTailor: false,
  // 记录是否少翻版
  isLessReverse: false,
  // 记录是否支持异形
  isSpecialShape: false,
  shortSideRect: 300,
  longSideRect: 250,
  isSetCustomRect: false,
  customRectTemplate: [
    {
      shortSideRect: 250,
      longSideRect: 300,
      thickRect: null,
    },
  ],
  isSurplusNoRoll: 0,
  standardPlankList: [],
  selectStandardPlank: {
    default_selected: false,
    plankEdgeOff: 0,
    plankHeight: 0,
    plankWidth: 0,
    standard_plank_id: '',
  },
  process_setting_id: 0,
  // 是否开启自定义大板排版
  customPlankOrder: false,
  plankOrderList: [],
  isPreLayout: false,
  surplus_lock: false,
  isCombineToLShape: false,
  isSurNotLayoutMat: true,
})

/**
 * 未排版小板清单相关
 *
 */
// 未排小板清单
const showPartDetail = ref(false)
const paibanMessage = ref<Record<string, any>>({})

// 显示未排小板清单
const handleShowPartDetail = () => {
  showPartDetail.value = true
  isShowPaibanModal.value = false
}
const handleClosePartDetail = () => {
  showPartDetail.value = false
  isShowPaibanModal.value = true
}

// 确定开始排版
const paibanSettingState = ref<IpaibanFormDataType>()
/** 是否创建任务 */
const isCreateTask = ref(false)
const handleStartPaiban = (
  state: IpaibanFormDataType,
  isSendToFactory = false
) => {
  isCreateTask.value = state.isCreateTask ?? false
  if (!isCreateTask.value) {
    isConfirmLoading.value = false
  }
  paibanSettingState.value = state
  dealLayoutData(state, isSendToFactory)
}
const isShowSpecialAndFiveSix = ref<boolean>(false)
const continueJudgeSpecialShape = ref<boolean>(false)
const handleConfirmContinuePaiban = () => {
  isShowSpecialAndFiveSix.value = false
  continueJudgeSpecialShape.value = true
  dealLayoutData(paibanSettingState.value)
}
const handleCancelContinuePaiban = () => {
  isShowSpecialAndFiveSix.value = false
  handleCancelPiaban()
}
const isError = ref(false)
const dealPlateErr = (errText?: string) => {
  isError.value = true
  paibanParams.value.isPaibaning = false
  let errStr = errText
  const knifeMap = ncSetting.value.plate_knife_map as any
  if (!knifeMap) {
    for (const key in knifeMap) {
      errStr = knifeMap[key].error
    }
  }
  // 处理括号内的字符加粗 刀名
  errStr = errStr.replace(/（([^）]+)）/g, '<strong>（$1）</strong>')
  // 处理特定的词汇加粗
  errStr = errStr.replace(
    /已开启不同材质下料刀/g,
    '<strong>已开启不同材质下料刀</strong>'
  )
  vm?.proxy
    .$confirm(errStr ?? '', translateLang('提示'), {
      confirmButtonText: translateLang('前往添加'),
      cancelButtonText: translateLang('取消'),
      type: 'warning',
      dangerouslyUseHTMLString: true,
    })
    .then(() => {
      const setting_id = paibanFormData.value.process_line_id,
        line = selectProLine.value.name,
        equipType = 'engraving'
      router.push({
        path: `/${equipType}`,
        query: {
          setting_id: setting_id + '',
          line,
          equipType,
        },
      })
    })
    .catch(() => {
      isError.value = false
    })
}
const updateMaterialData = (
  res: Awaited<ReturnType<typeof calcBaseMaterial>>
) => {
  if (!res) return
  needBaseMaterials.value = res.needBaseMaterials
  autoAddSpecialPlate.value = res.autoAddSpecialPlate
  materialInfo.value = res.materialRes
}

// 处理layout数据
const dealLayoutData = async (
  state: IpaibanFormDataType = paibanFormData.value,
  isSendToFactory = false
) => {
  try {
    isConfirmLoading.value = true
    paibanFormData.value = state

    let currentLine: typeof proLineList.value[number] | undefined = undefined

    if (!state) return message.error('排版参数不存在')

    // 使用的是预排版
    if (state.isPreLayout) {
      const res = await getPrelayoutSetting()
      if (res.status !== 1) return message.error('获取预排版设置失败')
      const { setting_value: setting } = res.data
      const ncSetting = dealPreLayoutSetting(setting)
      store.commit('setPreLayoutSetting', res.data)
      store.commit('setOriLayoutSetting', res.data) // 保存排版用预排版设置
      store.commit('setNcSetting', ncSetting)
      store.commit(
        'setRecodrProductionLineChoose',
        translateLang('(空)预排版方案')
      )
    } else {
      // 使用正常生产线设置
      const ncRes = await fetchGetProductionNcSetting({
        setting_id: selectProLine.value.id,
      })
      if (ncRes.status !== 1) {
        // TODO: 检查五六面钻配置
        if (oldFiveSixXYTip(ncRes.status)) return
        return message.error('获取生产线设置失败')
      }
      const ncSetting = ncRes.data

      if (ncSetting.laser_enable) {
        // 激光一体机 反面刀库
        const isBackKnives = Object.values(ncSetting.back_knives).some(
          (item: any) => item.type === 'laser'
        )
        if (!isBackKnives) {
          isShowPaibanModal.value = false
          return message.error('激光一体机 反面刀库 未设置激光刀，请检查！')
        }
        // 开料机刀库
        const isKnives = Object.values(ncSetting.knives).some(
          (item: any) => item.type === 'laser'
        )
        if (!isKnives) {
          isShowPaibanModal.value = false
          return message.error('开料机刀库 未设置激光刀，请检查！')
        }
      }
      Object.assign(ncSetting, { process_setting_id: selectProLine.value.id })
      store.commit('setNcSetting', ncSetting)
      // 获取当前选择的生产线
      const line = proLineList.value.find(
        (item) => selectProLine.value.id === item.id
      )
      if (!line) throw new Error('未找到生产线')
      currentLine = line

      store.commit('setRecodrProductionLineChoose', currentLine.name)
    }

    // 清空一些排版的前置参数
    resetPaibanData()
    store.commit('setPrePaibanData', [])
    store.commit('setPaibanData', [])
    store.commit('setSkipCrossMaterialConfirm', false)
    clearCachedRawPlank()
    buryPointApi('material', 'set_layout')
    isPaibanErr.value = false

    // 获取是都是锯切输出小板设置
    const isSawToExportPartData =
      currentLine?.data.cuttingEquipment === 'engraving' &&
      currentLine?.data.saw_setting.saw_enable &&
      currentLine?.data.saw_setting.saw_aio
    // 电子锯
    if (
      (currentLine && currentLine.data.cuttingEquipment === 'electronicSaw') ||
      isSawToExportPartData
    ) {
      await handleShowOrderMark()
      isShowPaibanModal.value = false
      paibanParams.value.isSendToFactory = isSendToFactory
      if (!isShowOrderMark.value) {
        handleProlineIsElectronicSaw(isSendToFactory)
        // paibanState中存在一些偏好设置中的值，此处就是在保存这些值
        updateLocalPreference({
          ...preferencesSetting.value,
          ...paibanFormData.value,
        } as any)
        store.commit('setActivePaibanWay', [paibanFormData.value?.paibanWay])

        // paibanState里面部分数据的操作记录
        genFinalRecordFn(
          {
            customRectTemplate: preferencesSetting.value.customRectTemplate,
            isSetCustomRect: preferencesSetting.value.isSetCustomRect,
          },
          {
            customRectTemplate: paibanFormData.value.customRectTemplate,
            isSetCustomRect: paibanFormData.value.isSetCustomRect,
          }
        )
      }
      // resetNCSetting()

      return
    }

    // 判断所有待排版板件是否都满足只加工孔槽不下料条件
    const isAllPartsNoCut =
      currentLine &&
      selectedParts.value.every((part) =>
        isOnlyProcessSlotAndHole(currentLine, part.matCode)
      )
    // 检测柜柜原片数据是否一致（所有板件都不下料时无需检测原片同步）
    if (
      !isAllPartsNoCut &&
      !BaseMIsSame.value &&
      !sessionStorage.getItem('thinkerx_material') &&
      !route.query.thinkerx_material &&
      !currentPreferenceSetting.value.isCheckBigPlankSynchronous
    ) {
      isShowPaibanModal.value = false
      showSyncGuiguiBaseMModal.value = true

      return
    }

    // 判断异形嵌套和五六面钻
    if (currentLine && !continueJudgeSpecialShape.value) {
      if (
        state.isSpecialShape &&
        currentLine.data.dock56FDrill &&
        !currentLine.data.hole_slot_engraving_process.engraving_process_setting
          .non_hole_slot_of_special_shape &&
        currentLine.data.ncHoleSlot !== 'doubleHoleSlot'
      ) {
        // 弹出提示框
        isShowSpecialAndFiveSix.value = true
        isShowPaibanModal.value = false
        return
      }
    }

    // 判断是否开启激光一体机
    if (ncSetting.value.laser_enable) {
      // 激光一体机 反面刀库
      const isBackKnives = Object.values(ncSetting.value.back_knives).some(
        (item: any) => item.type === 'laser'
      )
      if (!isBackKnives) {
        isShowPaibanModal.value = false
        return message.error('激光一体机 反面刀库 未设置激光刀，请检查！')
      }
      // 开料机刀库
      const isKnives = Object.values(ncSetting.value.knives).some(
        (item: any) => item.type === 'laser'
      )
      if (!isKnives) {
        isShowPaibanModal.value = false
        return message.error('开料机刀库 未设置激光刀，请检查！')
      }
    }

    store.commit('setCustomPlankOrder', state.customPlankOrder)
    store.commit('setPlankOrderList', state.plankOrderList)
    if (state.customPlankOrder) {
      buryPointApi('material', 'customPaiban')
      const standardPlank = state.plankOrderList.find(
        (item) => item.plankType == '标准大板'
      )
      if (
        state.plankOrderList.length == 0 ||
        state.plankOrderList.every((item) => item.amount == 0)
      ) {
        Vue.prototype.$message({
          message: '请至少保留一种大板参与排版!',
          type: 'error',
        })
        isShowPaibanModal.value = false
        return
      } else if (!standardPlank || standardPlank.amount == 0) {
        const newFilterPlankList = filterPlankList.value.filter((item) =>
          item.parts.some((part) => part.isSelected)
        )
        const plateList = state.plankOrderList.filter(
          (item) => item.plankType != '标准大板'
        )
        let flag = false
        newFilterPlankList.forEach((item) => {
          // 查找是否使用了
          const mixPaibanPlan = storePreferencesSetting?.value?.enableMixPaiban
            ? selectedMixPaibanPlans.value.find((plan) =>
                matchMixPaibanPlan(plan, item)
              )!
            : null
          const filterPlateList = plateList.filter(
            (plateItem) =>
              item.matCode == plateItem.matCode &&
              item.thick == plateItem.thick &&
              (item.texture == plateItem.texture ||
                mixPaibanPlan?.allColors.includes(plateItem.texture))
          )
          if (
            !filterPlateList.length ||
            filterPlateList.every((plateItem) => plateItem.amount == 0)
          ) {
            flag = true
          }
        })
        if (flag) {
          Vue.prototype.$message({
            message: translateLang('当前用料方案存在小板没有可用大板进行排版!'),
            type: 'error',
          })
          isShowPaibanModal.value = false

          return
        }
      }
    }

    // 余料自动裁剪
    store.commit('setSurplusAutoTailor', state.surplusAutoTailor)

    if (state.surplusAutoTailor) {
      store.commit('setSurplusTailorWay', state.surplusTailorWay)
      store.commit('setRecodeIsTailor', state.surplusAutoTailor)
      store.commit('setLongSideRect', state.longSideRect)
      store.commit('setShortSideRect', state.shortSideRect)
      store.commit('setIsSetCustomRect', state.isSetCustomRect)
      store.commit('setCustomRectTemplate', state.customRectTemplate)
      store.commit('setIsCombineToLShape', state.isCombineToLShape)
    }

    store.commit('setIsResetPaibanAllocation', true)

    // 记录参加了排版的待排版库板件，用于待排版库隐藏对应的板件
    const awaitStoreHiddenIds = awaitStoreDataForPaiban.value.map(
      (it: any) => it.partUniqueId
    )
    // 已经参与排版的待排版库的id
    const preLayoutAwaitHiddenIds = selectedParts.value
      .filter((it) => it._isAwaitStorePlank)
      .map((it) => it.partUniqueId)

    let allParts = getAllParts(
      filterPlankList.value.length ? filterPlankList.value : plankList.value
    ).concat([
      ...bujianDataForPaiban.value,
      ...awaitStoreDataForPaiban.value,
    ]) as PartType[]

    // 保存原始对纹板件
    const textureParts = allParts.filter((p) => isTextureAlignmentPlank(p))
    // 对纹板件处理
    allParts = compositeTexturePlanks(
      allParts as any,
      ncSetting.value?.panelSize?.layoutGap ?? 0,
      false,
      false,
      ncSetting.value?.decimal ?? 2
    ) as any
    // 记录虚拟板，并将对纹小板加入处理（用于孔槽分流）
    const virtualPlanks = allParts.filter((p) => isVirtualCompositePlank(p))
    allParts.push(...textureParts)
    allParts = flipTextureLowPos(
      allParts as PartType[],
      ncSetting.value?.decimal ?? 2
    )
    // ncsetting没有正确数据，有错误信息，则直接跳过
    if (ncSetting.value && !Reflect.has(ncSetting.value, 'err_info')) {
      await dealPlankHoleSlot(allParts, ncSetting.value)
    }

    /** 处理孔槽 */
    function dealParts(parts: any[]) {
      parts.forEach((part: any) => {
        const newPart = allParts.find(
          (p: any) => p.partUniqueId == part.partUniqueId
        ) as any
        if (newPart) {
          const keys = [
            'holes',
            'slots',
            'process_in_engraving_to_curve',
            'engraving_cut_curve',
            'engraving_cut_curve_to_turn',
            'millInfo',
            'handleSlopes',
          ]
          keys.forEach((key) => {
            const newV = newPart[key] as any
            if (newV) {
              part[key] = newV
            }
          })
          // 记录原始槽点位数据（用于扩板操作）
          part.slots?.forEach((slot: any) => {
            slot.oriPt1 = slot.pt1 ? window.$copy(slot.pt1) : undefined
            slot.oriPt2 = slot.pt2 ? window.$copy(slot.pt2) : undefined
          })
          part.lineSlots?.forEach((slot: any) => {
            slot.oriPath = slot.path ? window.$copy(slot.path) : undefined
          })
          // Object.assign(part, newPart)
        }
      })
    }
    plankList.value.forEach((plank) => {
      dealParts(plank.parts)
    })
    // 处理板件孔槽分流情况
    dealParts(
      [
        bujianDataForPaiban.value,
        awaitStoreDataForPaiban.value,
        selectedParts.value,
      ].flat(1)
    )
    // 用对纹虚拟板的分流信息，代替内部小板的分流信息
    for (const vp of virtualPlanks) {
      const {
        process_in_engraving_to_curve,
        engraving_cut_curve,
        engraving_cut_curve_to_turn,
      } = vp
      const planks = decompositeTexturePlanks([vp])
      for (const cp of planks ?? []) {
        cp.process_in_engraving_to_curve = process_in_engraving_to_curve
        cp.engraving_cut_curve = engraving_cut_curve
        cp.engraving_cut_curve_to_turn = engraving_cut_curve_to_turn
      }
    }

    store.commit(
      'awaitPaibanStore/setParticipationPaibanPlank',
      awaitStoreHiddenIds.concat(preLayoutAwaitHiddenIds)
    )

    const mergedParts = dealFrameDoorSplice(
      [
        ...selectedParts.value,
        ...bujianDataForPaiban.value,
        ...awaitStoreDataForPaiban.value,
      ],
      ncSetting.value?.knife?.diameter
    )
    const dealRes = await calcBaseMaterial(
      mergedParts,
      selectStandardPlank.value,
      ncSetting.value.isPreLayout ? -2 : state.process_line_id,
      (errType, errText = '') => {
        paibanParams.value.isPaibaning = false
        if (errType === 'plank') {
          isShowPaibanModal.value = false
          dealPlateErr(errText)
        } else {
          vm?.proxy.$confirm(errText ?? '', translateLang('提示'), {
            confirmButtonText: translateLang('确认'),
            cancelButtonText: translateLang('取消'),
            type: 'error',
          })
        }
      }
    )

    if (dealRes) {
      // 过滤掉满足只加工孔槽不下料条件的板件，这些板件不需要判断是否超尺
      const rawLongPlates = currentLine
        ? dealRes.setNotMatchPartList.filter(
            (part) => !isOnlyProcessSlotAndHole(currentLine, part.matCode)
          )
        : dealRes.setNotMatchPartList
      // 虚拟组合板拆解为原始子板，不收集虚拟板
      extraLongPlates.value = decompositeTexturePlanks(rawLongPlates) as any[]
      // 将仅加工孔槽板件生成的特殊原片追加到 needBaseMaterials,这是临时处理
      if (currentLine) {
        const allParts = [
          ...selectedParts.value,
          ...bujianDataForPaiban.value,
          ...awaitStoreDataForPaiban.value,
        ]
        const notCutMaterials = genBaseMaterialsForNotCutParts(
          allParts,
          currentLine
        )
        dealRes.needBaseMaterials.unshift(...notCutMaterials)
      }
      updateMaterialData(dealRes)
    } else {
      isShowPaibanModal.value = false

      return
    }

    if (isError.value) {
      isShowPaibanModal.value = false
      // resetNCSetting()

      return
    }
    // 检测原片是否可容纳所有板件
    if (!paibanFormData.value.customPlankOrder) {
      if (extraLongPlates.value.length) {
        // 检测对纹组是否超尺
        const compositedExtra = compositeTexturePlanks(
          extraLongPlates.value,
          0,
          false,
          true
        )
        const oversizedGroups = compositedExtra.filter((p) =>
          isVirtualCompositePlank(p)
        )
        if (oversizedGroups.length) {
          const groupInfos = oversizedGroups
            .map((p) => {
              const child = p._virtualCompositePlanks?.[0]
              return `${child?.address ?? ''}_${child?.roomName ?? ''}_${
                p.partName ?? ''
              }`
            })
            .filter(Boolean)
            .join('、')
          message.error(`存在超尺对纹组：${groupInfos}`)
        }
        isShowPaibanModal.value = false
        if (autoAddSpecialPlate.value) {
          // 开启自动添加超尺板件
          // 获取特殊大板的尺寸
          bigPlateList.value = calculateBigPlateList(extraLongPlates.value)
          showAddSpecialPlate.value = true
        } else {
          showAddBaseMModal.value = true
        }
        throw new Error('存在超尺')
      }
    }
    if (!state.isCreateTask) {
      isConfirmLoading.value = false
      isShowPaibanModal.value = false
      paibanParams.value.isPaibaning = true
    }

    // // 获取生产线nc设置
    // const params: { setting_id: number; production_from?: 'guimen' } = {
    //   setting_id: currentLine.id,
    // }
    // if (window.sessionStorage.getItem('thinkerx_material')) {
    //   params.production_from = 'guimen'
    // }
    // const ncSettingRes =
    //   state && state.isPreLayout
    //     ? { data: ncSetting.value, status: 1 }
    //     : ncSetting.value
    //     ? { data: ncSetting.value, status: 1 }
    //     : await fetchGetProductionNcSetting(params)
    // const { status, data } = ncSettingRes
    // if (status !== 1) throw new Error('获取nc设置失败')
    const data = cloneDeep(ncSetting.value) as typeof ncSetting.value
    // TODO: 检查刀具是否符合
    judgePlateKnife(data.plate_knife_map, selectedParts.value)
    if (isError.value) {
      // resetNCSetting()

      return
    }
    // TODO: 检查五六面钻配置
    if (oldFiveSixXYTip(Number(status))) {
      // resetNCSetting()
      return
    }

    // 绘制尺寸对调
    const drawPlankWidth: number =
      data ?? data.countertopSetting.xyReverse
        ? selectStandardPlank.value.plankHeight
        : selectStandardPlank.value.plankWidth
    const drawPlankHeight: number =
      data.xyReverse ?? data.countertopSetting.xyReverse
        ? selectStandardPlank.value.plankWidth
        : selectStandardPlank.value.plankHeight

    const ncSettingTmep = Object.assign(data, {
      process_setting_id: data.isPreLayout ? null : currentLine?.id,
      process_setting_name: data.isPreLayout ? '预排版方案' : currentLine?.name,
      cuttingEquipment: data.isPreLayout
        ? 'engraving'
        : (currentLine?.data.cuttingEquipment as string),
      drawPlankWidth,
      drawPlankHeight,
    })

    // 防止新账号没有顺逆时针的设置
    if (!ncSettingTmep.cutDirection) {
      ncSettingTmep.cutDirection = '逆时针'
    }
    store.commit('setNcSetting', ncSettingTmep)
    store.commit('setHighglossDirection', ncSettingTmep.highgloss_direction)
    // 保存偏好设置
    updateLocalPreference({
      ...preferencesSetting.value,
      ...paibanFormData.value,
    } as any)
    genFinalRecordFn(
      {
        customRectTemplate: preferencesSetting.value.customRectTemplate,
        isSetCustomRect: preferencesSetting.value.isSetCustomRect,
      },
      {
        customRectTemplate: paibanFormData.value.customRectTemplate,
        isSetCustomRect: paibanFormData.value.isSetCustomRect,
      }
    )
    store.commit('setPaibanInfo', paibanFormData.value)
    store.commit('setActivePaibanWay', [paibanFormData.value.paibanWay])
    store.commit('setOrderInfo', tempOrderInfo.value)
    // 清除排版批次
    store.commit('setTypesettingBatch', '')
    // 处理数据
    await dealReadPaibanData(
      selectedParts.value,
      ncSettingTmep,
      bujianDataForPaiban.value,
      awaitStoreDataForPaiban.value
    )
  } catch (error) {
    console.log('排版数据错误', error)
  } finally {
    isConfirmLoading.value = false
    paibanParams.value.isPaibaning = false
  }
}
// 生成操作记录
function genFinalRecordFn(current: any, ori: any, callback = null) {
  let recordData = {
    key: '',
    operateArr: [
      {
        key: '余料自动裁剪',
        dataArr: [
          {
            type: 'form',
            current,
            ori,
            compareMsg: [
              {
                title: '裁剪最大尺寸',
                keys: ['isSetCustomRect', 'customRectTemplate'],
              },
            ],
            formTextObj: {
              isSetCustomRect: '设置不同厚度板件最小裁剪尺寸',
              customRectTemplate: '设置不同厚度板件最小裁剪尺寸模板',
            },
          },
        ],
      },
    ],
  }
  genFinalRecord(recordData, 'paiban_setting', '', () => {})
}
// 超尺板件数据
const extraLongPlates = ref<INewMaterialListExtraPartType[]>([])

const extraLongPlatesIndex = ref(1)
// 超尺板件数据根据当前的index进行动态获取
const currentExtraLongPlatesItem = computed(() => {
  return extraLongPlates.value[extraLongPlatesIndex.value - 1]
})

// 需要添加的特殊大板
const bigPlateList = ref<IAutoAddPlankFieldsType[]>([])

// 根据超尺小板列表，计算出要添加的特殊大板的尺寸数据
const calculateBigPlateList = (
  extraLongPlates: INewMaterialListExtraPartType[]
) => {
  // 将超尺小板进行分类
  const extraLongPlatesGroup = extraLongPlates.reduce((acc, part) => {
    if (!acc[part.symbol]) {
      acc[part.symbol] = []
    }
    acc[part.symbol].push(part)
    return acc
  }, {} as Record<string, Array<INewMaterialListExtraPartType>>)
  const result: IAutoAddPlankFieldsType[] = []
  const sawToLayout =
    store.state.ncSetting.sawSetting.mentaoji_enable &&
    store.state.ncSetting.sawSetting.sawToLayout &&
    store.state.ncSetting.sawSetting.processType === 'weldingPlank'
  const default_oversize_plank_value =
    materialInfo.value?.default_oversize_plank_value
  Object.keys(extraLongPlatesGroup).forEach((key) => {
    const keyArr = key.split(':')
    let height: number | string = ''
    let width: number | string = ''
    const parts = extraLongPlatesGroup[key]
    const maxHeight = Math.max(...parts.map((item) => item.originHeight))
    if (
      parts.every(
        (part) => part.originHeight <= 2440 && part.originWidth <= 1220
      )
    ) {
      height = 2440
      width = 1220
    } else if (
      parts.some((part) => part.originWidth <= 1220) &&
      maxHeight > 2440 &&
      maxHeight <= 2750
    ) {
      height = 2750
      width = 1220
    } else if (
      parts.some((part) => part.originHeight > 2750 || part.originWidth > 1220)
    ) {
      height = ''
      width = ''
    }
    // 要是有旋转的话不用推荐值，用户自己手动输入
    if (sawToLayout) {
      height = ''
      width = ''
    }

    if (parts.some((part) => part.texDir === 'reverse')) {
      height = ''
      width = ''
    }

    // 如果勾选了设置超尺特殊大板的默认添加尺寸，则使用设置的默认尺寸
    if (default_oversize_plank_value?.checked) {
      height = default_oversize_plank_value.height
      width = default_oversize_plank_value.width
    }

    result.push({
      matCode: keyArr[0],
      thick: Number(keyArr[1]),
      color: keyArr[2],
      height: height,
      width: width,
      isPicked: false,
      trim_edge: selectStandardPlank.value.plankEdgeOff,
      is_high_gloss_plank: keyArr[3] === 'true' ? 1 : 0, //原片中的数据存储的值为1，0
    })
  })
  return result
}

// 查看超尺板件清单
const handleViewExtralPlateList = () => {
  showAddSpecialPlate.value = false
  showBigPlateDetail.value = true
}
// 关闭添加超尺板件弹窗
const handleCloseAddSpecialPlate = () => {
  showAddSpecialPlate.value = false
}

// 添加特殊的loadding状态
const isAddBigPlateLoading = ref(false)
//  超尺板件一键添加
const handleAddBigPlate = () => {
  try {
    isAddBigPlateLoading.value = true
    if (bigPlateList.value.some((item) => !item.height || !item.width)) {
      message.warning(translateLang('请填写板件的长宽！'))
      return
    }
    saveSpecialPlank()
  } catch (error) {
    console.log(error)
  } finally {
    setTimeout(() => {
      isAddBigPlateLoading.value = false
    }, 500)
  }
}

// 保存添加的特殊大板
const saveSpecialPlank = async () => {
  if (!bigPlateList.value?.length) {
    message.info('添加板件不能为空')
    return
  }

  const allPlankInfo = materialInfo.value?.specialPlankInfo || []

  bigPlateList.value.forEach((item) => {
    allPlankInfo.forEach((speItem) => {
      if (materialInfo.value && !materialInfo.value.isAutoSelected) {
        if (
          item.matCode == speItem.matCode &&
          item.color == speItem.color &&
          item.thick == speItem.thick
        ) {
          speItem.isPicked = false
        }
      }
    })
    if (materialInfo.value && !materialInfo.value?.isAutoSelected) {
      item.isPicked = true
    }
    item.height = Number(item.height)
    item.width = Number(item.width)
    item.trim_edge = selectStandardPlank.value.plankEdgeOff
    item.matCode = item.is_high_gloss_plank
      ? `高光_${item.matCode}`
      : item.matCode
  })

  // 品牌大板记录不参与普通特殊大板 API 保存
  const normalPlanks = allPlankInfo.filter((item: any) => !isBrandRecord(item))

  const payLoad = {
    uid: userInfo.value.id,
    data: {
      specialPlankInfo: [...normalPlanks, ...bigPlateList.value],
    },
  }
  try {
    const res = await fetchSaveBaseMaterial(payLoad)
    if (res.status !== 1) {
      message.error(translateLang('添加特殊大板失败'))
      throw '添加特殊大板失败'
    }

    message.success(translateLang('添加特殊大板成功'))
    setTimeout(() => {
      // 重新开始计算排版数据
      showAddSpecialPlate.value = false
      showBigPlateDetail.value = false
      bigPlateList.value = []
      paibanParams.value.isPaibaning = true
      dealLayoutData(paibanSettingState.value)
    }, 0)
  } catch (error) {
    throw {
      message: '添加特殊大板失败',
      error,
    }
  }
}

// 删除添加的特殊大板
const handleDelBigPlate = (index: number) => {
  bigPlateList.value.splice(index, 1)
}
// 特殊大板尺寸输入检测 FIX: 对输入数字处理的正则被注释，会影响格式化
const handleCheckSpecialPlateSize = (val: string, row: any, prop: string) => {
  val += ''
  val = val
    .replace(/[^\d.]/g, '') // 去除数字和小数点以外的数字
    .replace(/\.{2,}/g, '.') // 去除多余小数点
    .replace('.', '@_@') // 将小数点暂存为其他字符
    .replace(/\./g, '') // 替换多余的小数点, 防止输入时的闪烁
    .replace('@_@', '.') // 将暂存的小数点替换回来
    .replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
  // 限制输入0
  if (Number(val) === 0) {
    val = ''
  }
  row[prop] = val
  if (row.width < 1220) {
    row.showWInputIcon = true
  } else {
    row.showWInputIcon = false
  }
}

// 从超尺小板列表返回上一级
const handleGoBackToAddExtraLongPlates = () => {
  showBigPlateDetail.value = false
  showAddSpecialPlate.value = true
}

// 是否勾选超尺时，选用更大特殊大板
const autoAddSpecialPlate = ref(false)

// 查看超尺板件详情
const handleViewExtralPlateDetail = (item: any) => {
  showAddBaseMModal.value = false
  isShowPlateDetails.value = true
  let ele = document.querySelector('.new-material-list')
  ele?.scrollIntoView({ block: 'end' })
}

// 跳转到原片管理页面
const handleToBaseMaterial = () => {
  router.push({
    path: '/baseMaterial',
  })
}

// 查看板件详情返回上一级
const handleGoBack = () => {
  isShowPlateDetails.value = false
  showAddBaseMModal.value = true
}

// 切换超尺板件
const handleToggleExtraPlate = (type: 'last' | 'next') => {
  if (type === 'last') {
    extraLongPlatesIndex.value--
    if (extraLongPlatesIndex.value === 0) {
      extraLongPlatesIndex.value = extraLongPlates.value.length
    }
  } else {
    extraLongPlatesIndex.value++
    if (extraLongPlatesIndex.value === extraLongPlates.value.length + 1) {
      extraLongPlatesIndex.value = 1
    }
  }
}
// 保存原片信息
const materialInfo = ref<
  Awaited<ReturnType<typeof getRawMaterialPlankInfo>>['data'] | null
>(null)

const needBaseMaterials = ref<INewMaterialListSpecialPlankType[]>([])

// 校验使用到的刀具是否符合规则
const judgePlateKnife = (
  plate_knife_map: Record<string, IPlankKnifeMapType>,
  selectedParts: PartType[]
) => {
  if (!plate_knife_map || !selectedParts.length) return
  const planksArr: string[] = []
  selectedParts.forEach((item) => {
    planksArr.push(
      item.typeSymbol.split(':')[0] + ':' + item.typeSymbol.split(':')[1]
    )
  })
  const knifesArr = Object.keys(plate_knife_map).map((item) => {
    if (Number(item.split('.')[1]) == 0) {
      item = item.split('.')[0]
    }
    return item
  })

  if (!intersection(knifesArr, planksArr)) return

  // 如果开启了激光一体机 则不校验原片刀具
  if (store.state.ncSetting.laser_enable) return

  let errorKnifeName: string[] = []
  for (const key in plate_knife_map) {
    let error = plate_knife_map[key].error
    if (error && planksArr.includes(key.split('.')[0])) {
      // 添加逻辑：将匹配上的错误原片刀具名字添加到数组中
      errorKnifeName.push(plate_knife_map[key].knife)
    }
  }
  // 添加逻辑：匹配上的原片刀具没有错误，则不返回错误
  if (errorKnifeName.length) {
    isError.value = true
    paibanParams.value.isPaibaning = false
    let errorMsg = `<strong>已开启不同材质下料刀</strong>，该生产线下料刀<strong>（${errorKnifeName.join(
      '、'
    )}）</strong>直径为空，请前往添加对应刀径`

    vm?.proxy
      .$confirm(errorMsg, translateLang('提示'), {
        confirmButtonText: translateLang('前往添加'),
        cancelButtonText: translateLang('取消'),
        type: 'warning',
        dangerouslyUseHTMLString: true,
      })
      .then(() => {
        const setting_id = paibanFormData.value.process_line_id + ''
        const line = selectProLine.value.name
        const equipType = 'engraving'
        router.push({
          path: `/${equipType}`,
          query: {
            setting_id,
            line,
            equipType,
          },
        })
      })
      .catch(() => {
        isError.value = false
        throw new Error('不同材质下料刀校验失败')
      })
  }
}

// const intersection = (a: any[], b: any[]) => {
//   const s = new Set(b)
//   a = a.filter((x) => s.has(x))
//   let isMate = false
//   if (a.length !== 0) {
//     isMate = true
//   } else {
//     isMate = false
//   }
//   return isMate
// }

// 旧版xy提示
const oldFiveSixXYTip = (status: number) => {
  if (status == 499) {
    if (vm?.proxy?.$confirm && vm?.proxy?.$createElement) {
      const createElement = vm.proxy.$createElement
      vm.proxy
        .$confirm(
          createElement('p', null, [
            createElement(
              'i',
              { style: 'color: red' },
              `${translateLang('五六面钻模板过老')}，`
            ),
            createElement(
              'span',
              null,
              `${translateLang('请联系售后人员更换对接模板')}！`
            ),
          ]),
          translateLang('警告'),
          {
            confirmButtonText: translateLang('确定'),
            showCancelButton: false,
            type: 'warning',
          }
        )
        .catch(() => {})
    }
    paibanParams.value.isPaibaning = false
    isShowPaibanModal.value = false
    showSyncGuiguiBaseMModal.value = false
    showAddBaseMModal.value = false
    return true
  } else {
    return false
  }
}

// 检验板件之间长宽是否匹配
const checkPlankIsAvailable = (
  texDir: 'notcare' | 'normal' | 'reverse',
  rect: { width: number; height: number },
  rectInfo: { width: number; height: number }
) => {
  if (texDir !== 'notcare') {
    return rect.width <= rectInfo.width && rect.height <= rectInfo.height
  } else {
    const [partMin, partMax] = [rect.width, rect.height].sort((a, b) => a - b)
    const [plankMin, plankMax] = [rectInfo.width, rectInfo.height].sort(
      (a, b) => a - b
    )
    return partMin <= plankMin && partMax <= plankMax
  }
}

const errorPathPlankID = computed(() => store.state.errorPathPlankID)

// 是否使用急速排版
const isNewLayout = ref(false)

// 判断参与排版的板件中是否有指定下料刀
const dealMaterialKnife = (resData: any, finalSelectPlankList: any) => {
  const matCodeList = resData.map(
    (item: any) => `${item.matCode}:${item.thick}`
  )
  const paibanMatCodeList = finalSelectPlankList.map(
    (item: any) => `${item.matCode}:${item.thick}`
  )
  return paibanMatCodeList.some((item: any) => matCodeList.includes(item))
}

const dealReadPaibanData = async (
  selectionPlankList: PartType[],
  ncSetting: NCSettingType,
  bujianList: PartType[],
  awaitStoreData: PartType[]
) => {
  // 补件仓库数据 改为外部传入
  // const bujianData = await bujianTableRef.value?.analyzeLayoutToPaiban()
  // const bujianList = (bujianData?.plank_data ?? []) as unknown as PartType[]
  // // 待排版仓库数据
  // const awaitStoreData = (await awaitStoreRef.value?.getAwaitStorePlank()) ?? []
  // 排版前清空本地缓存的待排版库数据
  store.commit('awaitPaibanStore/clear')
  // 保存本次排版所使用的补件
  store.commit('setAvailableBujianList', bujianList)
  // 补件一同参与排版
  let finalSelectPlankList = [
    ...selectionPlankList,
    ...bujianList,
    ...awaitStoreData,
  ]

  const colorMap: Record<string, Array<string>> = {}
  // 根据混排方案，对板件进行处理,修改满足要求的小板的颜色
  if (storePreferencesSetting.value?.enableMixPaiban) {
    finalSelectPlankList = finalSelectPlankList.map((part) => {
      const { texture, matCode, thick } = part
      const plan = selectedMixPaibanPlans.value.find((plan) =>
        matchMixPaibanPlan(plan, { matCode, texture })
      )
      // 这个大板符合混排方案，则同步修改小板数据
      if (plan) {
        const { targetTexture, originTexture } = plan
        const key = `${targetTexture}:${matCode}:${thick}`
        if (!colorMap[key]) {
          colorMap[key] = [...originTexture]
        }
        return {
          ...part,
          texture: targetTexture,
          oriTexture: part.texture,
        }
      }
      return part
    })

    if (selectedMixPaibanPlans.value.every((plan) => !plan.isSelected)) {
      store.commit('materialListStore/setColorMap', {})
    } else {
      store.commit('materialListStore/setColorMap', colorMap)
    }
  }

  // 多材质不同下料刀
  const moreMatCodePaibanData = dealMorePlateKnife(
    finalSelectPlankList,
    ncSetting
  )
  const fnialList: Array<ReturnType<typeof layoutStart>> = []
  // prePaibanData进行push操作
  store.commit('setIsSinglePushPrePaibanData', true)
  // 清空perPaibanData
  store.commit('setPrePaibanData', [])
  let doorFrameErr = false
  moreMatCodePaibanData.forEach((paibanData) => {
    const {
      preLayoutData,
      setting: { diameter },
    } = paibanData
    const nc = JSON.parse(JSON.stringify(ncSetting))
    if (!nc.laser_enable) {
      // 如果未开启激光一体机，则使用多材质不同下料刀的直径
      nc.knife.diameter = diameter
    }
    const frameDoorSpliceData = dealFrameDoorSplice(preLayoutData, diameter)
    changeLayoutData(frameDoorSpliceData)
    // 进行排版前的板件处理
    const val = layoutStart(nc)
    if (val && val.layout?.isErr) {
      paibanParams.value.isPaibaning = false
      plankErrVisible.value = true
      plankErrMsg.value = translateLang(
        '板件内部异形数据错误,请检查是否符合刀具规格!板号【{plankIDList}】',
        { plankIDList: val?.layout?.hasErrPathList?.join('、') || '' }
      )
      return
    }
    if (val && val.layout?.isDoorFrameErr) {
      paibanParams.value.isPaibaning = false
      doorFrameErr = true
      Modal.error({
        title: translateLang('提示'),
        content: val.layout.errMsg,
      })
      return
    }
    fnialList.push(val)
  })
  if (plankErrVisible.value) return
  if (doorFrameErr) return
  store.commit('setIsSinglePushPrePaibanData', false)
  if (errorPathPlankID.value.length) {
    paibanParams.value.isPaibaning = false
    showSyncGuiguiBaseMModal.value = false
    Modal.error({
      title: translateLang('提示'),
      content: translateLang(
        '板件内部存在异常数据（板号：{errorPathPlankID}），请检查！',
        {
          errorPathPlankID: errorPathPlankID.value,
        }
      ),
    })
    return
  }
  // 当前排版的小板没有匹配上接口返回的原片下料刀数据，说明没有匹配上设置的原片刀具数据
  // 这里需要校验一下生产线设置的刀具数据

  if (fnialList.some((it) => !it) || !fnialList.length) {
    paibanParams.value.isPaibaning = false
    showSyncGuiguiBaseMModal.value = false
    let content = ''

    if (!ncSetting.laser_enable) {
      // 未开启激光一体机
      // 未开启"不同材质下料刀"时:
      content = translateLang(
        '该生产线下料刀（{name}）直径为空，请前往添加对应刀径!',
        { name: ncSetting.knife?.name }
      )
      const resData = await getBlankTableList()
      let isDealMaterialKnife = dealMaterialKnife(
        resData.data.data,
        finalSelectPlankList
      )
      if (isDealMaterialKnife) {
        // 开启"不同材质下料刀"时:
        content = `${translateLang('已开启不同材质下料刀')}，${content}`
      }
      content = content
        .replace(/（([^）]+)）/g, '<strong>（$1）</strong>')
        .replace(
          /已开启不同材质下料刀/g,
          '<strong>已开启不同材质下料刀</strong>'
        )
    } else {
      // 开启激光一体机

      // 检查正面刀库（knife）激光刀
      // if (!ncSetting.knife?.diameter) {
      //   errorList.push(`正面刀库-激光刀（${ncSetting.knife?.name || '未知'}）`)
      // }
      // if (!ncSetting.back_knives?.diameter) {
      //   errorList.push(
      //     `反面刀库-激光刀（${ncSetting.back_knife?.name || '未知'}）`
      //   )
      // }
      //  遍历正面反面刀库 找到下料刀 判断是否为空
      const knivesErrorList: string[] = []
      let knivesErrorString = ''
      Object.values(ncSetting.knives || {}).forEach((item: any) => {
        if (item.type === 'laser' && !item.diameter) {
          knivesErrorList.push(`激光刀（${item.name || '--'}）`)
        }
        if (item.cutable === true && !item.diameter) {
          knivesErrorList.push(`下料刀（${item.name || '--'}）`)
        }
      })
      if (knivesErrorList.length) {
        knivesErrorString = `正面刀库-${knivesErrorList.join('、')}，`
      }

      const backKnivesErrorList: string[] = []
      let backKnivesErrorString = ''
      Object.values(ncSetting.back_knives || {}).forEach((item: any) => {
        if (item.type === 'laser' && !item.diameter) {
          backKnivesErrorList.push(`激光刀（${item.name || '--'}）`)
        }
        if (item.cutable === true && !item.diameter) {
          backKnivesErrorList.push(`下料刀（${item.name || '--'}）`)
        }
      })
      if (backKnivesErrorList.length) {
        backKnivesErrorString = `反面刀库-${backKnivesErrorList.join('、')}`
      }

      content = `该生产线下${knivesErrorString}${backKnivesErrorString} 直径为空，请前往添加对应刀径`
    }

    vm?.proxy
      .$confirm(content, translateLang('提示'), {
        confirmButtonText: translateLang('前往添加'),
        cancelButtonText: translateLang('取消'),
        type: 'warning',
        dangerouslyUseHTMLString: true,
      })
      .then(() => {
        const setting_id = paibanFormData.value.process_line_id + ''
        const line = selectProLine.value.name
        const equipType = 'engraving'
        router.push({
          path: `/${equipType}`,
          query: {
            setting_id,
            line,
            equipType,
          },
        })
      })
      .catch(() => {
        isError.value = false
        throw new Error('不同材质下料刀校验失败')
      })
    return
  }

  if (fnialList.length) {
    const newList = fnialList.filter((i) => i)
    const slotErrList = newList.filter((i) => {
      return i && i.layout?.isErr
    })

    if (slotErrList.length) {
      paibanParams.value.isPaibaning = false
      showSyncGuiguiBaseMModal.value = false
      Modal.error({
        title: translateLang('提示'),
        content: slotErrList[0] ? slotErrList[0].layout?.errMsg : '',
      })
      return
    }
  }
  const resultArr = fnialList.map((item) => {
    if (typeof item === 'object') {
      return dealLayoutResultData(
        item,
        needBaseMaterials.value,
        paibanFormData.value,
        ncSetting,
        store,
        isNewLayout.value,
        materialInfo.value!.only_layout_too_big
      )
    }
  })
  if (resultArr.some((item) => !item)) {
    paibanParams.value.isPaibaning = false
    plankErrVisible.value = true
    return
  }
  const surLockRe = await handleSurplusLock()
  if (surLockRe) {
    // 过滤掉与仅加工孔槽板件匹配的余料
    const currentLine = proLineList.value.find(
      (item) => item.id === ncSetting.process_setting_id
    )
    const filteredSurplusList = filterSurplusByNoCutPlanks(
      surplusList.value,
      finalSelectPlankList,
      currentLine
    )
    // 处理余料数据 准备排版数据
    await dealSurplusParams(filteredSurplusList, ncSetting, resultArr, store)
  }
}

// 余料锁定处理
// : Promise<ISurplusType[] | false>
const handleSurplusLock = async (): Promise<boolean> => {
  let allSurplusList: Array<ISurplusType> = JSON.parse(
    JSON.stringify(surplusList.value)
  )
  let selectSurplusList = allSurplusList.filter((item) => item.isSelected)
  let oldSelectSurplusList = store.state.selectSurplusList.map(
    (item: ISurplusType) => item.id
  )

  // 开启余料锁定 且选了余料
  if (preferencesSetting.value.surplus_lock && selectSurplusList.length) {
    store.commit(
      'setSelectSurplusList',
      surplusList.value.filter((sur) => sur.isSelected)
    )
    // 排版之前锁定勾选的余料（假锁）
    const lockParams = {
      surplus: selectSurplusList.map((item) => ({
        ...item,
        lock_num: item.amount,
        lock_status: 1,
      })),
      release_all: false,
    }
    const lockRes = await surplusLock(lockParams)
    // 存在选中的余料大板被其他排版使用中，请稍后再试
    if (lockRes.status == 0) {
      Vue.prototype.$message.error(lockRes.msg)
      paibanParams.value.isPaibaning = false
      return false
    } else if (lockRes.data.length) {
      // 更新柜柜添加余料的 ggid
      allSurplusList.forEach((item) => {
        lockRes.data.forEach((resItem: any) => {
          if (item.id == resItem.origin_data.id) {
            item.ggid = resItem.origin_data.ggid
          }
        })
      })
      // 获取锁定后最新的余料 并更新id（柜柜添加的余料，进行锁定后，id会变化，因为是存在不同的表里的）
      await getSurplusList()
      surplusList.value.forEach((item) => {
        allSurplusList.forEach((allItem) => {
          if (
            item.ggid == allItem.ggid &&
            item.lock_order == allItem.lock_order
          ) {
            // allItem.id = item.id
            item.isSelected = allItem.isSelected
          }
        })
      })
      selectSurplusList = surplusList.value.filter((item) => item.isSelected)
      store.commit('setSelectSurplusList', surplusList.value)
    }

    // 解锁未勾选的余料 存在第一次勾选使用了 第二次切到开料清单未勾选排版 还被锁定的情况
    const unlockOldSurplusList = surplusList.value.filter(
      (item) => oldSelectSurplusList.includes(item.id) && !item.isSelected
    )
    if (unlockOldSurplusList.length) {
      const unLockParams = {
        surplus: unlockOldSurplusList.map((item) => ({
          ...item,
          lock_num: item.amount,
          lock_status: 0,
        })),
        release_all: false,
      }
      await surplusLock(unLockParams)
    }
  }
  return true
}

// 处理余料参数和排版参数
const dealSurplusParams = async (
  allSurplusList: ISurplusType[],
  ncSetting: NCSettingType,
  resultArr: ReturnType<typeof dealLayoutResultData>[],
  store: any
) => {
  // 生成余料参数
  const surplusObj = genSurplusParams(allSurplusList)
  const paramObjArr: Array<ReturnType<typeof genPaibanRequestParams>> = []
  resultArr.forEach((item) => {
    const result = item?.result
    if (result) {
      const paramObj = genPaibanRequestParams(store, surplusObj, result, 0)
      paramObjArr.push(paramObj)
    }
  })
  await getPaibanData(paramObjArr, ncSetting)
}

const prePaibanData = computed(() => store.state.prePaibanData)

// 创建排版任务操作记录
const saveTaskOperationRecord = async (taskBatch: string) => {
  const record = [
    {
      key: '开料清单',
      value: [
        {
          key: '排版任务',
          value: [
            {
              key: '创建任务',
              oldValue: '任务批次',
              value: taskBatch,
            },
          ],
        },
      ],
    },
  ]
  saveDataJsonToOssForRecord(
    record,
    '开料清单',
    { id: store.state.userInfo.id },
    () => []
  )
}

// 获取排版接口的数据, 并处理成绘制的数据
const getPaibanData = async (
  data: ReturnType<typeof genPaibanRequestParams>[],
  ncSetting: NCSettingType
) => {
  beforePaibanDataDeal()
  store.commit('setFinalDrawData', [])
  let paibanWay = paibanFormData.value.paibanWay
  if (ncSetting.glass_setting) {
    paibanWay = 'paiban'
  }
  // store.commit('paibanStore/setPaibanDataCollect', [])
  store.commit('paibanStore/clearAlreadyDealDrawData')
  store.commit('setPaibanData', [])
  const isPreLayout = store.state.ncSetting.isPreLayout
  const { safe_length = [], scattered_layout = false } = isPreLayout
    ? store.state.preLayoutSetting.setting_value.movePlankSetting
    : store.state.ncSetting.movePlankSetting

  // paibanParams.value.isPaibaning = false
  const res = await dealPaibanData(
    data,
    prePaibanData.value,
    paibanWay,
    true,
    true,
    true,
    isNewLayout.value,
    scattered_layout,
    safe_length,
    { isCreateTask: isCreateTask.value }
  )

  const order_nos = Array.from(
    new Set(prePaibanData.value.map((p) => p.orderNo))
  ).join(',')

  if (isCreateTask.value) {
    // 创建排版任务：成功且飞行动效结束后再关闭弹窗
    const preLayoutData = getAllParts(plankList.value)
    const taskBatch = await paibanSettingRef.value?.createPaibanTask({
      data: res,
      prePaibanData: prePaibanData.value,
      paibanWay,
      preLayoutData,
      order_nos,
    })
    store.dispatch('paibanTaskStore/fetchPaibanTaskList', {
      page: 1,
      limit: 10,
    })
    if (taskBatch) {
      buryPointApi('material', 'paiban_task_created')
      saveTaskOperationRecord(taskBatch)
      isShowPaibanModal.value = false
    }
    isConfirmLoading.value = false
    return
  }
  store.commit('setIsNewPaiban', Boolean(hasSendToTask.value))
  store.commit('setHistoryPlankEdgeOff', selectStandardPlank.value.plankEdgeOff)
  store.commit('setHistorySecondTrimValue', ncSetting.secondTrimValue)
  store.commit('deleteTempStorage', 'clear')
  // FIX
  if (!res) {
    paibanParams.value.isPaibaning = false
    return
  }
  store.commit('setActivePaibanWay', [paibanWay])
  _hmt.push(['_trackEvent', '开始排版', 'click'])
  // 排版超时和重新排版
  if (res.isPaibanErr) {
    isPaibanErr.value = res.isPaibanErr
    isNotSawKnife.value = res.notSawRFlag
    paibanParams.value.isPaibaning = false
    isNewLayout.value = true
    return
  }
  if (res?.isErr) {
    message.error(translateLang('排版失败，存在大板数量不足或小板超尺'))
    // Vue.prototype.$message({
    //   message: translateLang('排版失败，存在大板数量不足或小板超尺'),
    //   type: 'error',
    // })
    paibanParams.value.isPaibaning = false
    isShowPaibanModal.value = true
    paibanMessage.value = res.message
    return
  }

  // 存在过大的板件
  if (res.isOverSize) {
    paibanParams.value.isPaibaning = false
    showSyncGuiguiBaseMModal.value = false
    const size =
      res.text
        ?.trim()
        ?.split(':')
        ?.pop()
        ?.split(' ')
        ?.filter((s: string) => s) || []
    let content = `${translateLang('存在过大板件！小板尺寸：{width}-{height}', {
      width: size[0],
      height: size[1],
    })}`
    if (res.text.includes('超出台面')) {
      content += ` ${translateLang('台面宽度')}：${ncSetting.counter_width}mm`
    }

    Modal.error({
      title: translateLang('提示'),
      content,
      width: res.text.includes('超出台面') ? 500 : 400,
    })
    return
  }
  const queryParams: {
    from?: string
    isSpecialShape?: string
    setting_id?: string
  } = {}

  if (isFromLbl.value) {
    queryParams.from = 'lbl'
  } else if (paibanFormData.value.isSpecialShape) {
    queryParams.isSpecialShape = String(paibanFormData.value.isSpecialShape)
  } else {
    queryParams.setting_id = String(paibanFormData.value.process_line_id)
    queryParams.from = 'material_paiban'
  }
  // 清空有可能上一次是从历史记录跳过去保存的排版批次，避免影响到本次排版(本次不需要展示排版批次)
  sessionStorage.removeItem('layout_batch')
  store.commit('setPaibanTaskObj', null)
  router.push({
    path: '/newPaiban',
    query: queryParams,
  })

  // 到此处，说明排版成功了，对之前的修改记录进行保存
  saveOperateRecord()
  // 开料清单重新排版 批量补标签数据置为空
  store.commit('setBatchTaggingList', [])
}
// 排版前的综合数据处理，如数据初始化，以及某些数据清空
const beforePaibanDataDeal = () => {
  // 新的排版重置待排版库未入库提示
  store.commit('awaitPaibanStore/setIsNoPromptPushStore', false)
}

const isCanContinue = ref(false)
const orderIds = ref<string[]>([])
const proucePopupState = ref<ProucePopupState>({
  mark_action: 1,
  is_produced_orders: true,
  is_display_mark: true,
})
const isShowOrderMark = ref(false)

// 排版Setting组件实例
const paibanSettingRef = ref<InstanceType<typeof PaibanSetting> | null>(null)

// 补件表格实例
const bujianTableRef = ref<InstanceType<typeof MBujianTable> | null>(null)
// 订单生产标记点击导出
const handleOrderMarkOk = async () => {
  isShowOrderMark.value = false
  isCanContinue.value = true
  // 这里需要传参
  handleProlineIsElectronicSaw(paibanParams.value.isSendToFactory)
  const params = {
    ...preferencesSetting.value,
    ...paibanFormData.value,
  }
  updateLocalPreference(params as any, ({ isErr }) => {
    if (isErr) {
      isConfirmLoading.value = false
    } else {
      store.commit('setActivePaibanWay', [paibanFormData.value?.paibanWay])
    }
  })
  if (!orderIds.value.length) return
  // 更新标记状态
  const data = {
    order_ids: [...new Set(orderIds.value)],
    mark_action: proucePopupState.value.mark_action,
  }
  await updateProduceStatus(data as any)
}
// 订单生产标记点击取消
const handleOrderMarkCancel = () => {
  isShowOrderMark.value = false
  isCanContinue.value = false
}
const handleShowOrderMark = async () => {
  // 每一块小板都有orderId（柜柜过来的数据）
  // filter过滤掉无效orderId 类似于false null undefined之类的值
  const allPartOrderIds = selectedParts.value
    .map((item) => item.orderId)
    .filter((item) => item)
  // 存在没有orderId的板件
  if (allPartOrderIds.length !== selectedParts.value.length) {
    isCanContinue.value = true
    return
  }

  const ggOrderIds = localStorage.getItem('ggOrderIds')
  const filterGGIds = ggOrderIds ? JSON.parse(ggOrderIds) : []

  // 计算 filterGGIds 中每个值的重复次数
  const countMap = filterGGIds.reduce((map: any, value: any) => {
    map.set(value, (map.get(value) || 0) + 1)
    return map
  }, new Map())
  // 深拷贝一下,避免后续操作对源数据产生影响
  orderIds.value = cloneDeep(allPartOrderIds)
  // 过滤 this.orderIds 中包含在 filterGGIds 中的值，并确保输出数组中每个值的重复次数不超过 filterGGIds 中的重复次数
  orderIds.value = orderIds.value.filter((value) => {
    if (countMap.has(value) && countMap.get(value) > 0) {
      countMap.set(value, countMap.get(value) - 1)
      return true
    }
    return false
  })

  // 应该是判断选择的板件
  const isAllBujian = selectedParts.value.every((item) => item._isBujian)
  if (!orderIds.value.length || isAllBujian) {
    isCanContinue.value = true
    return
  }
  const data = {
    order_ids: [...new Set(orderIds.value)], //此次排版的订单号
  }

  const proucePopupStateRes = await getProucePopupState(data)
  if (proucePopupStateRes.status) {
    const { data } = proucePopupStateRes
    Object.assign(proucePopupState.value, data)
  }
  if (
    proucePopupStateRes.data.is_display_mark ||
    proucePopupStateRes.data.is_produced_orders
  ) {
    isShowOrderMark.value = true
  } else {
    isShowOrderMark.value = false
  }
}

// 试生产弹窗组件实例
const trialRef = ref<typeof MTryProductionDialog | null>(null)

// 自定义文件设置
const customizeFolderSetting =
  ref<Awaited<ReturnType<typeof getCustomFolderSetting>>['data']>()

const userInfo = computed(() => store.state.userInfo)

// 保存NC文件的ossurl
const NCUrls = ref<ISmtFileResponse[]>([])

const folderChooseModalRef = ref<InstanceType<
  typeof GFolderChooseModal
> | null>(null)
// 电子锯文件处理
const handleProlineIsElectronicSaw = async (isSendToFactory = false) => {
  // 检查本地所使用的目录是否存在
  if (!isSendToFactory && !(await folderChooseModalRef.value?.verify())) return
  const isShowTrialDialog = await trialRef.value?.checkUserSettingStatus(
    selectProLine.value.id
  )

  // 需要进行试生产
  if (isShowTrialDialog) {
    isShowPaibanModal.value = false
    return
  }
  isShowPaibanModal.value = false

  // 显示排版状态弹窗
  paibanParams.value.isPaibaning =
    (isShowOrderMark.value && isCanContinue.value) || !isShowOrderMark.value

  // 获取选中的补件数据
  const bujianData = await bujianTableRef.value?.analyzeLayoutToPaiban()
  const bujianList = bujianData?.plank_data ?? []
  // 待排版仓库数据
  const awaitStoreData = (await awaitStoreRef.value?.getAwaitStorePlank()) ?? []

  const parts: (PartType & { newTexture?: string })[] = [
    ...bujianList,
    ...awaitStoreData,
  ] as unknown as PartType[]
  const selectParts = cloneDeep(selectedParts.value)
  const saw_setting_res = await getSaeSetting({
    setting_id: paibanFormData.value.process_line_id,
    setting_type: 'electronicSaw',
  })
  selectParts.forEach((part: PartType) => {
    // 电子锯下载如果是横纹需要表现的和页面上一样的尺寸，但又不改变纹理的字段需要做此处理
    if (part.texDir === 'reverse') {
      // 开启电子锯 横纹板件长宽对调 就不做这个处理 并且把横纹变成竖纹 客户要的就是这个
      if (!saw_setting_res.data.data.texture_reversed_len_width) {
        rotatePlank(part, -1)
      } else {
        part.texDir = 'normal'
      }
    }
    parts.push(part)
  })
  // 对所有参与排版的数据做处理
  for (const plank of parts) {
    const { matCode, texture } = plank
    if (plank.slots.length !== 0 || plank.holes.length !== 0) {
      const holeSide = plank.holes.every((item) => item.side === -1)
      const slotSide = plank.slots.every((item) => item.side === -1)
      if (holeSide && slotSide) {
        reversalPlank(plank)
      }
    }
    // 根据小板的高光属性对小板的matCode做处理
    if (plank.is_high_gloss_plank && !plank.matCode.includes('高光_')) {
      plank.matCode = `高光_${plank.matCode}`
    }

    // 开启了混排
    if (storePreferencesSetting.value?.enableMixPaiban) {
      // 根据混排方案，修改参与小板的texture和oriTexture
      const mixPlan = selectedMixPaibanPlans.value.find((plan) =>
        matchMixPaibanPlan(plan, { matCode, texture })
      )
      // 这个大板符合混排方案，则同步修改小板数据, 电子锯， texture 还是存储原始颜色， oriTexture 存储混排后的颜色(我想用oriTexture，但是后端不太想用)
      if (mixPlan) {
        plank.newTexture = mixPlan.targetTexture || texture
      }
    }
  }
  if (!paibanFormData.value?.process_line_id) return

  const customFolderSettingRef = await getCustomFolderSetting({
    setting_id: paibanFormData.value?.process_line_id,
  })
  if (customFolderSettingRef.status === 1) {
    customizeFolderSetting.value = customFolderSettingRef.data
  }
  const currentProline = proLineList.value.find(
    (item) => item.id === paibanFormData.value.process_line_id
  )
  const isSawToExportPartData =
    currentProline.data.cuttingEquipment === 'engraving' &&
    currentProline.data.saw_setting.saw_enable &&
    currentProline.data.saw_setting.saw_aio

  const params = {
    uid: userInfo.value.id,
    process_id: paibanFormData.value.process_line_id,
    layoutData: parts,
    saw_aio: isSawToExportPartData,
  }
  collector.clear()
  collector.setOriginParts(window.$copy(parts))
  collector.setNcSetting(window.$copy(ncSetting.value ?? {}))
  const swaFileRes = await fetchGenerateSmtFile(params)
  if (swaFileRes.status === 1) {
    if (swaFileRes.data.status === 0) {
      Vue.prototype.$message.error(swaFileRes.data.msg)
      isTaskLoading.value = false
      paibanParams.value.isPaibaning = false
      return
    }

    // 发送试生产记录到后端
    if (isTrialProduct.value) {
      sendTrialRecord(swaFileRes.data, {
        process_setting_id: selectProLine.value.id,
        process_setting_name: selectProLine.value.name,
      })
    }

    downloadFile(swaFileRes.data, parts, isSendToFactory)

    // 下载电子锯数据时， 保存此次的操作历史
    saveOperateRecord()
  }
}

const repeatFileNameList = ref<any[]>([])
const repeatFolderNameList = ref<any[]>([])
const repeatNameList = ref<any[]>([])

const isShowWarningModal = ref(false)

// 下载NC/电子锯文件
const downloadFile = async (
  arr: ISmtFileResponse[],
  parts: PartType[],
  isSendToFactory: boolean
) => {
  try {
    // 校验文件信息是否正确
    const errItem = arr.find((item) => item.error_info)
    // 存在错误文件
    if (errItem) {
      vm?.proxy.$confirm(
        `<span id="material_nc_error">${errItem.error_info}</span>`,
        translateLang('警告'),
        {
          type: 'error',
          dangerouslyUseHTMLString: true,
          confirmButtonText: translateLang('确定'),
        }
      )
      paibanParams.value.isPaibaning = false
      return
    }

    // 获取排版图
    let imgArr = getLabelPaibanImg()

    let arrs: string[] = []
    for (let i = 0; i < plankList.value.length; ++i) {
      if (plankList.value[i].parts.length == 0) continue
      let address = plankList.value[i].parts[0].address
      if (!arrs.includes(address)) {
        arrs.push(address)
      }
    }
    let name = handleGenFileNameStr(
      plankList.value,
      customizeFolderSetting.value
    )
    // 清空存储的文件内容数据
    store.commit('setFolderContents', {})
    store.commit('setRepeatFileName', [])
    store.commit('setTempFileName', [])
    /** zip 源 */
    let zip
    let nameStr = '云排版电子锯'
    if (ncSetting.value.customizeFolder?.new_customize_folder) {
      collector.addExtraData({
        productionLineName: selectProLine.value.name,
      })
      const { exporter, folderStructure } = await genNcZipByCustomFolder(
        ncSetting.value as any,
        ncSetting.value.customizeFolder?.customize_folder_config,
        arr,
        [],
        imgArr ?? [],
        [],
        {},
        { pageType: 'materialList' }
      )
      // 内嵌发送车间不能走这里，不然会直接下载文件
      if (window.webToQt && !isSendToFactory) {
        await exporter.exportToQtClient()
        exporter.clear()
        autoSaveHistory()
        return
      }
      const {
        success,
        errorMsg,
        zip: resultZip,
      } = await exporter.exportZip(false, false)
      if (!success) {
        message.error(errorMsg?.join('\n') ?? '文件下载失败')
        return
      }
      zip = resultZip
      nameStr = folderStructure.getNodeStructure().name || nameStr
      exporter.clear()
    } else {
      // 常规发送给 qt 的数据，和上面相同，发送车间还是需要走下面的逻辑
      if (window.webToQt && !isSendToFactory) {
        dealWebToQtData(arr, imgArr, ncSetting.value)
        autoSaveHistory()
        return
      }
      const result = await downloadNCFile(
        arr,
        name,
        imgArr!,
        [],
        false,
        '',
        mergeFolder,
        ncSetting.value,
        () => {
          // this.isDownloadingNc = false
        },
        ''
      )

      if (result) {
        const {
          zip: zip1,
          nameStr: nameStr1,
          qtRepeat,
          repeatNameList: repeatNameList1,
          repeatZipFileNameList,
          repeatZipFolderNameList,
        } = result as any
        nameStr = nameStr1
        zip = zip1
        if (qtRepeat) {
          repeatNameList.value = repeatNameList1
          repeatFileNameList.value = repeatZipFileNameList
          repeatFolderNameList.value = repeatZipFolderNameList
          return
        }
        let repeatZipFolderNameList2: any = []
        let repeatZipFileNameList2 = JSON.parse(
          JSON.stringify(store.state.repeatFileName)
        )
        Object.keys(store.state?.folderContents)?.forEach((item) => {
          if (
            !ncSetting.value.customizeFolder?.merge_folder_list.includes(
              fileNameSetObj[item] + '文件'
            ) &&
            ncSetting.value?.customizeFolder?.merge_folder_list.length > 1
          ) {
            if (
              ncSetting.value?.customizeFolder.merge_folder_display_name.trim() ===
              store.state.folderContents[item].trim()
            ) {
              repeatZipFolderNameList2.push(fileNameSetObj[item])
            }
          }
        })
        repeatFileNameList.value = repeatZipFileNameList2
        repeatFolderNameList.value = repeatZipFolderNameList2
        repeatNameList.value = []
          .concat(repeatZipFolderNameList2)
          .concat(repeatZipFileNameList2)

        if (repeatNameList.value.length) {
          isShowWarningModal.value = true
          paibanParams.value.isPaibaning = false
          isConfirmLoading.value = false
          return
        }
      }
    }
    if (isSendToFactory) {
      sendNcFileToFactory(zip, parts)
      autoSaveHistory()
      return
    }
    let isNcFile: string | undefined = undefined
    await promiseToZip(
      zip,
      null,
      nameStr,
      (url: string) => {
        isNcFile = url
      },
      null,
      {},
      ncSetting.value
    )
    paibanParams.value.isPaibaning = false
    autoSaveHistory(isNcFile)
    Vue.prototype.$message.success(translateLang('{type}下载完成'))
  } finally {
    paibanParams.value.isPaibaning = false
    paibanParams.value.isSendToFactory = false
  }
}

/** 保存历史 */
const autoSaveHistory = async (isNcFile?: string) => {
  historyName.value = `${translateLang('历史方案')} ${splitTime()}`
  const { obj, name: ossFileName } = ossFilesParams.value
  ossUploadFiles(obj, ossFileName, (url: string) => {
    saveMaterialPaiban(url, 1, isNcFile)
  })
}

/** @description 发送数据到车间 */
const sendNcFileToFactory = async (zip: any, parts: PartType[]) => {
  const allParts = getAllParts(plankList.value)
  const payload = {
    address: Array.from(
      new Set(
        allParts.map((data: any) =>
          data.address ? data.address : data.groupNo
        )
      ).values()
    ).join(','),
    order_id: Array.from(
      new Set(allParts.map((data: any) => data.orderNo)).values()
    ).join(','),
    product_line: selectProLine.value.name,
    plank: parts.map((part) => ({ ...part, amount: 1 })),
    process_line_id:
      paibanFormData.value?.process_line_id ??
      paibanFormData.value?.process_setting_id,
    zip,
  }
  const res = await sendDataToWorkShop(payload)
  paibanParams.value.isPaibaning = false
  paibanParams.value.isSendToFactory = false
  if (res.status == 1) {
    Vue.prototype.$message.success(translateLang('发送至车间成功!'))
    autoSaveHistory()
  } else {
    vm?.proxy.$confirm(translateLang('发送车间失败，请联系售后人员请求帮助!'))
  }
}

const OrderTypeMap = {
  singleOrder: '单订单',
  multiOrder: '多订单',
  noOrder: '无订单',
}
// 处理web和客户端通信时的数据 电子锯
const dealWebToQtData = async (
  arr: ISmtFileResponse[],
  imgArr: any[] = [],
  ncSetting: INcSettingType
) => {
  store.commit('setFolderContents', {})
  store.commit('setRepeatFileName', [])
  store.commit('setTempFileName', [])
  try {
    let qtData = []
    // 处理排版图
    for (let key in imgArr) {
      imgArr[key].forEach((item: any) => {
        let url = item.url.replace(/^data:image\/(png|jpg|jpeg);base64,/, '')
        let obj = {
          originFile: _translateFileNameFn(
            `排版图${item.index}`,
            ncSetting.customizeFolder,
            `paiban${item.index}`,
            item
          ),
          fileName: item.name,
          url: url,
          fileType: 'base64',
        }
        qtData.push(obj)
      })
    }
    let sawSetting
    const saw_setting_res = await getSaeSetting({
      setting_id: paibanFormData.value.process_line_id,
      setting_type: 'electronicSaw',
    })
    if (saw_setting_res.data.data) sawSetting = saw_setting_res.data.data
    const { orderType, orderCounts } = dealElectronicSawData(
      arr as unknown as any
    )
    const { is_gen_surplus_folder } = ncSetting.customizeFolder
    // 处理下料文件
    let num = 1
    for (let i = 0; i < arr.length; ++i) {
      let url = 'https://eggrj.oss-cn-hangzhou.aliyuncs.com/' + arr[i].filename
      // 如果是贴标机文件
      let prefixName = ''
      let originFile = ''
      let fileName = ''
      let nextFileName = ''
      if (
        ncSetting.folderCategory &&
        ncSetting.folderCategory.useCategoryFolder
      ) {
        prefixName =
          arr[i].stock_key
            .substring(0, arr[i].stock_key.lastIndexOf(':'))
            .replace(/:/g, '_') + '/'
      }
      let obj = {
        url: '',
        fileName: '',
        originFile: '',
        fileType: '',
        file_type: '',
      }
      if (arr[i].filetype === 'label') {
        let setName = _translateFileNameFn(
          '贴标机',
          ncSetting.customizeFolder,
          'labeling_folder',
          arr[i]
        )
        const surplusFolder = _translateFileNameFn(
          '余料大板文件',
          ncSetting.customizeFolder,
          'surplus_folder',
          arr[i]
        )
        if (arr[i].plank_type === 'surplus' && is_gen_surplus_folder) {
          originFile = prefixName + surplusFolder
        } else {
          originFile = prefixName + setName
        }
        fileName = arr[i].file_display_name
      } else if (arr[i].filetype === 'nc') {
        let setName = _translateFileNameFn(
          '下料文件',
          ncSetting.customizeFolder,
          'engraving_folder',
          arr[i]
        )
        const surplusFolder = _translateFileNameFn(
          '余料大板文件',
          ncSetting.customizeFolder,
          'surplus_folder',
          arr[i]
        )
        if (arr[i].plank_type === 'surplus' && is_gen_surplus_folder) {
          originFile = prefixName + surplusFolder
        } else {
          originFile = prefixName + setName
        }
        if (arr[i].file_display_name == '') {
          fileName =
            ('00' + num).substr(-3, 3) +
            '_' +
            (arr[i].direction == 'front' ? '正.' : '反.') +
            arr[i].filetype
          num++
        } else {
          fileName = arr[i].file_display_name
        }
      } else if (arr[i].file_type === 'saw') {
        originFile = _translateFileNameFn(
          'saw',
          ncSetting.customizeFolder,
          'electronic_saw_folder',
          arr[i]
        )
        originFile = originFile ? `${originFile}/` : ''

        if (sawSetting.rooms_by_category) {
          const delimiter = sawSetting?.delimiter || ''
          let lv2Folder = ''
          let lv3Folder = ''

          if (sawSetting.useCategoryFolder) {
            switch (orderType) {
              case OrderTypeMap['noOrder']:
              case OrderTypeMap['singleOrder']:
                if (arr[i].room_name) {
                  const newRemark = arr[i].room_remark
                    ? arr[i].room_remark.replace(/[/:?<>\|."*]/g, '')
                    : ''
                  nextFileName = `${arr[i].room_name}${
                    newRemark ? delimiter + newRemark : ''
                  }`
                } else if (arr[i].partHasRoom) {
                  nextFileName = '其他房间'
                }
                break
              case OrderTypeMap['multiOrder']:
                if (arr[i].order_no) {
                  const newCustomer = arr[i].customer_name
                    ? arr[i].customer_name?.replace(/[/:?<>\|."*]/g, '')
                    : ''
                  lv2Folder = `${arr[i].order_no}${
                    newCustomer ? delimiter + newCustomer : ''
                  }`
                } else {
                  lv2Folder = '其他订单'
                }
                if (arr[i].room_name) {
                  const newRemark = arr[i].room_remark
                    ? arr[i].room_remark.replace(/[/:?<>\|."*]/g, '')
                    : ''
                  lv3Folder = `${arr[i].room_name}${
                    newRemark ? delimiter + newRemark : ''
                  }`
                } else if (
                  orderCounts[arr[i].order_no]?.length !== 1 &&
                  orderCounts[arr[i].order_no].some((item) => item.room_name)
                ) {
                  lv3Folder = arr[i].partHasRoom ? '其他房间' : ''
                }
                nextFileName = `${lv2Folder}${lv3Folder ? '/' + lv3Folder : ''}`
                break
              default:
                break
            }
          } else {
            switch (orderType) {
              case OrderTypeMap['noOrder']:
                break
              case OrderTypeMap['singleOrder']:
                break
              case OrderTypeMap['multiOrder']:
                if (arr[i]?.partHasOrder) {
                  nextFileName = '其他订单'
                } else {
                  const newCustomer = arr[i].customer_name
                    ? arr[i].customer_name?.replace(/[/:?<>\|."*]/g, '')
                    : ''
                  nextFileName = `${arr[i].order_no}${
                    newCustomer ? delimiter + newCustomer : ''
                  }`
                }
                break
              default:
                break
            }
          }

          originFile += nextFileName ? `${nextFileName}/` : ''
        }

        if (arr[i].file_display_name) {
          fileName = arr[i].file_display_name
        } else {
          fileName = arr[i].fileName?.split('/')[1]
        }
        obj.file_type = 'saw'
      } else {
        let setName = _translateFileNameFn(
          arr[i].filetype,
          ncSetting.customizeFolder,
          arr[i].filetype,
          arr[i]
        )
        originFile = setName
        if (arr[i].file_display_name) {
          fileName = arr[i].file_display_name
        } else {
          fileName = arr[i].filename
        }
      }
      obj.url = url
      obj.fileName = fileName
      obj.originFile = originFile
      obj.fileType = 'url'
      qtData.push(obj)
    }
    paibanParams.value.isPaibaning = false
    if (!checkFolderName(ncSetting, qtData)) return
    const { cuttingEquipment } = proLineList.value.find(
      (item) => paibanFormData.value.process_line_id === item.id
    )?.data
    const isElec = cuttingEquipment === 'electronicSaw'
    let paibanDataObj = {
      layoutData: getAllParts(plankList.value),
      paibanData: paibanData.value,
      process_setting_id: isElec
        ? paibanFormData.value.process_line_id
        : ncSetting.process_setting_id,
      process_setting_name: isElec
        ? selectProLine.value.name
        : ncSetting.process_setting_name,
      recodeSelectPart: store.state.recodeSelectPart,
      recodeSelectSurplus: store.state.recodeSelectSurplus,
      thinkerxMaterialKeys: store.state.thinkerxMaterialKeys,
    }
    let ncData = {
      layoutData: paibanDataObj,
      ncData: qtData,
      orderCodeAsDirectionName: isElec
        ? undefined
        : ncSetting.folderCategory.orderCodeAsDirectionName,
    }
    window.webToQt.ncDataToQtV2
      ? window.webToQt.ncDataToQtV2(ncData)
      : window.webToQt.ncDataToQt(qtData)
    return
  } catch (err) {
    Vue.prototype.$message.error(`${err}`)
    throw err
  }
}

// 电子锯数据处理
const dealElectronicSawData = (arr: ISmtFileResponse[]) => {
  let orderType = OrderTypeMap['singleOrder']
  const hasOrderNo = arr.some((item) => item.order_no)
  const hasNoOrderNo = arr.some((item) => !item.order_no)
  const hasRoom = arr.some((item) => item.room_name)
  const hasNoRoom = arr.some((item) => item.room_name)
  const getOrderNos = (data: ISmtFileResponse[]) => {
    return data
      .filter((item) => {
        if (item.file_type === 'saw') {
          return item
        }
      })
      .filter((item) => item.order_no)
      .map((item) => item.order_no)
  }
  // 获取所有order_no
  const allOrderNos = getOrderNos(arr)
  const uniqueOrderNos = new Set(allOrderNos) // 检查是否有数据缺少order_no
  // 根据订单数量设置orderType
  const hasMissingOrderNo = arr
    .filter((item) => {
      if (item.file_type === 'saw') return item
    })
    .some((item) => !item.order_no)
  if (!hasOrderNo) {
    orderType = OrderTypeMap['noOrder']
  } else if (hasMissingOrderNo || uniqueOrderNos.size > 1) {
    orderType = OrderTypeMap['multiOrder']
  } else if (uniqueOrderNos.size === 1) {
    orderType = OrderTypeMap['singleOrder']
  }
  if (hasOrderNo && hasNoOrderNo) {
    arr.forEach((item) => {
      if (!item.order_no) {
        item.partHasOrder = true
      }
    })
  }
  if (hasRoom && hasNoRoom) {
    arr.forEach((item) => {
      if (!item.room_name) {
        item.partHasRoom = true
      }
    })
  }
  const orderCounts = arr.reduce((accumulator, current) => {
    const key = current.order_no
    if (!accumulator[key]) {
      accumulator[key] = []
    }
    accumulator[key].push(current)
    return accumulator
  }, {} as Record<string, Array<ISmtFileResponse>>)
  return {
    orderType,
    orderCounts,
    hasOrderNo,
    hasNoOrderNo,
    hasRoom,
    hasNoRoom,
  }
}

// 数据检查
const checkFolderName = (ncSetting: INcSettingType, zip: any) => {
  let repeatZipFileNameList: any[] = []
  let repeatZipFolderNameList: any[] = []
  let tempZipFileNameList: any[] = []
  if (zip?.files) {
    repeatZipFileNameList = JSON.parse(
      JSON.stringify(store.state.repeatFileName)
    )
  } else {
    // 内嵌
    zip.forEach((item: any) => {
      // 判断合并文件内部是否有文件存在重名
      if (item?.file_type !== 'saw') {
        // 判断合并文件内部是否有文件存在重名
        if (
          item.originFile.indexOf(
            ncSetting.customizeFolder?.merge_folder_display_name
          ) !== -1
        ) {
          if (tempZipFileNameList.includes(item.fileName)) {
            repeatZipFileNameList.push(item.fileName)
          } else {
            // 存入值
            tempZipFileNameList.push(item.fileName)
          }
        }
      }
    })
    repeatZipFileNameList = [...new Set(repeatZipFileNameList)]
  }
  // 获取当前存储的文件内容数据，判断它是否在合并文件夹中
  // 如果不在，那么它的名称不能和合并文件夹一样
  Object.keys(store.state?.folderContents)?.forEach((item) => {
    if (
      !ncSetting?.customizeFolder?.merge_folder_list.includes(
        fileNameSetObj[item] + '文件'
      ) &&
      ncSetting?.customizeFolder?.merge_folder_list.length > 1
    ) {
      if (
        ncSetting.customizeFolder.merge_folder_display_name.trim() ===
        store.state.folderContents[item].trim()
      ) {
        repeatZipFolderNameList.push(fileNameSetObj[item])
      }
    }
  })

  repeatFileNameList.value = repeatZipFileNameList
  repeatFolderNameList.value = repeatZipFolderNameList
  repeatNameList.value = []
    .concat(...repeatZipFolderNameList)
    .concat(...repeatZipFileNameList)
  if (repeatNameList.value.length) {
    isShowWarningModal.value = true

    paibanParams.value.isPaibaning = false
    isConfirmLoading.value = false
    return false
  }
  return true
}

// 生成排版标签信息
const getLabelPaibanImg = () => {
  let imgArr: any[] = []
  const oriArr = paibanData.value
  if (ncSetting.value.labelingMachine) {
    let imgExportArr = []
    for (
      let i = 0;
      i < ncSetting.value.layoutImageSetting.layoutImage.length;
      ++i
    ) {
      let imgSetting = ncSetting.value.layoutImageSetting.layoutImage[i]
      let obj = {
        type: imgSetting.imageFormat,
        prefix: imgSetting.imageNamePrefix,
        direction: imgSetting.imageDirection == 'horiz' ? true : false, // 判断是横向图片还是竖向图片
        way: imgSetting.way,
        enable: imgSetting.enable,
        width: 0,
        height: 0,
        index: 0,
      }
      if (obj.direction) {
        obj.width = imgSetting.imageSize[1]
        obj.height = imgSetting.imageSize[0]
      } else {
        obj.width = imgSetting.imageSize[0]
        obj.height = imgSetting.imageSize[1]
      }
      obj.index = i + 1
      imgExportArr.push(obj)
    }
    let plankWidth = ncSetting.value.drawPlankWidth
    let plankHeight = ncSetting.value.drawPlankHeight
    // 循环输出两种排版图
    for (let j = 0; j < imgExportArr.length; ++j) {
      if (!imgExportArr[j].enable) continue
      imgArr[j + 1] = []
      let direction = imgExportArr[j].direction
      // 创建canvas标签
      let oCanvas = document.createElement('canvas')

      // 设置canvas长宽
      oCanvas.width = Number(imgExportArr[j].width)
      oCanvas.height = Number(imgExportArr[j].height)
      let ctx = oCanvas.getContext('2d')
      let fontSize = 14
      if (!ctx) return
      // 如果是横向, 则需要切换旋转canvas, 切换canvas的长宽
      if (direction) {
        var temp = oCanvas.width
        oCanvas.width = oCanvas.height
        oCanvas.height = temp
      }
      // 循环绘制每一块大板
      for (let i = 0; i < oriArr.length; ++i) {
        ctx.clearRect(0, 0, oCanvas.width, oCanvas.height)
        let center = {
          x: 0,
          y: 0,
        }
        ctx.fillStyle = '#fff'
        ctx.fillRect(0, 0, oCanvas.width, oCanvas.height)

        // 如果是横向, 则以中心点位置旋转, 并重新计算原点坐标
        if (direction) {
          center = {
            x: Math.round(oCanvas.width / 2),
            y: Math.round(oCanvas.height / 2),
          }
          ctx.translate(center.x, center.y)
          ctx.rotate(Math.PI / 2)
          ctx.translate(-center.y, -center.x)
        }

        // 设置绘制的属性
        ctx.fillStyle = '#fff'
        let finalScale = 0
        let startX = 0
        let startY = 0

        // 根据余料或者正常大板, 计算绘制起始点(居中绘制)
        if (
          oriArr[i].surplusInfo &&
          Object.keys(oriArr[i].surplusInfo).length > 0
        ) {
          let surplusInfo = oriArr[i].surplusInfo
          // 减少一个文字大小的高度和宽度
          let scaleX =
            Number(surplusInfo.width) / Number(imgExportArr[j].width - 64)
          let scaleY =
            Number(surplusInfo.height) / Number(imgExportArr[j].height - 64)
          finalScale = scaleX > scaleY ? scaleX : scaleY
          startX =
            Math.abs(surplusInfo.width / finalScale - imgExportArr[j].width) / 2
          startY =
            Math.abs(surplusInfo.height / finalScale - imgExportArr[j].height) /
            2
          if (surplusInfo.shape && surplusInfo.shape == 'lshape') {
            let x3 = ncSetting.value.xyReverse
              ? Number(surplusInfo.y5)
              : Number(surplusInfo.x3)
            let y3 = ncSetting.value.xyReverse
              ? Number(surplusInfo.x5)
              : Number(surplusInfo.y3)
            let x4 = ncSetting.value.xyReverse
              ? Number(surplusInfo.y4)
              : Number(surplusInfo.x4)
            let y4 = ncSetting.value.xyReverse
              ? Number(surplusInfo.x4)
              : Number(surplusInfo.y4)
            let x5 = ncSetting.value.xyReverse
              ? Number(surplusInfo.y3)
              : Number(surplusInfo.x5)
            let y5 = ncSetting.value.xyReverse
              ? Number(surplusInfo.x3)
              : Number(surplusInfo.y5)
            let newWidth = surplusInfo.width
            let newHeight = surplusInfo.height
            y3 = newHeight - y3
            y4 = newHeight - y4
            y5 = newHeight - y5

            ctx.beginPath()
            ctx.moveTo(startX, startY)

            ctx.lineTo(startX + x3 / finalScale, startY + y3 / finalScale)
            ctx.lineTo(startX + x4 / finalScale, startY + y4 / finalScale)
            ctx.lineTo(startX + x5 / finalScale, startY + y5 / finalScale)
            ctx.lineTo(
              startX + newWidth / finalScale,
              startY + newHeight / finalScale
            )
            ctx.lineTo(startX, startY + newHeight / finalScale)

            ctx.closePath()
            ctx.stroke()
          } else if (surplusInfo.shape == 'specialShape') {
            const path = surplusInfo.path
            if (
              path[0].x !== path[path.length - 1].x ||
              path[0].y !== path[path.length - 1].y
            ) {
              path.push(path[0])
            }
            for (let i = 0; i < path.length; i++) {
              const point = path[i]
              ctx.beginPath()
              ctx.moveTo(
                startX + point.x / finalScale,
                startY + point.y / finalScale
              )
              ctx.lineTo(
                startX + point.x / finalScale,
                startY + point.y / finalScale
              )
            }
            ctx.closePath()
            ctx.stroke()
          } else {
            ctx.strokeRect(
              startX,
              startY,
              surplusInfo.width / finalScale,
              surplusInfo.height / finalScale
            )
          }
        } else {
          let scaleX = Number(plankWidth) / Number(imgExportArr[j].width - 64)
          let scaleY = Number(plankHeight) / Number(imgExportArr[j].height - 64)
          finalScale = scaleX > scaleY ? scaleX : scaleY
          startX = Math.abs(plankWidth / finalScale - imgExportArr[j].width) / 2
          startY =
            Math.abs(plankHeight / finalScale - imgExportArr[j].height) / 2
          ctx.strokeRect(
            startX,
            startY,
            plankWidth / finalScale,
            plankHeight / finalScale
          )
          ctx.fillRect(
            startX,
            startY,
            plankWidth / finalScale,
            plankHeight / finalScale
          )
        }

        // 将图片进行居中
        for (let k = 0; k < oriArr[i].parts.length; ++k) {
          let part = oriArr[i].parts[k]
          drawParts(ctx, part, startX, startY, finalScale, imgExportArr[j].way)
        }

        if (direction) {
          ctx.translate(center.y, center.x)
          ctx.rotate(-Math.PI / 2)
          ctx.translate(-center.x, -center.y)
        }
        // 获取的方法getGraghEdge
        let { size } = getGraghEdge(oriArr[i])
        ctx.fillStyle = '#333'
        ctx.font = `${fontSize}px 'PingFangSC-Regular, PingFang SC'`
        let str = `${oriArr[i].thick}${oriArr[i].matCode}${oriArr[i].texture}`
        let usedRate = oriArr[i].usedRate
          ? oriArr[i].usedRate >= 1
            ? `${(100).toFixed(2)}%`
            : `${(oriArr[i].usedRate * 100).toFixed(2)}%`
          : '0%'
        let textWidth = calcTextSize(str, fontSize)
        let textStartX = (oCanvas.width - textWidth) / 2
        let textStartY = direction ? startX : startY
        ctx.fillText(str, textStartX, textStartY - 4)
        //排版图3单独处理
        if (imgExportArr[j].way == 3) {
          str = `第${i + 1}/${oriArr.length}张大板   利用率：${usedRate}`
          let strSecond = `材质:${oriArr[i].matCode}   颜色:${oriArr[i].texture}   规格：${size}`
          textWidth = calcTextSize(strSecond, fontSize)
          textStartX = (oCanvas.width - textWidth) / 2
          ctx.fillText(str, textStartX, textStartY - 20)
          ctx.fillText(strSecond, textStartX, textStartY - 4)
          for (let k = 0; k < oriArr[i].parts.length; ++k) {
            let part = oriArr[i].parts[k]
            drawText(ctx, part, startX, startY, finalScale)
          }
        } else {
          ctx.fillText(str, textStartX, textStartY - 4)
        }
        let imgUrl = oCanvas.toDataURL()
        imgArr[j + 1].push({
          url: imgUrl,
          name: imgExportArr[j].prefix + (i + 1) + '.' + imgExportArr[j].type,
          index: imgExportArr[j].index,
        })
      }
      if (document.body.contains(oCanvas)) {
        document.body.removeChild(oCanvas)
      }
    }
  }
  return imgArr
}

const drawParts = (
  ctx: CanvasRenderingContext2D,
  part: PartType,
  startX: number,
  startY: number,
  scale: number,
  way: number
) => {
  ctx.strokeStyle = '#0008'
  ctx.lineWidth = 1
  let rect = {
    x: startX + part.startX / scale,
    y: startY + part.startY / scale,
    width: part.rect.width / scale,
    height: part.rect.height / scale,
  }
  if (part.path) {
    for (let i = 0; i < part.path.length; ++i) {
      ctx.beginPath()
      for (let k = 0; k < part.path[i].length; ++k) {
        let x = rect.x + part.path[i][k].x / scale
        let y = rect.y + part.path[i][k].y / scale
        if (k == 0) {
          ctx.moveTo(x, y)
        } else {
          ctx.lineTo(x, y)
        }
      }
      ctx.closePath()
      ctx.stroke()
    }
  } else {
    ctx.strokeRect(rect.x, rect.y, rect.width, rect.height)
  }
  // 绘制孔、槽、牛角拉手、异型孔(只有排版图3才画)
  if (way == 3) {
    if (part.holes?.length > 0) {
      part.holes.forEach((hole) => {
        ctx.beginPath()
        ctx.arc(
          startX + (part.startX + hole.center.x) / scale,
          startY + (part.startY + hole.center.y) / scale,
          hole.diameter / scale,
          0,
          Math.PI * 2
        )
        ctx.closePath()
        ctx.stroke()
      })
    }
    if (part.slots?.length > 0) {
      part.slots.forEach((slot) => {
        const { x, y, width, height } = getSlotBasicInfo(slot, 'pt')
        ctx.beginPath()
        ctx.strokeRect(
          startX + (part.startX + x) / scale,
          startY + (part.startY + y) / scale,
          width / scale,
          height / scale
        )
        ctx.closePath()
      })
    }
    if (part.curveHoles?.length > 0) {
      part.curveHoles.forEach((curveHole) => {
        ctx.beginPath()
        for (let index = 0; index < curveHole.path.length; index++) {
          const curve = curveHole.path[index]
          let x, y
          x = startX + (part.startX + curve.x) / scale
          y = startY + (part.startY + curve.y) / scale
          if (index == 0) {
            ctx.moveTo(x, y)
          } else {
            ctx.lineTo(x, y)
          }
        }
        ctx.stroke()
        ctx.closePath()
      })
    }
    if (part.path?.length > 1) {
      part.path.forEach((path) => {
        ctx.beginPath()
        for (let index = 0; index < path.length; index++) {
          const curPath = path[index]
          let x, y
          x = startX + (part.startX + curPath.x) / scale
          y = startY + (part.startY + curPath.y) / scale
          if (index == 0) {
            ctx.moveTo(x, y)
          } else {
            ctx.lineTo(x, y)
          }
        }
        ctx.stroke()
        ctx.closePath()
      })
    }
    if (part.millInfo?.length > 0) {
      part.millInfo.forEach((mill) => {
        ctx.beginPath()
        for (let index = 0; index < mill.shape.length; index++) {
          const curMill = mill.shape[index]
          let x, y
          x = startX + (part.startX + curMill.x) / scale
          y = startY + (part.startY + curMill.y) / scale
          if (index == 0) {
            ctx.moveTo(x, y)
          } else {
            ctx.lineTo(x, y)
          }
        }
        ctx.stroke()
        ctx.closePath()
      })
    }
  }
}
const drawText = (
  ctx: any,
  part: any,
  startX: any,
  startY: any,
  scale: any
) => {
  let fontSize = 13
  ctx.fillStyle = '#333'
  ctx.font = `${fontSize}px 'PingFangSC-Regular, PingFang SC'`
  let lineHeight = 13
  let rect = {
    x: startX + part.startX / scale,
    y: startY + part.startY / scale,
    width: part.rect.width / scale,
    height: part.rect.height / scale,
  }
  let partInfo = `${part.realRect.height.toFixed(
    2
  )}*${part.realRect.width.toFixed(2)}*${part.thick}`

  let { y: partNameHeight, isFull } = wrapText(
    ctx,
    part.partName,
    rect.y + lineHeight,
    lineHeight,
    rect
  )
  if (!isFull) {
    wrapText(
      ctx,
      partInfo,
      lineHeight + partNameHeight,
      lineHeight,
      rect,
      'partInfo'
    )
  }
}
const wrapText = (
  ctx: any,
  text: string,
  y: number,
  lineHeight: number,
  rect: any,
  partInfo?: string
) => {
  let { x, y: rectY, width: maxWidth, height: maxHeight } = rect
  let words = text.split('')
  let line = ''
  let isFull = false
  let textStartY = y
  let partNameHeight = partInfo ? y - rectY - lineHeight : 0
  for (let n = 0; n < words.length; n++) {
    let testLine = line + words[n]
    let metrics = ctx.measureText(testLine)
    let testWidth = metrics.width
    if (testWidth > maxWidth && n > 0) {
      if (y - textStartY + lineHeight + partNameHeight < maxHeight) {
        ctx.fillText(line, x, y)
        line = words[n] + ' '
        y += lineHeight
      } else {
        isFull = true
        line = ''
        break
      }
    } else {
      line = testLine
    }
  }
  ctx.fillText(line, x, y)
  return { y, isFull }
}

// 计算文本宽度
const calcTextSize = (text: string, fontSize: number) => {
  let span = document.createElement('span')
  let result = {
    width: 0,
    height: 0,
  }
  result.width = span.offsetWidth
  result.height = span.offsetHeight
  span.style.visibility = 'hidden'
  span.style.fontSize = `${fontSize}px`
  span.style.fontFamily = 'PingFangSC-Regular, PingFang SC'
  span.style.display = 'inline-block'
  document.body.appendChild(span)
  if (typeof span.textContent != 'undefined') {
    span.textContent = text
  } else {
    span.innerText = text
  }
  result.width = parseFloat(window.getComputedStyle(span).width) - result.width
  document.body.removeChild(span)
  let width = result.width
  return width
}

const isShowSendToFactoryModal = ref(false)
// 打开发送至工厂的弹窗
const handleSendToFactory = () => {
  isShowSendToFactoryModal.value = true
}

// 确定发送至车间
const handleConfirmSend = async (temp: string, state: IpaibanFormDataType) => {
  isShowSendToFactoryModal.value = false
  isShowPaibanModal.value = false
  paibanParams.value.isSendToFactory = true
  try {
    if (state) {
      paibanFormData.value = state
    }
    dealLayoutData(state, true)
  } catch (error) {
    vm?.proxy.$confirm('发送至车间成功!')
  }
}

// 修改生产线列表
const setProLineList = (proLineList: IProductionLineType) => {
  store.commit('setProLineList', proLineList)
}

// 生产线选择
const selectProLine = ref<IProductionLineType>({
  id: 0,
  name: '',
  data: {},
})
const handleSelectProLine = (value: IProductionLineType) => {
  selectProLine.value = value
}
const getSelectLine = (value: IProductionLineType) => {
  selectProLine.value = value
}

// 标准大板
const selectStandardPlank = computed<StandardPlankType>(
  () => store.state.selectStandardPlank
)

/**
 * 筛选相关操作
 *
 */
// 记录当前筛选的所有属性
const filterProps = ref<IFilterableFieldsType[]>([])
// 当前筛选的属性
const filterProp = ref<IFilterableFieldsType>('')
// 筛选框中的筛选
const filterSearchVal = ref<string>('')
// 是否展示筛选弹窗
const filterVisible = ref(false)
// 已搜索的筛选
const searchVal = ref<Map<string, string>>(new Map())
const isHighGlossPlankVisible = ref(false)
// 料单筛选
const handlePlankFilter = (payLoad: { prop: string } | undefined) => {
  if (!payLoad) return
  const { prop } = payLoad
  filterVisible.value = false
  getFilterItem(prop as IFilterableFieldsType)
  if (filterProp.value !== 'is_high_gloss_plank') {
    filterVisible.value = true
  } else {
    // 打开高光属性弹窗
    isHighGlossPlankVisible.value = true
    searchValue.value = ''
    if (!filterKeys.value.length) {
      checkedKeys.value = getAllKeys(highlightProps.value)
    } else {
      checkedKeys.value = filterKeys.value
    }
  }
}
// 高光全选
const isCheckAll = ref<boolean>(true) // 默认全选
const checkedKeys = ref<string[]>([]) // 默认选中
const filterKeys = ref<string[]>([]) // 最终筛选的高光属性
const getAllKeys = (nodes: any[]): string[] => {
  return nodes.reduce((keys: string[], node: any) => {
    keys.push(node.key)
    if (node.children && node.children.length > 0) {
      keys.push(...getAllKeys(node.children))
    }
    return keys
  }, [])
}
function handleSelectAll() {
  isCheckAll.value = !isCheckAll.value
  if (isCheckAll.value) {
    checkedKeys.value = getAllKeys(highlightProps.value)
  } else {
    checkedKeys.value = []
  }
}

// 高光属性的筛选字段（树形控件格式）
const highlightProps = ref([
  {
    title: '高光板', // 节点显示名称
    key: 'highlight', // 唯一标识符
    children: [], // 子节点
  },
  {
    title: '非高光板', // 节点显示名称
    key: 'noHighlight', // 唯一标识符
    children: [], // 子节点
  },
]) as any
// 获取筛选条件项
const getFilterItem = (prop: IFilterableFieldsType) => {
  filterSearchVal.value = searchVal.value.get(prop) || ''
  filterProp.value = prop // 当前过滤项
  const newFilterObj: any = {}
  let data: any[] = plankList.value
  // 先排除自己的筛选
  ;(Object.keys(filterObj.value) as IFilterableFieldsType[]).forEach((item) => {
    if (item !== prop) {
      newFilterObj[item] = filterObj.value[item]
    }
  })
  // 获取排除其他过滤条件之后的数据
  if (Object.keys(newFilterObj).length > 0) {
    data = dealFilterData(
      plankList.value,
      newFilterObj,
      searchCondition.value,
      specialRemarksForProcessLabel.value
    )
  }
  let partArr = data.map((plank) => plank.parts).flat(1)
  if (prop) {
    // 这里需要单独处理高光属性，新增了高光属性的别名之后，需要根据对应的材质获取高光属性的别名进行筛选
    if (prop === 'is_high_gloss_plank') {
      partArr.forEach((item) => {
        const highlightName = matchHighlightBoardName(item.matCode)
        if (item.is_high_gloss_plank) {
          // 如果是高光板，添加到高光板的子节点中
          const highlightNode = highlightProps.value.find(
            (node: any) => node.key === 'highlight'
          )
          if (
            highlightNode &&
            !highlightNode.children.some(
              (child: any) => child.title === highlightName
            )
          ) {
            highlightNode.children.push({
              title: highlightName,
              key: `highlight-${highlightName}`,
            })
          }
        } else {
          // 如果是非高光板，添加到非高光板的子节点中
          const noHighlightNode = highlightProps.value.find(
            (node: any) => node.key === 'noHighlight'
          )
          if (
            noHighlightNode &&
            !noHighlightNode.children.some(
              (child: any) => child.title === `非${highlightName}`
            )
          ) {
            noHighlightNode.children.push({
              title: `非${highlightName}`,
              key: `noHighlight-非${highlightName}`,
            })
          }
        }
      })
      generateList(highlightProps.value)
    } else if (prop === 'hsInfo') {
      // 孔槽数量：固定筛选项，默认全选（具体有/无孔槽判断逻辑见 getHsInfoFilterValue）
      filterProps.value = ['hasHsInfo', 'noHsInfo'] as any
    } else {
      const allPartProps = Array.from(
        new Set(
          partArr.map((part) =>
            getFilterPropOriData(
              prop,
              part,
              specialRemarksForProcessLabel.value
            )
          )
        )
      ) as IFilterableFieldsType[]
      filterProps.value = allPartProps
    }
  }
}
/** 高光部分树形控件的搜索 */
const getParentKey = (key: any, tree: any): string | undefined => {
  let parentKey
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i]
    if (node.children) {
      if (node.children.some((item: any) => item.key === key)) {
        parentKey = node.key
      } else if (getParentKey(key, node.children)) {
        parentKey = getParentKey(key, node.children)
      }
    }
  }
  return parentKey
}

const expandedKeys = ref([])
const searchValue = ref('')
const autoExpandParent = ref(true)

const onExpand = (keys: any) => {
  expandedKeys.value = keys
  autoExpandParent.value = false
}
const dataList = ref([]) as any
const generateList = (data: any) => {
  for (let i = 0; i < data.length; i++) {
    const node = data[i]
    const key = node.key
    dataList.value.push({ key, title: node.title })
    if (node.children) {
      generateList(node.children)
    }
  }
}
generateList(highlightProps.value)
const onChange = (e: any) => {
  const value = e.target.value
  const keys = dataList.value
    .map((item: any) => {
      if (item.title.indexOf(value) > -1) {
        return getParentKey(item.key, highlightProps.value)
      }
      return null
    })
    .filter((item: any, i: any, self: any) => item && self.indexOf(item) === i)

  expandedKeys.value = keys
  searchValue.value = value
  autoExpandParent.value = true
}
// 关闭高光筛选弹窗
function handleCancleHighGlossFilter() {
  isHighGlossPlankVisible.value = false
}
// 重置高光筛选条件
function handleResetHighGlossFilter() {
  searchValue.value = ''
  isCheckAll.value = true
  isHighGlossPlankVisible.value = false
  handleResetFilter()
}
// 高光确定筛选
function handleConfirmHighGlossFilter() {
  const filterValues = [] as any
  isHighGlossPlankVisible.value = false
  // 筛选出选中的高光属性名称
  checkedKeys.value.forEach((key) => {
    if (key.includes('highlight-') || key.includes('noHighlight-')) {
      const name = key.replace('highlight-', '').replace('noHighlight-', '')
      filterValues.push(name)
    }
  })
  filterObj.value = {
    ...filterObj.value,
    [filterProp.value]: filterValues,
  }
  // 确定的时候更新筛选key
  filterKeys.value = checkedKeys.value
}
// 确定筛选
const handleConfirmFilter = (filterValues: string[], prop: string) => {
  filterVisible.value = false
  filterObj.value = {
    ...filterObj.value,
    [prop]: filterValues,
  }
}

// 关闭筛选弹窗
const handleCloseFilterModal = () => {
  filterVisible.value = false
}

// 重置筛选
const handleResetFilter = () => {
  delete filterObj.value[filterProp.value]

  // 触发监听
  filterObj.value = {
    ...filterObj.value,
  }
  filterVisible.value = false
}

// 如果在筛选状态下修改了属性值，那么需要将修改后的属性值加入到筛选列表中
const addFilterPropValue = (
  filterObj: Partial<Record<IFilterableFieldsType, string[]>>,
  prop: IFilterableFieldsType,
  value: string
) => {
  const copyFilterObj = cloneDeep(filterObj)
  if (Object.keys(copyFilterObj).length) {
    if (copyFilterObj[prop]) {
      if (!copyFilterObj[prop]?.includes(value)) {
        copyFilterObj[prop]?.push(value)
      }
    }
  }
  // 比较前后两次的筛选列表是否相等，如果相等则直接返回源对象
  // FIX:后续需要处理筛选属性的值为undefine/空的时候， 使用stringify比较不准确的问题
  if (JSON.stringify(copyFilterObj) === JSON.stringify(filterObj)) {
    return filterObj
  }
  return copyFilterObj
}
// 进入页面监听是否存在筛选条件，处理料单数据
watch(
  () => filterObj.value,
  (newVal) => {
    try {
      if (filterObj.value) {
        // isTaskLoading.value = true

        const newPlankList = dealFilterData(
          plankList.value,
          newVal,
          searchCondition.value,
          specialRemarksForProcessLabel.value
        )
        setFilterPlankList(newPlankList)
      }
    } catch (error) {
      console.log('筛选时报错', error)
    } finally {
      setTimeout(() => {
        // isTaskLoading.value = false
      }, 200)
    }
  },
  { immediate: true }
)

// 监听高光属性的全选
watch(
  () => checkedKeys.value,
  (val) => {
    const allKeys = getAllKeys(highlightProps.value)
    isCheckAll.value = val.length >= allKeys.length
  }
)

// 筛选弹窗关闭后的毁掉
const onAfterFilterClose = () => {}

/**
 * 批量修改板件
 */

// 表单批量修改弹窗展示
const isShowBatchChangePropsModal = ref(false)
// 批量修改确定按钮loading状态
const isUpdating = ref(false)
// 取消修改
const handleCancelEdit = () => {
  isShowBatchChangePropsModal.value = false
}
// 打开批量修改弹窗
const handleOpenBatchChangeModal = () => {
  if (!plankList.value.length) {
    Vue.prototype.$message({
      type: 'warning',
      message: `<span id="batch_edit_plank_warning">${translateLang(
        '请先至少选中一个板件再进行此操作!'
      )}</span>`,
      dangerouslyUseHTMLString: true,
    })
    return
  }
  isShowBatchChangePropsModal.value = true
  buryPointApi('material', 'batch_edit')
}
const plankEditorModalRef = ref<InstanceType<typeof plankEditor> | null>(null)

const tips = ref<string[]>([])
// 批量修改板件需要额外展示的信息
const extraWarningTips = computed(() => {
  return (
    prop: IEditableFields,
    editValue: string | number | boolean | undefined,
    hasPreEdgePlank?: boolean
  ) => {
    if (
      deleteHolesSlotsDataList.value.includes(prop) &&
      Number(editValue) <= 0.01 &&
      hasPreEdgePlank
    ) {
      return [translateLang('存在封边预铣值，封边不能小于0.01或者空')]
    }
    return []
  }
})
const deleteHolesSlotsDataList = ref([
  'leftEdge',
  'rightEdge',
  'frontEdge',
  'backEdge',
  'allEdge',
])
// 确认修改
const handleConfirmEdit = async (form: IBatchUpdateCallbackParams) => {
  let { prop, editValue, isAllRows } = form

  // 批量修改影响对纹的属性前确认
  if (affectTextureProps.includes(prop)) {
    const hasTextureAlignParts = filterPlankList.value.some((plank) =>
      plank.parts?.some((part: PartType) => isTextureAlignmentPlank(part))
    )
    if (hasTextureAlignParts) {
      const targetParts: PartType[] = []
      ;[filterPlankList.value, plankList.value].forEach((list) => {
        list.forEach((plank: PlankType) => {
          const parts = isAllRows
            ? plank.parts
            : plank.parts?.filter((p) => p.isSelected)
          if (parts?.length) targetParts.push(...parts)
        })
      })
      const confirmed = await showTextureConfirmModal(
        translateLang('当前操作会清除板件对纹信息，请确认是否继续？'),
        targetParts
      )
      if (!confirmed) return
    }
  }

  isUpdating.value = true
  const startTime = performance.now()

  if (prop === 'is_high_gloss_plank') {
    editValue = !!editValue
  }
  if (typeof editValue === 'string') {
    editValue = editValue.trim()
  }

  // TODO:进行批量修改
  batchUpdateProps(filterPlankList.value, { ...form, editValue })
    .then((res) => {
      // 赋值操作
      const { result, hasEditParts } = res

      // 封边预铣处理
      const hasPreEdgePlank = hasEditParts.some(
        (part) => part.edgePreMillingInfo
      )
      const warningTips = extraWarningTips.value(
        prop,
        editValue,
        hasPreEdgePlank
      )
      if (warningTips.length > 0) {
        tips.value.push(...warningTips)
        return
      }
      // 根据hasEditPartIds进行更新plankList
      const newPlankList = plankList.value.map((plank) => {
        return {
          ...plank,
          parts: plank.parts.map((part) => {
            const newPart = hasEditParts.find(
              (p) => p.partUniqueId === part.partUniqueId
            )
            // 复制一个prop，避免对之前的内容产生影响
            let cProp = prop
            if (
              (cProp === 'specHeight' || cProp === 'specWidth') &&
              part.texDir == 'reverse'
            ) {
              cProp = cProp === 'specHeight' ? 'specWidth' : 'specHeight'
            }
            let cPart = part
            if (newPart) {
              ;(newPart[
                prop as Exclude<IEditableFields, 'allEdge'>
              ] as typeof editValue) = editValue
              if (prop === 'texture') {
                part['oriTexture'] = editValue as unknown as string
              }
              cPart = newPart
            }
            // 批量修改完成，判断标识数组里面是否有标记值，如果没有需要加上
            // 因为批量修改即使数据一样也会被重新赋值，对于清除孔槽的属性还是会被清除，所以这里直接添加标记，只要修改了都给标记
            if (!cPart.collectChangeProp) cPart.collectChangeProp = []
            if (!cPart.collectChangeProp.includes(cProp)) {
              cPart.collectChangeProp.push(cProp)
            }
            return newPart || part
          }),
        }
      })

      let newFilterPlankList = result
      // TODO:修改的是需要重新分类的属性
      if (reClassifyProps.includes(prop)) {
        newFilterPlankList = dealFilterData(
          result,
          filterObj.value,
          searchCondition.value,
          specialRemarksForProcessLabel.value
        )
        const newPlankList2 = dealMaterialList(newPlankList)
        setPlankList(newPlankList2)
      } else {
        setPlankList(newPlankList)
      }
      setFilterPlankList(newFilterPlankList)

      let changeParts: ChangePart = []
      // 判断，是否勾选全部行，且不存在筛选，和搜索条件，那么不记录修改的板件的信息
      if (
        !isAllRows ||
        Object.keys(filterObj.value).length ||
        Object.values(searchCondition.value).some((it) => it)
      ) {
        changeParts = hasEditParts.map((part) => {
          return {
            plankId: part.plankID,
            partName: part.partName,
            address: part.address,
          }
        })
      }
      // 生成操作记录(如果，不是全部行或者存在筛选那么就要记录修改的板件的信息)
      addOperateRecord({
        prop,
        value: editValue,
        changeParts,
        address: orderInfo.value.order_address,
      })
      isShowBatchChangePropsModal.value = false
    })
    .catch((error) => {
      // 报错关闭确认按钮loading
      isUpdating.value = false
      console.log(error, 'error,批量修改错误')
      isShowBatchChangePropsModal.value = false
    })
    .finally(() => {
      console.log('批量修改耗时', performance.now() - startTime)
      isUpdating.value = false
    })
}

const { addOperateRecord, saveOperateRecord, resetOperateRecord } =
  useRecordData()

// 修改后需要重新分类的属性
const reClassifyProps = ['matCode', 'texture', 'thick', 'is_high_gloss_plank']

// 需要清理孔槽信息的属性
const needClearHoleSlotsProps = [
  'specHeight',
  'specWidth',
  'frontEdge',
  'backEdge',
  'leftEdge',
  'rightEdge',
  'thick',
  'allEdge', // 批量修改时可以选择所有修边，传入的prop为allEdge
]

// 需要清理骨骼门标识的属性
const needClearFrameDoorIdentityProps = [
  'texDir',
  'matCode',
  'texture',
  'is_high_gloss_plank',
]

/** @descript 修改后会影响对纹的板件字段 */
const affectTextureProps = [
  'texDir',
  'matCode',
  'texture',
  'is_high_gloss_plank',
  'leftEdge',
  'rightEdge',
  'frontEdge',
  'backEdge',
  'allEdge',
  'thick',
  'specHeight',
  'specWidth',
]

/** needClearHoleSlotsProps、needClearFrameDoorIdentityProps 变更后骨骼门合并关系失效 */
function shouldClearFrameDoorIdentity(prop: string) {
  return (
    needClearHoleSlotsProps.includes(prop as any) ||
    needClearFrameDoorIdentityProps.includes(prop as any)
  )
}

function partHasFrameDoorIdentity(part: PartType) {
  const v = (part as PartType & { frame_door?: unknown }).frame_door
  return v !== undefined && v !== null && v !== ''
}

function clearFrameDoorIdentityIfPresent(part: PartType) {
  const p = part as PartType & { frame_door?: unknown; children?: unknown }
  if (
    p.frame_door === undefined ||
    p.frame_door === null ||
    p.frame_door === ''
  ) {
    return
  }
  // 须用 undefined 覆盖而非 delete：assignPart 使用 Object.assign(part, newPart)，
  // delete 掉的属性不会出现在 newPart 上，无法清除 plankList 里已存在的 frame_door
  p.frame_door = undefined
}

// 批量修改料单属性
const batchUpdateProps = (
  plankList: PlankType[],
  payload: IBatchUpdateCallbackParams
): Promise<{
  result: PlankType[]
  hasEditParts: PartType[]
}> => {
  let { prop, isAllRows, editValue } = payload
  return new Promise((resolve) => {
    // 记录修改的板件的id，用于后面修改plankList的数据
    // const hasEditPartIds: string[] = []
    const hasEditParts: PartType[] = []
    const result = plankList.map((plank) => {
      return {
        ...plank,
        parts: plank.parts.map((part) => {
          const copyPart = JSON.parse(JSON.stringify(part))
          if (isAllRows || part.isSelected) {
            // hasEditPartIds.push(part.partUniqueId)
            if (prop === 'texDir') {
              part.beforeTexDir = copyPart.texDir
              changeTexDir(part, editValue)
            } else if (needClearHoleSlotsProps.includes(prop)) {
              let edgeObj = {}
              if (prop === 'allEdge') {
                edgeObj = {
                  frontEdge: editValue,
                  backEdge: editValue,
                  leftEdge: editValue,
                  rightEdge: editValue,
                }
              }
              if (prop === 'thick') {
                // 清除板子的品牌信息
                part.brandName = ''
                part.supplierName = ''
                part.colorId = ''
              }
              part = compose(
                clearPlankObjHoleSlotsInfo,
                plankSpecialDeal
              )({
                ...part,
                [prop]: editValue,
                ...edgeObj,
              })
            } else if (prop === 'texture') {
              part[prop] = editValue as unknown as string
              part['oriTexture'] = editValue as unknown as string
            } else if (reClassifyProps.includes(prop)) {
              // 清除板子的品牌信息
              part.brandName = ''
              part.supplierName = ''
              part.colorId = ''
            } else {
              // if (prop in part) {
              // 存在导入的json文件中，没有plank_remarks字段
              ;(part[
                prop as Exclude<IEditableFields, 'allEdge'>
              ] as typeof editValue) = editValue
              // }
            }
            if (
              partHasFrameDoorIdentity(copyPart) &&
              shouldClearFrameDoorIdentity(String(prop))
            ) {
              clearFrameDoorIdentityIfPresent(part)
            }
            hasEditParts.push(part)
          }
          return part
        }),
      }
    })
    resolve({ result, hasEditParts })
  })
}
// 清理孔槽信息
const clearPlankObjHoleSlotsInfo = (part: PartType) => {
  const props = [
    'path',
    'oPath',
    'curveHoles',
    'millInfo',
    'edge_length_info',
    'lineSlots',
  ]
  props.forEach((item) => {
    Reflect.deleteProperty(part, item)
  })
  return part
}

// 处理余料形状
const dealSurplusShape = (shape: 0 | 1 | 2) => {
  const shapeObj = {
    0: '矩形',
    1: 'L形',
    2: '异形',
  } as const
  return translateLang(shapeObj[shape])
}

/**
 * 试生产
 */

// 确认试生产的回调
const handleTrialProductConfirm = () => {
  handleProlineIsElectronicSaw(paibanParams.value.isSendToFactory)
}

// 是否是试生产状态
const isTrialProduct = computed(() => store.state.isTrialProduct)

const trailProductState = computed(() => store.state.trailProductState)
/**
 * 偏好设置
 */

const preferencesSetting = ref<Partial<PreferencesSetting>>({
  layoutMethod: '',
  paibanWay: '',
  process_line_id: 0,
  surplusTailorWay: '',
  surplusAutoTailor: false,
  isLessReverse: false,
  isSpecialShape: false,
  shortSideRect: 0,
  longSideRect: 0,
  customRectTemplate: [
    {
      shortSideRect: 250,
      longSideRect: 300,
      thickRect: null,
    },
  ],
  isSetCustomRect: false,
  isCheckBigPlankSynchronous: false,
  isLoadMoreTable: false,
  pick_up_data: false,
  saved_highlight_prop: false,
  isBujianRecommend: true,
  isPaibanStoreRecommend: true,
  isSurplusRecommend: true,
  isDeductionBujian: true,
  isDeductionPaibanStore: true,
  isDeductionSurplus: true,
  isDeductionBaseMaterial: true,
  surplus_lock: false,
  isSurNotLayoutMat: true,
  searchKeyType: 'address',
})
// 当前页面中的偏好设置 初始设置
const currentPreferenceSetting = ref({
  isLoadMoreTable: false, // 导入料单不覆盖
  isDefaultFoldData: false, // 默认收起料单数据
  savedHightLightProp: false, // 获取该用户是否保存过表头
  isCheckBigPlankSynchronous: false, // 是否需要同步柜柜数据
  isBujianRecommend: true, // 是否开启补件
  isPaibanStoreRecommend: true, //是否开启待排版库
  isSurplusRecommend: true, // 是否开启余料
})
// 默认收起数据赋值操作
const handleDefaultFoldData = (payload: boolean) => {
  // 如果勾选了默认收起数据,需要给开料清单，可用余料，可用补件设置默认收起,修改表格不改变默认收起状态
  if (payload) {
    // 可用补件
    store.commit('onChangeTrigger', !payload)
    // 可用余料
    store.commit('onChangeIsShowSurplusList', payload)
    // 开料清单
    const plankList = filterPlankList.value.map((plank) => {
      return {
        ...plank,
        isUnfold: !payload,
      }
    })
    setFilterPlankList(plankList)
    // 待排版库收起
    nextTick(() => {
      awaitStoreRef.value?.setExpand(!payload)
    })
  }
}

// 保存偏好设置时，自定义字段和接口参数字段映射
const savePreferences = async (
  e: { target: { checked: boolean } },
  type: keyof typeof allPerfSettingMap
) => {
  try {
    if (!e.target) return
    const checked = e.target.checked
    preferencesSetting.value[allPerfSettingMap[type]] = checked
    currentPreferenceSetting.value[CurrentPerfSettingMap[type]] = checked
    updateLocalPreference(preferencesSetting.value as any)
    switch (type) {
      case 'fold':
        handleDefaultFoldData(checked)
        break
    }
  } catch (error) {
    Vue.prototype.$message({
      message: '网络错误，请重新修改',
      type: 'error',
    })
  }
}

// 处理埋点
const handleBury = () => {
  if (currentPreferenceSetting.value.isLoadMoreTable) {
    buryPointApi('material', 'import_list_notCover')
  }
  if (currentPreferenceSetting.value.isDefaultFoldData) {
    buryPointApi('material', 'default_fold')
  }
  if (currentPreferenceSetting.value.isBujianRecommend) {
    buryPointApi('material', 'bujian_recommend')
  }
  if (currentPreferenceSetting.value.isPaibanStoreRecommend) {
    buryPointApi('material', 'store_plank_recommend')
  }
  if (currentPreferenceSetting.value.isSurplusRecommend) {
    buryPointApi('material', 'surplus_plank_recommend')
  }
}

// 三方数据
const thirdPlankData = computed(() => store.state.thirdPlankData)

const batchPaiban = computed(() => store.state.batchPaiban)

// 开料清单原始数据
const preLayoutData = computed<PartType[]>(() => store.state.preLayoutData)

// 订单信息
const orderInfo = computed(() => store.state.orderInfo)

const dealJsonData = async (data: Record<string, any>, isClearData = false) => {
  // 导入json数据不显示样表头
  store.commit('setIsShowSample', false)
  if (data.paibanInfo) {
    const paibanInfo = {
      ...store.state.paibanInfo,
      ...data.paibanInfo,
    }
    if (
      !Object.prototype.hasOwnProperty.call(data.paibanInfo, 'influenceOptions')
    ) {
      delete paibanInfo.influenceOptions
    }
    store.commit('setPaibanInfo', paibanInfo)
  }
  const currentLine = proLineList.value.find(
    (item) => data.process_setting_id === item.id
  )
  // 将json文件中的生产线记录保存
  store.commit(
    'setRecodrProductionLineChoose',
    currentLine ? currentLine.name : data.process_setting_name
  )

  if (data.hasOwnProperty('layoutResult')) {
    store.commit('clearPaibanData')
    store.commit('setIsTrialProduct', false)
    dealGuiguiJson(JSON.parse(data.layoutResult)).then(async (res: any) => {
      store.commit('changeDataFrom', 'ggpc')
      initData(
        res,
        {
          isClearHSInfo: false,
          isLoadMore: currentPreferenceSetting.value.isLoadMoreTable,
          isToggle: false,
        },
        true
      )
    })
  } else if (data.hasOwnProperty('layoutData')) {
    // 如果是生产宝转换过来的数据，进行一次旋转，调整其纹理不正确问题(本质上这个问题是云排版引起的，只是为了临时解决)
    if (data?.source_platform === 'guigui_converter') {
      data.layoutData.forEach((item: any) => {
        if (item.texDir === 'reverse') {
          rotatePlank(item, 1)
        }
        // 是否来至柜柜转换器
        item._isInGuiGuiConverter = true
      })
    }
    // const hasPreLayoutData = preLayoutData.value && preLayoutData.value.length
    const hasPreLayoutData = importCount.value > 1

    data.layoutData = dealPreLayoutDataLabelID(
      data.layoutData.map((item: any) => {
        const partUniqueId =
          hasPreLayoutData && currentPreferenceSetting.value.isLoadMoreTable
            ? nanoid()
            : item.partUniqueId ?? nanoid()
        return {
          ...item,
          partUniqueId,
          oriPartUniqueId: partUniqueId,
          srcTexDir: item.texDir,
          srcPath:item.path ? item.path[0] :null,
          sholes: item.sholes.map((hole: any) => ({
            ...hole,
            side: Number(hole.side),
          })),
          sslots: item.sslots.map((slot: any) => ({
            ...slot,
            side: Number(slot.side),
          })),
        }
      })
    )
    // 清空排版相关数据
    store.commit('clearPaibanData')
    store.commit('setIsTrialProduct', false)
    initData(
      data.layoutData,
      {
        isClearHSInfo: false,
        isLoadMore: currentPreferenceSetting.value.isLoadMoreTable,
        isToggle: false,
      },
      true
    )
    if (data.paibanData?.length) {
      store.commit('setIsNewPaiban', false)
      const newPaibanData = data.paibanData.map((plank: PlankType) => {
        const {
          oriTextures = [],
          allColors = [],
          stockKeys = [],
          oriBigTexture = plank.texture,
          parts = [],
          ...rest
        } = plank
        return {
          ...rest,
          oriTextures,
          allColors,
          stockKeys,
          oriBigTexture,
          parts: parts.map((part) => {
            return {
              ...part,
              oriTexture: part.oriTexture || part.texture,
            }
          }),
        }
      })

      store.commit('setPaibanData', dealPaibanDataLabelID(newPaibanData))
      const params: { setting_id: number; production_from?: 'guimen' } = {
        setting_id: data.process_setting_id as number,
      }
      if (window.sessionStorage.getItem('thinkerx_material')) {
        params.production_from = 'guimen'
      }
      const isPreLayout =
        !data.process_setting_id ||
        data.process_setting_id == -2 ||
        (data.process_setting_name &&
          data.process_setting_name.includes('预排版方案'))
      if (isPreLayout) {
        const layoutSetting = data.preLayoutSetting
          ? { data: data.preLayoutSetting }
          : await getPrelayoutSetting()
        const { setting_value: setting } = layoutSetting.data
        const ncSetting = dealPreLayoutSetting(setting)
        store.commit('setPreLayoutSetting', layoutSetting.data)
        store.commit('setOriLayoutSetting', data.preLayoutSetting) // 保存排版用预排版设置
        store.commit('setNcSetting', ncSetting)
      } else {
        const {
          data: resData,
          status,
          msg,
        } = await fetchGetProductionNcSetting(params)
        if (status !== 1) {
          if (data.paibanData.length) {
            Vue.prototype.$message({
              message: `${msg.replace(/'/g, '')},${translateLang(
                '无法直接查看排版方案,请点击开始排版！'
              )}`,
              type: 'error',
            })
            store.commit('setPaibanData', [])
          }
          return
        }
        // TODO: 检查刀具是否符合
        judgePlateKnife(data.plate_knife_map, selectedParts.value)
        if (isError.value) return
        // TODO: 检查五六面钻配置
        if (oldFiveSixXYTip(status)) return

        // 绘制尺寸对调
        const drawPlankWidth: number = resData.xyReverse
          ? selectStandardPlank.value.plankHeight
          : selectStandardPlank.value.plankWidth
        const drawPlankHeight: number = resData.xyReverse
          ? selectStandardPlank.value.plankWidth
          : selectStandardPlank.value.plankHeight

        const ncSetting = Object.assign(resData, {
          process_setting_id: data.process_id ?? data.process_setting_id,
          process_setting_name: data.process_setting_name,
          drawPlankWidth,
          drawPlankHeight,
        })
        // 防止新账号没有顺逆时针的设置
        if (!ncSetting.cutDirection) {
          ncSetting.cutDirection = '逆时针'
        }
        store.commit('setNcSetting', ncSetting)
      }
    }
  }
  if (!store.state.orderInfo.batch) {
    // 第一次导入或者以前的订单 batch 为false
    // 初次加载
    if (isFirstLoadJson) {
      isFirstLoadJson.value = false
      store.commit(
        'setOrderInfo',
        Object.assign(store.state.orderInfo, {
          batch: data.paibanInfo?.batch,
        })
      )
    } else {
      store.commit('setOrderInfo', store.state.orderInfo)
    }
  } else {
    // 以前的订单batch 为 true， 或者是柜柜跳转过来的
    isFirstLoadJson.value = false
    store.commit(
      'setOrderInfo',
      Object.assign(store.state.orderInfo, {
        batch: data.paibanInfo?.batch,
      })
    )
  }

  // 设置导入json文件中的混排方案
  store.commit(
    'materialListStore/setSelectedMixPaibanPlans',
    data.paibanInfo?.mixPaibanPlans || []
  )
  if (isClearData) store.commit('clearPaibanData')
}

const dealDataFromGuigui = async () => {
  if (!window.localStorage.getItem('debugger')) {
    window.history.replaceState('', '', '#' + route.path)
  }
  const id =
    route.query.data_id ||
    JSON.parse(window.sessionStorage.getItem('guiguiJumpEquipmentParams')!)
      ?.data_id
  const order_ids: string[] = []
  const order_codes: string[] = []
  const room_ids: string[] = []
  const needPaibanRoomIds: string[] = []
  const res = await fetchGuiguiOrderInfo({ id })
  if (res.status !== 1) {
    Vue.prototype.$message({
      message: translateLang('未查询到相关板件!请确认是否绘制板件!'),
      type: 'error',
    })
    return
  }
  if (Object.keys(res.data).length) {
    const list = JSON.parse(res.data)
    const data = list.filter((item: any) => !item.hasOwnProperty('exportType'))
    const bujianList = list.filter((item: any) =>
      item.hasOwnProperty('exportType')
    )
    // 记录订单信息
    for (let i = 0; i < data.length; i++) {
      order_ids.push(data[i].projectInfo.id)
      order_codes.push(data[i].projectInfo.order_code)
      let roomIds = data[i].projectInfo.room_ids.split(',').map(Number)
      room_ids.push(...roomIds)
      if (data[i].hasOwnProperty('roomIds')) {
        needPaibanRoomIds.push(...data[i].roomIds)
      }
    }
    const orderInfo: OrderInfoType = {
      order_ids: order_ids.join(','),
      order_codes: order_codes.join(','),
      needPaibanRoomIds: needPaibanRoomIds,
      room_ids: room_ids,
      bujianPlankId: {},
      needBujianRoomId: [],
      addition_info: [],
    }

    if (bujianList.length) {
      orderInfo.bujianPlankId = {}
      const bjPlankMock = bujianList[0].complementOrders
      // 记录需要补件的房间id
      orderInfo.needBujianRoomId = []
      // 获取预处理数据需要传新的render_json
      orderInfo.addition_info = []
      bjPlankMock.forEach((item: any) => {
        orderInfo.order_ids += ',' + item.oid
        orderInfo.order_codes += ',' + item.order_code
        item.plates.forEach((e: any) => {
          if (!orderInfo.needBujianRoomId.includes(e.rid)) {
            orderInfo.needBujianRoomId.push(e.rid)
          }
          orderInfo.addition_info.push({
            room_id: e.rid as string,
            render_url: e.render_url as string,
          })
          if (!orderInfo.bujianPlankId[e.rid]) {
            orderInfo.bujianPlankId[e.rid] = []
          }
          orderInfo.bujianPlankId[e.rid].push({
            plankId: e.plankId,
            ggid: e.ggid,
            address: item.buyer_address,
            orderNo: item.order_code,
            oid: item.oid,
            plankNum: e.plate_info?.plankNum,
            customerName: item.customer_name,
          })
        })
      })
    }
    await handleTrailState(orderInfo)
    store.commit('setOrderInfo', orderInfo)
    await getLayoutData()
    if (window.webToQt) {
      buryPointApi('guigui', 'enter_bluen_embed')
    }
    buryPointApi('guigui', 'enter_bluen_web')
  }
}
const handleTrailState = async (orderInfo: any) => {
  const params = {
    is_get_layout_data: 0,
  }
  const res = await fetchMaterialTransData(params)
  if (res.status === 1) {
    if (
      res.data.state === 1 &&
      orderInfo.room_ids.includes(res.data.trial_room_id)
    ) {
      ;(vm?.proxy as any).$antdConfirm({
        title: '温馨提示',
        content:
          '当前试生产订单已调整为使用当前账号的工艺设置数据，请注意您的工艺设置！',
        okText: '确定',
        class: 'trail-tech-modal',
        centered: true,
      })
    }
    if (orderInfo.room_ids.includes(res.data.trial_room_id)) {
      store.commit('setIsTrialProduct', true)
    }
  }
}

const getLayoutData = async () => {
  emptyShow.value = true
  store.commit('setIsShowSample', false)
  store.commit('setIsLinkLogin', true)
  const params = {
    room_ids: !orderInfo.value.needPaibanRoomIds.length
      ? orderInfo.value.room_ids
      : orderInfo.value.needPaibanRoomIds,
    addition_info: orderInfo.value.addition_info,
  }
  const res = await fetchGetLayoutData(params)

  isTaskLoading.value = false
  isTableEmpty.value = false
  if (res.status !== 1) {
    emptyShow.value = false
    modalMsg(
      res.msg,
      'warning',
      translateLang('提示'),
      null,
      {},
      'getLayoutData'
    )
    return
  }
  const orderGroup = res.data.result_data.reduce(
    (res: any, item: PartType[]) => {
      if (Array.isArray(item) && item.length > 0) {
        const orderId = item[0].orderId
        res[orderId] = item.length
      }
      return res
    },
    {}
  )
  store.commit(
    'setOrderInfo',
    Object.assign(store.state.orderInfo, {
      batch: res.data.batch && orderGroup,
    })
  )
  let arr: any[] = []
  const bujanArr = res.data.addition_data
  for (let i = 0; i < res.data.result_data.length; i++) {
    arr = [
      ...arr,
      ...res.data.result_data[i].map((part: any) => {
        const newPart = {
          ...part,
          srcTexDir: part.texDir,
        }
        if(part.path){
          newPart.srcPath = part.path[0]
        }
        return newPart
      }),
    ]
  }
  // 找出需要补件的小板
  if (bujanArr && bujanArr.length) {
    arr = arr.concat(handleBujianPlanks(bujanArr))
  }
  const addr: string[] = []
  for (let i = 0; i < arr.length; ++i) {
    const part = arr[i]
    const orderNo = part._isBujian
      ? part._bujianOrderNo ?? part.orderNo
      : part.orderNo
    const address = part._isBujian
      ? part._bujianAddress ?? part.address
      : part.address
    const code_addr =
      window.sessionStorage.getItem('thinkerx_material') || part.groupNo
        ? `${part.groupNo}`
        : `${orderNo}-${address}`
    if (!addr.includes(code_addr)) {
      addr.push(code_addr)
    }
  }
  const newOrderInfo = Object.assign(orderInfo.value, {
    order_address: addr.join(','),
  })
  store.commit('setOrderInfo', newOrderInfo)
  // 记录当前开料清单中所有订单的订单id和订单号, 以便排版接口和保存接口调用时使用
  store.commit('setPreLayoutParam', {
    type: 'roomId',
    data:
      orderInfo.value.needPaibanRoomIds.length == 0
        ? orderInfo.value.room_ids
        : orderInfo.value.needPaibanRoomIds,
    orderInfo: orderInfo.value,
  })

  await fetchAndSetBrandInfo(arr)

  initData(arr)
  const prePlankList = preLayoutData.value.length
    ? preLayoutData.value
    : getAllParts(plankList.value)
  const ggOrderIds = prePlankList.map((item) =>
    item._isBujian ? item._bujianOid : item.orderId
  )
  localStorage.setItem('ggOrderIds', JSON.stringify(ggOrderIds))
  emptyShow.value = false
}

// 是否来自老板良的数据
const isFromLbl = ref(false)
// 处理老板良跳转进来的参数
const dealDataFromLbl = async () => {
  emptyShow.value = true

  const oids = route.query.oids
  let order_ids: any[] = []
  if (typeof oids === 'string') {
    order_ids = oids?.split(',').map(String)
  }
  const order_codes = route.query.codes
  const orderInfo = {
    order_ids: oids,
    order_codes: order_codes,
    needPaibanRoomIds: [],
    room_ids: [],
  }
  isFromLbl.value = true
  buryPointApi('lbl', 'optimize_layout')
  const res = await fetchGetLayoutData({ order_ids })
  isTableEmpty.value = false
  if (res.status !== 1) {
    emptyShow.value = false
    Vue.prototype.$message({
      message: translateLang('未查询到相关板件!请确认是否绘制板件!'),
      type: 'error',
    })
    return
  }
  let arr: any[] = []
  for (let i = 0; i < res.data.result_data.length; i++) {
    arr = [
      ...arr,
      ...res.data.result_data[i].map((part: any) => ({
        ...part,
        srcTexDir: part.texDir,
        srcPath: part.path ? part.path[0] : null,
      })),
    ]
  }
  let addr: any[] = []
  for (let i = 0; i < arr.length; ++i) {
    let code_addr =
      window.sessionStorage.getItem('thinkerx_material') || arr[i].groupNo
        ? `${arr[i].groupNo}`
        : `${arr[i].orderNo}-${arr[i].address}`
    if (addr.length == 0) {
      addr.push(code_addr)
    } else {
      if (!addr.includes(code_addr)) {
        addr.push(code_addr)
      }
    }
  }
  let newOrderInfo = Object.assign(orderInfo, {
    order_address: addr.join(','),
  })
  store.commit('setOrderInfo', newOrderInfo)
  store.commit('setPreLayoutParam', {
    type: 'orderId',
    data: order_ids,
    orderInfo: newOrderInfo,
  })
  initData(arr)
  emptyShow.value = false
}

// 将指定的类型从联合类型中删除，返回一个新的联合类型
const currentHeadPropList = computed<IPropList[]>(() => {
  const saved = storePreferencesSetting.value?.needSaveData as
    | IPropList[]
    | undefined
  if (!saved) return headPropList
  // 老用户偏好里缓存的字段配置可能缺少新增的 interactionType，按 prop 用默认池兜底
  return saved.map((item) => {
    if (item.interactionType) return item
    const defaultItem = (allTableHeaderList as ReadonlyArray<IPropList>).find(
      (d) => d.prop === item.prop
    )
    return defaultItem?.interactionType
      ? { ...item, interactionType: defaultItem.interactionType }
      : item
  })
})

const typeColumnHeadDisplayText = computed(() => {
  const typeHeader = currentHeadPropList.value.find(
    (item) => item.prop === 'type'
  )
  return typeHeader?.customLabel != null
    ? translate(typeHeader.customLabel)
    : translateLang('门板')
})

// 检查是否是异形
const checkIsSpecial = (part: PartType) => {
  if (!part.specialShape) return ''
  if (
    part.curveHoles &&
    part.curveHoles.length &&
    part.path &&
    part.path?.length < 2 &&
    part.path[0] &&
    part.path[0]?.length < 5
  ) {
    return part.curveHoles.every((hole) => hole.disType == 'CCCurveSlot')
      ? ''
      : translateLang('异形')
  } else {
    return translateLang('异形')
  }
}

/**
 * 修改单个板件属性
 */

// 类型需要修正的属性
const needFixTypeProps = [
  'thick',
  'specHeight',
  'specWidth',
  'frontEdge',
  'backEdge',
  'leftEdge',
  'rightEdge',
  'amount',
] as const

// 输入的属性的修改
//记录，某个属性修改前的值
const nowInputWord = ref<any>('')

/**
 * 在当前料单页面清除对纹信息
 * 统一处理 filterPlankList / plankList / store 三处数据
 */
const clearTextureGrainInfoInPage = (parts: PartType | PartType[]) => {
  const list = Array.isArray(parts) ? parts : [parts]
  const ids = new Set(list.map((p) => p.partUniqueId))
  clearTextureGrainInfo(list)
  ;[filterPlankList.value, plankList.value].forEach((planks) => {
    planks.forEach((plank: PlankType) => {
      plank.parts?.forEach((part: PartType) => {
        if (ids.has(part.partUniqueId)) {
          clearTextureGrainInfo(part)
        }
      })
    })
  })

  store.state.preLayoutData.forEach((part: PartType) => {
    if (ids.has(part.partUniqueId)) {
      clearTextureGrainInfo(part)
    }
  })
}

/**
 * 修改影响对纹的属性前确认
 * 是纹理对齐板件 + 属性在 affectTextureProps 中 → 弹窗确认
 * 确认后清除 textureGrainInfo；取消则返回 false
 */
const handleTexturePropChangeConfirm = async (
  part: PartType,
  prop: string
): Promise<boolean> => {
  if (affectTextureProps.includes(prop) && isTextureAlignmentPlank(part)) {
    const confirmed = await showTextureConfirmModal(
      translateLang('当前操作会清除板件对纹信息，请确认是否继续？'),
      [part]
    )
    return confirmed
  }
  return true
}

// 修改料单数据,失焦的时候触发
const handleInputBlur = async (data: any) => {
  const startTime = performance.now()
  const { key, part } = data
  const oldValue = nowInputWord.value
  if (part[key] == oldValue) return
  try {
    const canProceed = await handleTexturePropChangeConfirm(part, key)
    if (!canProceed) {
      part[key] = oldValue
      return
    }

    const newPart = handleDealChangePartData(data, oldValue)
    changeProp(newPart, key)

    addOperateRecord({
      prop: key,
      oldValue,
      value: part[key],
      changeParts: [
        {
          plankId: part.plankID,
          partName: part.partName,
          address: part.address,
        },
      ],
      address: orderInfo.value.order_address,
      textKey: '单独修改',
    })
  } catch (error) {
    console.log('修改数据出错', error)
  } finally {
    console.log('修改单个属性耗时:', performance.now() - startTime)
  }
}
// 存储修改了料单数据的位置
const collectChangeProp = {}
// 处理修改料单数据的方法
const handleDealChangePartData = (
  data: {
    part: PartType
    key: Exclude<IEditableFields, 'allEdge'>
  },
  oldValue: any
) => {
  const { part, key: prop } = data
  if (part[prop] == oldValue) throw new Error('属性未修改')

  if (prop === 'thick') {
    // 清除板子的品牌信息
    part.brandName = ''
    part.supplierName = ''
    part.colorId = ''
  }
  let newPart = { ...part }
  // 如果修改的是板件的长宽或者封边,需要清除孔槽信息
  if (needClearHoleSlotsProps.includes(prop)) {
    // 如果是已有的板件, 则将其处理成空板
    if (!part.isManual) {
      // 清除孔槽信息
      newPart = compose(clearPlankObjHoleSlotsInfo, plankSpecialDeal)(part)
    } else {
      const isReverse = part.texDir == 'reverse'
      let width = isReverse ? +part.specHeight : +part.specWidth
      let height = isReverse ? +part.specWidth : +part.specHeight
      const hEdge = Number(part.leftEdge) + Number(part.rightEdge)
      const vEdge = Number(part.frontEdge) + Number(part.backEdge)
      const { width: preEdgeWidth, appliedSides } =
        part.edgePreMillingInfo || {}
      const { top, right, bottom, left } = appliedSides || {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
      }
      let widthEdge = 0
      let heightEdge = 0

      widthEdge += Number(right) + Number(left)
      heightEdge += Number(top) + Number(bottom)

      part.oRect = {
        x: 0,
        y: 0,
        width: width,
        height: height,
      }

      part.rect = {
        x: 0,
        y: 0,
        width: toDecimal(
          width -
            (isReverse ? vEdge : hEdge) +
            (isReverse ? widthEdge : heightEdge),
          2
        ),
        height: toDecimal(
          height -
            (isReverse ? hEdge : vEdge) +
            (isReverse ? heightEdge : widthEdge),
          2
        ),
      }
      part.realRect = { ...part.rect }
      part.realCurve = [
        { x: 0, y: 0 },
        { x: part.oRect.width, y: 0 },
        { x: part.oRect.width, y: part.oRect.height },
        { x: 0, y: part.oRect.height },
      ]
      part.edgeInfo = `←${part.leftEdge ?? 0}↓${part.backEdge ?? 0}→${
        part.rightEdge ?? 0
      }↑${part.frontEdge ?? 0}`
      newPart = part
    }
  } else if (reClassifyProps.includes(prop)) {
    // 修改了材质，厚度，颜色等属性后，需要进行重新分类
    // if (part.matCode && !part.matCode.includes('高光_')) {
    //   part.is_high_gloss_plank = false
    //   newPart.is_high_gloss_plank = false
    // }
    // 清除板子的品牌信息
    newPart.brandName = ''
    newPart.supplierName = ''
    newPart.colorId = ''
  }
  if (partHasFrameDoorIdentity(part) && shouldClearFrameDoorIdentity(prop)) {
    clearFrameDoorIdentityIfPresent(newPart)
  }
  // 成品长宽变更时同步重算成品面积，保持与 oRect 一致
  if (prop === 'specHeight' || prop === 'specWidth') {
    newPart.finishedArea = toDecimal(
      (Number(newPart.specWidth) * Number(newPart.specHeight)) / 1000000,
      2
    )
  }
  return newPart
}

// 下拉项属性修改
const handleSelectChange = async (
  prop: 'type' | 'texDir' | 'is_high_gloss_plank',
  part: PartType,
  val?: any
) => {
  const oldValue = part[prop]
  const startTime = performance.now()
  try {
    const canProceed = await handleTexturePropChangeConfirm(part, prop)
    if (!canProceed) {
      part[prop] = oldValue
      return
    }

    const changePropMapFn = new Map<typeof prop, (...args: any[]) => any>([
      ['texDir', changeTexDir],
    ])
    const fn = changePropMapFn.get(prop)
    if (fn) {
      fn(part, val)
    }
    if (
      partHasFrameDoorIdentity(part) &&
      (prop === 'texDir' || prop === 'is_high_gloss_plank')
    ) {
      clearFrameDoorIdentityIfPresent(part)
    }
    if (prop === 'is_high_gloss_plank') {
      // 清除板子的品牌信息
      part.brandName = ''
      part.supplierName = ''
      part.colorId = ''
    }
    changeProp({ ...part, [prop]: val }, prop)

    addOperateRecord({
      prop,
      oldValue,
      value: val,
      changeParts: [
        {
          plankId: part.plankID,
          partName: part.partName,
          address: part.address,
        },
      ],
      address: orderInfo.value.order_address,
      textKey: '单独修改',
    })
  } catch (error) {
    console.log('error', error)
  } finally {
    console.log('修改单个属性耗时:', performance.now() - startTime)
  }
}

// 按下回车键时, 改为触发失焦事件, 防止调用两次失焦事件
const updateBlur = (e: ChangeEvent<HTMLInputElement>) => {
  e.target.blur()
}

// 点击料单单元格 materialCellClick
const handleClickCell = (
  part: PartType,
  field: Exclude<IEditableFields, 'allEdge'>
) => {
  if (
    part.texDir == 'reverse' &&
    (field == 'specHeight' || field == 'specWidth')
  ) {
    field = field == 'specHeight' ? 'specWidth' : 'specHeight'
  }
  nowInputWord.value = part[field]
}

// 板件修改的特殊处理
const plankSpecialDeal = (plank: PartType) => {
  let width = Number(plank.specWidth)
  let height = Number(plank.specHeight)
  let widthEdge = 0
  let heightEdge = 0
  const { width: preEdgeWidth, appliedSides } = plank.edgePreMillingInfo || {}
  const { top, right, bottom, left } = appliedSides || {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  }
  if (preEdgeWidth && Number(preEdgeWidth) > 0) {
    widthEdge += Number(right) + Number(left)
    heightEdge += Number(top) + Number(bottom)
  }
  let newPlank = {
    ...plank,
    oRect: {
      x: 0,
      y: 0,
      width: width,
      height: height,
    },
    rect: {
      x: 0,
      y: 0,
      width: toDecimal(
        width -
          Number(plank.leftEdge) -
          Number(plank.rightEdge) +
          Number(widthEdge),
        2
      ),
      height: toDecimal(
        height -
          Number(plank.frontEdge) -
          Number(plank.backEdge) +
          Number(heightEdge),
        2
      ),
    },
    realCurve: [
      { x: 0, y: 0 },
      { x: plank.oRect.width, y: 0 },
      { x: plank.oRect.width, y: plank.oRect.height },
      { x: 0, y: plank.oRect.height },
    ],
    realRect: {
      x: 0,
      y: 0,
      width: toDecimal(
        width -
          Number(plank.leftEdge) -
          Number(plank.rightEdge) +
          Number(widthEdge),
        2
      ),
      height: toDecimal(
        height -
          Number(plank.frontEdge) -
          Number(plank.backEdge) +
          Number(heightEdge),
        2
      ),
    },
    specialShape: false,
    hsInfo: '0孔0槽',
    edgeInfo: `←${plank.leftEdge}↓${plank.backEdge}→${plank.rightEdge}↑${plank.frontEdge}`,
    typeSymbol: `${plank.matCode}:${plank.thick}:${plank.texture}`,
    holes: [],
    sholes: [],
    slots: [],
    handleSlopes: [],
    sslots: [],
    fullSize: {},
    // 长宽变更后同步刷新成品面积，避免单条/批量修改后该字段失真
    finishedArea: toDecimal((width * height) / 1000000, 2),
  }
  return newPlank as unknown as PartType
}

// 修改板件数据
const assignPart = (
  plankList: PlankType[],
  newPart: PartType,
  isNeedPath = true,
  prop: string
) => {
  const hasEditPlankUniID = newPart.partUniqueId
  let part: PartType | undefined
  plankList.find((plank) => {
    part = plank.parts.find((part) => part.partUniqueId === hasEditPlankUniID)
    if (part) return true
  })
  if (part) {
    Object.assign(part, newPart)
    part.specHeight = Number(part.specHeight)
    part.specWidth = Number(part.specWidth)
    part.srcTexDir = JSON.parse(JSON.stringify(newPart)).srcTexDir
    part.srcPath = JSON.parse(JSON.stringify(newPart)).srcPath
    if (!isNeedPath) {
      part = clearPlankObjHoleSlotsInfo(part)
    }
    if (!part.collectChangeProp) part.collectChangeProp = []
    const specialTreatedAttributes = ['specHeight', 'specWidth']
    let targetProp = prop
    if (specialTreatedAttributes.includes(prop) && part.texDir == 'reverse') {
      targetProp = prop == 'specHeight' ? 'specWidth' : 'specHeight'
    }
    if (!part.collectChangeProp.includes(targetProp)) {
      part.collectChangeProp.push(targetProp)
    }
  }
  return plankList
}

// 板件数据类型修正
const fixPlankDataType = (
  part: PartType,
  prop: Exclude<IEditableFields, 'allEdge'>
) => {
  return {
    ...part,
    [prop]: Number(part[prop]),
  }
}

const virtualListRef = ref<InstanceType<typeof virtualList> | null>(null)
// 纹理,修改前，聚焦时获取修改前的值
const handleFocusPlankTexDir = (plank: PartType) => {
  // 记录之前的纹理
  if (!plank.beforeTexDir) {
    plank.beforeTexDir = plank.texDir
  }
  handleClickCell(plank, 'texDir')
  virtualListRef.value?.itemClick({
    part: plank,
    field: 'texDir',
  })
}
// 修改纹理前， 需要执行的函数
const changeTexDir = (part: PartType, value: any) => {
  // 当切换到横纹时, 则将板件数据旋转90度
  if (value === 'reverse' && part.beforeTexDir !== 'reverse') {
    rotatePlank(part, 1)
  }
  // 如果是从横纹切换到竖纹和无纹理, 则旋转-90度
  if (value === 'normal' && part.beforeTexDir !== 'normal') {
    rotatePlank(part, -1)
  }
  if (value === 'notcare' && part.beforeTexDir === 'reverse') {
    rotatePlank(part, 1)
  }
  if (part.beforeTexDir === 'notcare' && value === 'normal') {
    rotatePlank(part, -1)
  }
  part.srcTexDir = value
  part.beforeTexDir = value
  part.texDir = value
}
const rotatePlank = (part: PartType, direction: 1 | -1) => {
  let isReverse = !(part['isReverse'] || false)
  let rect = part['rect']
  let oRect = part['oRect']
  let startX = part['startX']
  let startY = part['startY']
  let paths = part['path']
  let oPaths = part['oPath']
  let cutCurve = part['cutCurve']
  let cutCurveEx = part['cutCurveEx']
  let realCurve = part['realCurve']
  let realCurveEx = part['realCurveEx']
  let holes = part['holes']
  let slots = part['slots']
  let handleSlopes = part['handleSlopes']
  let sholes = part['sholes']
  let sslots = part['sslots']
  let realRect = part['realRect']
  let edgeInfo = part['edgeInfo']
  let edgeTextureMap = part['edge_texture_map']
  let sholeInfo = part['sholeInfo']
  let sholeInfoF = part['sholeInfoF']
  let sslotInfo = part['sslotInfo']
  let sslotInfoF = part['sslotInfoF']
  let curveHoles = part['curveHoles']
  let millInfo = part['millInfo']
  let oriCurveHoles = part['oriCurveHoles']
  let lineSlots = part['lineSlots'] ?? []
  let oldSize = part['oldSize']
  let edgeArrowMap = part['edgeArrowMap']

  let o = {
    x: rect.width / 2,
    y: rect.height / 2,
  }

  let oo = {
    x: oRect.width / 2,
    y: oRect.height / 2,
  }
  // rect
  rect = {
    x: 0,
    y: 0,
    width: rect.height,
    height: rect.width,
  }

  oRect = {
    x: 0,
    y: 0,
    width: oRect.height,
    height: oRect.width,
  }
  if (oldSize) {
    oldSize = {
      width: oldSize.height,
      height: oldSize.width,
    }
  }

  // realRect
  realRect = {
    x: 0,
    y: 0,
    width: realRect.height,
    height: realRect.width,
  }

  // paths
  for (var i in paths) {
    var path = paths[i]
    for (var j in path) {
      var p = path[j]
      var x = p['x'] - o.x
      var y = p['y'] - o.y

      p['x'] = -direction * y + o.y
      p['y'] = direction * x + o.x
    }
  }
  if (curveHoles) {
    for (var i in curveHoles) {
      let path = curveHoles[i]['path']
      const nativePath = curveHoles[i]['native_path'] ?? []
      for (let j in path) {
        var p = path[j]
        var x = p['x'] - o.x
        var y = p['y'] - o.y

        p['x'] = -direction * y + o.y
        p['y'] = direction * x + o.x
      }
      for (let j in nativePath) {
        const p = nativePath[j]
        var x = p['x'] - o.x
        var y = p['y'] - o.y

        p['x'] = -direction * y + o.y
        p['y'] = direction * x + o.x
      }
    }
  }
  if (millInfo) {
    for (let i in millInfo) {
      let shape = millInfo[i]['shape']
      for (let j in shape) {
        const p = shape[j]
        const x = p['x'] - oo.x
        const y = p['y'] - oo.y

        p['x'] = -direction * y + oo.y
        p['y'] = direction * x + oo.x
      }
    }
  }

  if (oriCurveHoles) {
    for (var i in oriCurveHoles) {
      let path = oriCurveHoles[i]['path']
      for (let j in path) {
        var p = path[j]
        var x = p['x'] - oo.x
        var y = p['y'] - oo.y

        p['x'] = -direction * y + oo.y
        p['y'] = direction * x + oo.x
      }
    }
  }

  // oPath
  for (var i in oPaths) {
    var path = oPaths[i]
    for (var j in path) {
      var p = path[j]
      var x = p['x'] - oo.x
      var y = p['y'] - oo.y

      p['x'] = -direction * y + oo.y
      p['y'] = direction * x + oo.x
    }
  }
  for (let idx = 0; idx < lineSlots.length; idx++) {
    const lineSlot = lineSlots[idx]
    const { path, oPath, polygonArr = [] } = lineSlot

    for (var j in path) {
      let p = path[j]
      let x = p['x'] - o.x
      let y = p['y'] - o.y
      p['x'] = -direction * y + o.y
      p['y'] = direction * x + o.x
    }
    for (var j in oPath) {
      let p = oPath[j]
      let x = p['x'] - oo.x
      let y = p['y'] - oo.y
      p['x'] = -direction * y + oo.y
      p['y'] = direction * x + oo.x
    }
    polygonArr.forEach((polygon) => {
      for (var j in polygonArr) {
        let p = polygon[j]
        let x = p['x'] - o.x
        let y = p['y'] - o.y
        p['x'] = -direction * y + o.y
        p['y'] = direction * x + o.x
      }
    })
  }

  for (var i in cutCurve) {
    var p = cutCurve[i]
    var x = p['x'] - o.x
    var y = p['y'] - o.y

    p['x'] = -direction * y + o.y
    p['y'] = direction * x + o.x
  }

  for (var i in cutCurveEx) {
    path = cutCurveEx[i]
    for (var j in path) {
      var p = path[j]
      var x = p['x'] - o.x
      var y = p['y'] - o.y
      p['x'] = -y + o.y
      p['y'] = x + o.x
    }
  }

  for (var i in realCurve) {
    var p = realCurve[i]

    var x = p['x'] - oo.x
    var y = p['y'] - oo.y

    p['x'] = -direction * y + oo.y
    p['y'] = direction * x + oo.x
  }

  for (var i in realCurveEx) {
    // eslint-disable-next-line no-redeclare
    var path = realCurveEx[i]
    for (var j in path) {
      var p = path[j]

      var x = p['x'] - oo.x
      var y = p['y'] - oo.y

      p['x'] = -direction * y + oo.y
      p['y'] = direction * x + oo.x
    }
  }

  // holes

  for (var h in holes) {
    var hole = holes[h]
    var center = hole['center']
    var ocenter = hole['ocenter']

    var x = center['x'] - o.x
    var y = center['y'] - o.y
    center['x'] = -direction * y + o.y
    center['y'] = direction * x + o.x

    x = ocenter['x'] - oo.x
    y = ocenter['y'] - oo.y
    ocenter['x'] = -direction * y + oo.y
    ocenter['y'] = direction * x + oo.x
    const newHole = adjustHoleDirection(hole, 90 * direction)
    Object.assign(holes[h], newHole)
  }
  // slots
  const slotAndSlopesList = [...slots, ...(handleSlopes ?? [])]
  for (var s in slotAndSlopesList) {
    var slot = slotAndSlopesList[s]
    var pt1 = slot['pt1']
    var pt2 = slot['pt2']
    var opt1 = slot['opt1']
    var opt2 = slot['opt2']

    var x1 = pt1['x'] - o.x
    var y1 = pt1['y'] - o.y
    var x2 = pt2['x'] - o.x
    var y2 = pt2['y'] - o.y
    pt1['x'] = -direction * y1 + o.y
    pt1['y'] = direction * x1 + o.x
    pt2['x'] = -direction * y2 + o.y
    pt2['y'] = direction * x2 + o.x

    x1 = opt1['x'] - oo.x
    y1 = opt1['y'] - oo.y
    x2 = opt2['x'] - oo.x
    y2 = opt2['y'] - oo.y
    opt1['x'] = -direction * y1 + oo.y
    opt1['y'] = direction * x1 + oo.x
    opt2['x'] = -direction * y2 + oo.y
    opt2['y'] = direction * x2 + oo.x
  }

  // sholes
  for (var k in sholes) {
    var shole = sholes[k]
    var side = shole['side']
    const ocenter = shole['ocenter']

    const x = ocenter['x'] - oo.x
    const y = ocenter['y'] - oo.y
    ocenter['x'] = -direction * y + oo.y
    ocenter['y'] = direction * x + oo.x

    side = parseInt(String(side)) - direction
    if (side <= 0) {
      side = 4
    } else if (side > 4) {
      side = 1
    }

    shole['side'] = side as 1 | 2 | 3 | 4
  }

  // sslots
  for (var j in sslots) {
    var sslot = sslots[j]
    var side = sslot['side'] as 1 | 2 | 3 | 4
    const opt1 = sslot['opt1']
    const opt2 = sslot['opt2']

    const x1 = opt1['x'] - oo.x
    const y1 = opt1['y'] - oo.y
    const x2 = opt2['x'] - oo.x
    const y2 = opt2['y'] - oo.y

    opt1['x'] = -direction * y1 + oo.y
    opt1['y'] = direction * x1 + oo.x
    opt2['x'] = -direction * y2 + oo.y
    opt2['y'] = direction * x2 + oo.x

    side = parseInt(String(side)) - direction
    if (side <= 0) {
      side = 4
    } else if (side > 4) {
      side = 1
    }

    sslot['side'] = side
  }
  sholeInfo = generatorSideHoleSlot([
    ...sholes,
    ...holes.filter((hole) => isSideMachineHole(hole) && hole.side == 1),
  ])
  sholeInfoF = generatorSideHoleSlot(
    holes.filter((hole) => isSideMachineHole(hole) && hole.side == -1),
    'upDownFlip'
  )
  sslotInfo = generatorSideHoleSlot(
    [
      ...sslots,
      ...slots.filter((slot) => isSideMachineSlot(slot) && slot.side == 1),
      ...(part.millInfo
        ? part.millInfo?.filter(
            (mill: any) => isSideMachineMillInfo(mill) && mill.side == 1
          )
        : []),
    ],
    '',
    part
  )
  sslotInfoF = generatorSideHoleSlot(
    slots.filter((slot) => isSideMachineSlot(slot) && slot.side == -1),
    'upDownFlip',
    part
  )

  // edgeInfo
  var left = edgeInfo.substring(
    edgeInfo.indexOf('←') + 1,
    edgeInfo.indexOf('↓')
  )
  var bottom = edgeInfo.substring(
    edgeInfo.indexOf('↓') + 1,
    edgeInfo.indexOf('→')
  )
  var right = edgeInfo.substring(
    edgeInfo.indexOf('→') + 1,
    edgeInfo.indexOf('↑')
  )
  var top = edgeInfo.substring(edgeInfo.indexOf('↑') + 1)
  let dealType
  if (direction == 1) {
    edgeInfo = '←' + bottom + '↓' + right + '→' + top + '↑' + left
    dealType = 'rotate90'
  } else {
    edgeInfo = '←' + top + '↓' + left + '→' + bottom + '↑' + right
    dealType = 'rotate90F'
  }
  if (edgeTextureMap) {
    // 确保数组有4个元素，对应左、下、右、上
    var leftTexture = edgeTextureMap[1] || ''
    var bottomTexture = edgeTextureMap[2] || ''
    var rightTexture = edgeTextureMap[3] || ''
    var topTexture = edgeTextureMap[4] || ''

    if (direction == 1) {
      // 顺时针90度旋转：左→上，下→左，右→下，上→右
      edgeTextureMap[1] = bottomTexture // 新的左 = 原来的下
      edgeTextureMap[2] = rightTexture // 新的下 = 原来的右
      edgeTextureMap[3] = topTexture // 新的右 = 原来的上
      edgeTextureMap[4] = leftTexture // 新的上 = 原来的左
    } else {
      // 逆时针90度旋转：左→下，下→右，右→上，上→左
      edgeTextureMap[1] = topTexture // 新的左 = 原来的上
      edgeTextureMap[2] = leftTexture // 新的下 = 原来的左
      edgeTextureMap[3] = bottomTexture // 新的右 = 原来的下
      edgeTextureMap[4] = rightTexture // 新的上 = 原来的右
    }
  }
  if (edgeArrowMap) {
    // 确保数组有4个元素，对应左、下、右、上
    var leftArrow = edgeArrowMap[0] || ''
    var bottomArrow = edgeArrowMap[1] || ''
    var rightArrow = edgeArrowMap[2] || ''
    var topArrow = edgeArrowMap[3] || ''

    if (direction == 1) {
      edgeArrowMap[0] = bottomArrow // 新的左 = 原来的下
      edgeArrowMap[1] = rightArrow // 新的下 = 原来的右
      edgeArrowMap[2] = topArrow // 新的右 = 原来的上
      edgeArrowMap[3] = leftArrow // 新的上 = 原来的左
    } else {
      edgeArrowMap[0] = topArrow // 新的左 = 原来的上
      edgeArrowMap[1] = leftArrow // 新的下 = 原来的左
      edgeArrowMap[2] = bottomArrow // 新的右 = 原来的下
      edgeArrowMap[3] = rightArrow // 新的上 = 原来的右
    }
  }
  part.doorOpenSide = dealFormerEdgeChange(
    part.doorOpenSide,
    dealType,
    'doorOpenSide'
  )
  part.lightEdgeInfo = dealEdgeInfoChange(part.lightEdgeInfo, dealType)
  part.model_front_edge = dealFormerEdgeChange(
    part.model_front_edge,
    dealType,
    'former'
  )
  part.smoothEdge = dealFormerEdgeChange(
    part.smoothEdge,
    dealType,
    'doorOpenSide'
  )
  // 预铣值处理
  if (part.edgePreMillingInfo) {
    const { appliedSides } = part.edgePreMillingInfo
    const { top, right, bottom, left } = appliedSides
    if (direction == 1) {
      part.edgePreMillingInfo.appliedSides = {
        top: left,
        right: top,
        bottom: right,
        left: bottom,
      }
    } else {
      part.edgePreMillingInfo.appliedSides = {
        top: right,
        right: bottom,
        bottom: left,
        left: top,
      }
    }
  }
  part['rect'] = rect
  part['oRect'] = oRect
  part['oldSize'] = oldSize
  part['startX'] = startX
  part['startY'] = startY
  if (part.path) {
    part['path'] = paths
  }
  if (part.oPath) {
    part['oPath'] = oPaths
  }
  if (part.cutCurve) {
    part['cutCurve'] = cutCurve
  }
  if (part.cutCurveEx) {
    part['cutCurveEx'] = cutCurveEx
  }
  part['realCurve'] = realCurve
  part['realCurveEx'] = realCurveEx
  part['holes'] = holes
  part['slots'] = slots
  part['sholes'] = sholes
  part['sslots'] = sslots
  part['realRect'] = realRect
  part['edgeInfo'] = edgeInfo
  part['edgeTextureMap'] = edgeTextureMap
  part.specWidth = oRect.width
  part.specHeight = oRect.height
  part['sholeInfo'] = sholeInfo
  part['sholeInfoF'] = sholeInfoF
  part['sslotInfoF'] = sslotInfoF
  part['sslotInfo'] = sslotInfo
  part['isReverse'] = isReverse
  part['edgeArrowMap'] = edgeArrowMap
  return part
}
// 用于修改属性
const changeProp = (
  part: PartType,
  prop: ExcludeType<IEditableFields, 'allEdge'>
) => {
  try {
    // 修改的属性是否是需要修正的属性 将类型变成数值类型
    if (
      needFixTypeProps.includes(
        prop as unknown as typeof needFixTypeProps[number]
      )
    ) {
      part = fixPlankDataType(part, prop as Exclude<IEditableFields, 'allEdge'>)
    }
    // 修改plankList和filterPlankList
    // 由于 使用了混排后，会修改filterplankList中的oriTexture，但是planklist不需要被修改，此处传入 part来源于filterPlankList
    assignPart(
      plankList.value,
      { ...part, oriTexture: part.texture },
      true,
      prop
    )
    assignPart(filterPlankList.value, part, true, prop)
    if (prop === 'texture') {
      assignPart(
        filterPlankList.value,
        { ...part, oriTexture: part.texture },
        true,
        prop
      )
    } else {
      assignPart(filterPlankList.value, part, true, prop)
    }

    // 需要清除孔槽信息
    if (needClearHoleSlotsProps.includes(prop)) {
      assignPart(
        plankList.value,
        { ...part, oriTexture: part.texture },
        false,
        prop
      )
      assignPart(filterPlankList.value, part, false, prop)
    }

    // 需要重新分类
    if (reClassifyProps.includes(prop)) {
      // isTaskLoading.value = true
      const newFilterPlankList = dealFilterData(
        filterPlankList.value,
        filterObj.value,
        searchCondition.value,
        specialRemarksForProcessLabel.value
      )
      setFilterPlankList(newFilterPlankList)
      const newPlankList = dealMaterialList(plankList.value)
      setPlankList(newPlankList)
    }
    // 如果此时筛选条件中有此属性，则需要将修改后的属性值加入到筛选列表中
    filterObj.value = addFilterPropValue(
      filterObj.value,
      prop,
      part[prop] as unknown as string
    )
  } catch (error) {
    console.log('修改属性出错', error)
  } finally {
    // setTimeout(() => {
    //   isTaskLoading.value = false
    // }, 200)
  }
}

// 展开/折叠表头
const handleToggleFold = (plank: PlankType) => {
  plank.isUnfold = !plank.isUnfold
}

// 是否显示孔槽信息图
const isShowHSInfoModal = ref(false)
const currentPart = ref<PartType | null>(null)
const handleOpenHSInfoModal = (part: PartType) => {
  isShowHSInfoModal.value = true
  currentPart.value = part
}
const handleCloseHSInfoModal = () => {
  isShowHSInfoModal.value = false
  currentPart.value = null
}

/**
 * 视图切换
 *
 */
const toggleListTile = ref<ListTileType>(ListTileType.TABLE)
// 切换订单和绘制
const handleChangeListTile = (flag: ListTileType) => {
  toggleListTile.value = flag
  if (flag === ListTileType.TABLE) {
    buryPointApi('material', 'change_material_type')
  }
}

/**
 * 勾选操作
 */

// 勾选单个/全选
const handleSelectTablePlank = (
  plank: PlankType | null,
  data: PlankType | PartType
) => {
  const plankArr = [...plankList.value, ...filterPlankList.value]
  // 勾选的是大板，即是全部勾选/取消勾选

  if ('parts' in data) {
    data.parts.forEach((part) => {
      part.isSelected = data.isAllSelect
    })
    plankArr.forEach((P) => {
      if (P.categoryKey == data.categoryKey) {
        P.parts.forEach((p) => {
          p.isSelected = data.isAllSelect
        })
      }
    })
  } else {
    // 勾选小板
    plank?.parts.forEach((part) => {
      if (part.partUniqueId === data.partUniqueId) {
        part.isSelected = data.isSelected
      }
    })
    plankArr.forEach((P) => {
      P.parts.forEach((p) => {
        if (p.partUniqueId === data.partUniqueId) {
          p.isSelected = data.isSelected
        }
      })
    })
  }
  changeFilterPlankList()
  handleComputedIsAllSelect()
  // 更新plankList.value 这里应该不需要 暂时注释掉
  // setPlankList(filterPlankList.value)
}

// 勾选全部/取消勾选后需要修改filterPlankList、plankList中的isAllSelect
const handleComputedIsAllSelect = () => {
  // 这里应该不需要改源数据
  computedIsAllSelect(plankList.value)
  computedIsAllSelect(filterPlankList.value)
}

const computedIsAllSelect = (plankList: PlankType[]) => {
  const plankListSelectStatus = plankList.map((plank) => {
    return plank.parts.every((part) => part.isSelected)
  })
  plankListSelectStatus.forEach((status, indexs) => {
    plankList[indexs].isAllSelect = status
  })
}

// 是否勾选所有小板
const isSelectedAllPlank = computed({
  get() {
    // 这里不该只考虑外部的isAllSelect，而是需要考虑内部的所有parts的isSelected才会更准确，
    // （杜绝：因为搜索导致数据覆盖,会有搜索出来的数据即使没全选中，isAllSelect为true）
    // return filterPlankList.value.every((pl) => pl.isAllSelect)
    filterPlankList.value.forEach((pl) => {
      if (pl.parts.every((part) => part.isSelected)) {
        pl.isAllSelect = true
      } else {
        pl.isAllSelect = false
      }
    })
    return filterPlankList.value.every((pl) => pl.isAllSelect)
  },
  set(val) {
    handleChangeAllPlank({ target: { checked: val } } as any)
  },
})
const handleChangeAllPlank = (val: ChangeEvent<HTMLInputElement>) => {
  const { checked } = val.target

  changeAllPart(plankList.value, checked)

  changeAllPart(filterPlankList.value, checked)
}

// 修改所有小板的选中状态
const changeAllPart = (
  plankList: PlankType[] | Readonly<PlankType[]>,
  val: boolean
) => {
  plankList.forEach((plank) => {
    plank.isAllSelect = val
    plank.parts.forEach((part) => {
      part.isSelected = val
    })
  })
  // 这里需要重新计算changeData
  changeFilterPlankList()
}
const tempOrderInfo = ref({})

/**
 * @description 本页面用于更新偏好设置，会在偏好设置更新以及页面加载时调用
 * @param data 不传值则是 store 中的偏好设置
 */
function updatePreference({ data, isErr }: any) {
  if (!isErr) {
    data = data || store.state.preferencesSetting.setting
    Object.keys(preferencesSetting.value).forEach((k) => {
      ;(preferencesSetting.value as any)[k] = data[k]
    })
    currentPreferenceSetting.value = {
      isDefaultFoldData: data.pick_up_data ?? false,
      isLoadMoreTable: data.isLoadMoreTable ?? false,
      savedHightLightProp: data.saved_highlight_prop ?? false, // 获取该用户是否保存过表头
      isCheckBigPlankSynchronous: data.isCheckBigPlankSynchronous ?? false,
      isBujianRecommend: data.isBujianRecommend ?? true,
      isPaibanStoreRecommend: data.isPaibanStoreRecommend ?? true,
      isSurplusRecommend: data.isSurplusRecommend ?? true,
    }
    searchCondition.value.searchKeyType = data.searchKeyType ?? 'address'
  }
  handleDefaultFoldData(currentPreferenceSetting.value.isDefaultFoldData)
}
// 数据初始化
const initData = (
  data: PartType[],
  options = {
    isClearHSInfo: false,
    isLoadMore: currentPreferenceSetting.value.isLoadMoreTable,
    isToggle: false,
  },
  isImport = false
) => {
  plankErrMsg.value = translateLang('板件内部数据存在异常，无法进行排版生产')
  const { isClearHSInfo, isLoadMore, isToggle } = options
  // 处于导入数据，且未开启导入不覆盖
  if (isImport && !isLoadMore) {
    // 删除原先的所有数据
    handleDeleteAllParts()
  }

  // 如果开启了导入覆盖,且当前不是切换页面，那么在导入数据时，清空上一次的记录
  if (!isLoadMore && !isToggle) {
    resetOperateRecord()
  }

  try {
    const { plankList: newPlankList, orderInfo: newOrderInfo } = dealData({
      data,
      originPlankList: plankList.value,
      orderInfo: orderInfo.value,
      isClearHSInfo,
      isLoadMore,
      isFold: currentPreferenceSetting.value.isDefaultFoldData,
      isToggle,
    })
    setPlankList(newPlankList)
    // 这里需要重新计算changeData
    changeFilterPlankList(newPlankList)

    // 这里初始化时候 filterPlankList 需要克隆一份 不然会修改到plankList.value数据
    // 实际情况 filterPlankList用于页面展示，plankList.value 源数据非不必要不要修改
    setFilterPlankList(cloneDeep(newPlankList))
    tempOrderInfo.value = newOrderInfo

    // 将这里的数据
  } catch (error) {
    console.log('error', error)
  }
}
/**
 * 批量获取板件的品牌和供应商信息并回填到板件数据中
 * @param arr 板件数组（会被就地修改）
 */
const fetchAndSetBrandInfo = async (arr: PartType[]) => {
  const colorIdsString = Array.from(
    new Set(arr.map((part: PartType) => part.colorId).filter(Boolean))
  ).join(',')
  if (!colorIdsString) return
  try {
    const brandAndSupplierInfoList = await fetchGetBrandAndSupplierInfo({
      color_ids: colorIdsString,
    })
    if (brandAndSupplierInfoList.status === 1) {
      arr.forEach((part: PartType) => {
        const { colorId } = part
        if (colorId) {
          const brandAndSupplierInfo = brandAndSupplierInfoList.data.find(
            (item) => item.id === Number(colorId)
          )
          if (brandAndSupplierInfo) {
            part.brandName = brandAndSupplierInfo.brand_name
            part.supplierName = brandAndSupplierInfo.supplier_name
          }
        }
      })
    }
  } catch (error) {
    console.log(error)
  }
}

// 判断是否正确记载了数据
const hasLoadData = ref(false)
onMounted(async () => {
  EventBus.$on(EventBusKey.REFRESH_MATERIAL_LIST, () => {
    trialRef.value?.closeModal()
    initData(preLayoutData.value, {
      isToggle: !isTrialProduct.value,
      isClearHSInfo: false,
      isLoadMore: currentPreferenceSetting.value.isLoadMoreTable,
    })
  })
  store.commit('paibanTaskStore/setIsLoading', false)
  try {
    // 挂载偏好设置的更新
    proxy.$preference.init(updatePreference, route.path)
    isTaskLoading.value = true
    getSpecialRemarks().then((res) => {
      if (res?.status === 200) {
        store.commit('setSpecialRemarks', res?.data?.data ?? {})
      }
    })
    // 获取材质列表的数据
    const matCodeRes = await fetchMaterialMatCodes()
    if (matCodeRes) matCodeList.value = matCodeRes

    // 初始化样表表单数据
    samPleFormData.value = JSON.parse(
      JSON.stringify(store.state.sampleTableData)
    )
    const searchUrl = window.location.href
    if (
      searchUrl.includes('thinkerx_material') &&
      route.query.thinkerx_material
    ) {
      newPlankInfo.value.texDir = 'notcare'
    } else if (!searchUrl.includes('thinkerx_material')) {
      newPlankInfo.value.texDir = 'normal'
    }

    // 处理第三方数据
    if (thirdPlankData.value && thirdPlankData.value.length) {
      const arr = dealThinkerxMaterialData(thirdPlankData.value)
      initData(arr)
    }
    if (window?.webToQt?.loadIndicatorHide) {
      window.webToQt.loadIndicatorHide()
    }

    // 颜色配置项赋值
    if (!materialColorOptions.value.length) {
      materialColorOptions.value = materialColorList.value
    }

    // 当前为试生产
    if (isTrialProduct.value && trailProductState.value === 1) {
      ;(vm?.proxy as any)?.$antdConfirm({
        title: '温馨提示',
        content:
          '当前试生产订单已调整为使用当前账号的工艺设置数据，请注意您的工艺设置！',
        okText: '确定',
        class: 'trail-tech-modal',
        centered: true,
      })
    }
    syncSearchOptionsListCustomLabels()
    if (route.query.isTask) {
      store.commit('setHasSendToTask', true)
      const res = await httpRequest.get(route.query.paibanJson as string)
      dealJsonData(res)
    } else if (route.query.isBatch) {
      store.commit('setHasSendToTask', true)
      if (batchPaiban.value) {
        dealJsonData(batchPaiban.value)
      } else {
        const res = await httpRequest.get(route.query.paibanJson as string)
        dealJsonData(res)
      }
    }

    if (route.query && route.query.from) {
      store.commit('changeQtFrom', route.query.from)
      if (typeof route.query.from === 'string') {
        sessionStorage.setItem('QtFrom', route.query.from)
      }
    }
    // 检测guigui数据是否更新
    detectGuiguiBaseMIsUpdate()

    if (window.sessionStorage.getItem('isHistory')) {
      store.commit('changeHistoryStatus', true)
    }

    const guiguiJumpEquipmentParams = JSON.parse(
      window.sessionStorage.getItem('guiguiJumpEquipmentParams')!
    )
    // 根据token和data_id获取线上数据
    const queryKeys = Object.keys(route.query)
    if (!queryKeys.includes('isTask') && !queryKeys.includes('isBatch')) {
      if (
        (queryKeys.length > 0 &&
          !queryKeys.includes('material_cache_data') &&
          !route.query.thinkerx_material &&
          !queryKeys.includes('general_material')) ||
        sessionStorage.getItem('isThirdOder') ||
        (guiguiJumpEquipmentParams &&
          Object.keys(guiguiJumpEquipmentParams).length > 0)
      ) {
        if (route.query.data_id || guiguiJumpEquipmentParams?.data_id) {
          await dealDataFromGuigui()
        }
        if (route.query.oids) {
          await dealDataFromLbl()
        }
        return
      } else {
        isTableEmpty.value = false
      }
    }
    // 这一步切换页面、从历史记录进入
    if (preLayoutData.value.length > 0) {
      // TODO 在这一步失去修改内容

      initData(preLayoutData.value, {
        isToggle: !isTrialProduct.value,
        isClearHSInfo: false,
        isLoadMore: currentPreferenceSetting.value.isLoadMoreTable,
      })
      return
    }
    let thinkerx_material = sessionStorage.getItem('thinkerx_material')
    let third_material = sessionStorage.getItem('material_cache_data')
    const general_material = sessionStorage.getItem(
      SESSION_STORAGE_KEYS.GENERAL_MATERIAL
    )
    if (window.sessionStorage.getItem('materialParams') && !thinkerx_material) {
      isTableEmpty.value = true
      emptyShow.value = true
      store.commit('setIsShowSample', false)
      store.commit('setIsLinkLogin', true)
      let params = JSON.parse(
        window.sessionStorage.getItem('materialParams') as string
      )
      try {
        store.commit('setPreLayoutParam', params)
        store.commit('setOrderInfo', params.orderInfo)
        let obj: {
          addition_info: string
          room_ids?: string[]
          order_ids?: string[]
        } = {
          addition_info: orderInfo.value.addition_info,
        }
        if (params.type == 'roomId') {
          obj.room_ids = params.data
        } else {
          obj.order_ids = params.data
        }

        const res = await fetchGetLayoutData(obj)
        if (res?.status == 1) {
          let arr: PartType[] = []
          for (let i = 0; i < res.data.result_data.length; i++) {
            arr = [
              ...arr,
              ...res.data.result_data[i].map((part: PartType) => ({
                ...part,
                srcTexDir: part.texDir,
                srcPath: part.path ? part.path[0] : null,
              })),
            ]
          }
          if (res.data.addition_data && res.data.addition_data.length) {
            arr = arr.concat(handleBujianPlanks(res.data.addition_data))
          }
          await fetchAndSetBrandInfo(arr)

          initData(arr)
          emptyShow.value = false
        }
      } catch (error) {
        console.log('getLayout', error)
      }
    } else if (thinkerx_material) {
      emptyShow.value = true
      isTableEmpty.value = true
      store.commit('setIsShowSample', false)
      store.commit('setIsLinkLogin', true)
      try {
        // 统一的请求处理函数：先尝试 .json.gz，如果失败再尝试 .json
        // 由于上传时已设置 Content-Encoding: gzip 头，浏览器会自动解压，不需要手动解压
        const fetchJsonData = async (baseRequestUrl: string) => {
          try {
            // 先尝试 .json.gz 格式（新数据），浏览器会自动解压
            const gzipUrl = `${baseRequestUrl}.json.gz`
            return await axios({ url: gzipUrl })
          } catch (gzipError: any) {
            // 如果 .json.gz 找不到（404 或其他错误），尝试 .json 格式（老数据）
            if (
              gzipError?.response?.status === 404 ||
              gzipError?.code === 'ERR_NETWORK'
            ) {
              try {
                const jsonUrl = `${baseRequestUrl}.json`
                return await axios({ url: jsonUrl })
              } catch (jsonError) {
                // 如果 .json 也失败，抛出错误
                throw jsonError
              }
            } else {
              // 其他错误直接抛出
              throw gzipError
            }
          }
        }

        const lblUrl = sessionStorage.getItem('thinkerx_url')
        let res: any
        if (lblUrl) {
          const baseUrl = `${lblUrl}${thinkerx_material}`
          const baseNewUrl = `${lblUrl.replace(
            /http:/g,
            'https:'
          )}${thinkerx_material}`

          // 直接使用 axios 返回的 Promise
          const urlPromise = fetchJsonData(baseUrl)
          const newUrlPromise = fetchJsonData(baseNewUrl)

          const response = await Promise.allSettled([urlPromise, newUrlPromise])
          const fulfilledResponses = response.filter(
            (item): item is PromiseFulfilledResult<any> =>
              item.status === 'fulfilled'
          )

          if (fulfilledResponses.length > 0) {
            res = fulfilledResponses[0].value
          }
        }

        const guimenBaseUrl = `https://mini2015.thinkerx.com/menerp/runtime/export/${thinkerx_material}`
        res = res ? res : await fetchJsonData(guimenBaseUrl)
        if (res?.data && res.data?.length > 0) {
          store.commit('setImportCount', 1)
          isTableEmpty.value = false
          let guimenKeys = []
          for (let key in res.data[0]) {
            if (key != 'remark_names') {
              guimenKeys.push(key)
            }
          }
          store.commit('recordGuimenDataKeys', guimenKeys)
        } else {
          isTableEmpty.value = false
        }
        let arr = dealThinkerxMaterialData(res.data)
        initData(arr)
        if (res?.data?.length !== 0) {
          let { factoryId } = res.data[0]
          sessionStorage.setItem('thinkerx_material_factory_id', factoryId)
        }
        emptyShow.value = false
      } catch (error) {
        console.log('error', error)
      } finally {
        isTaskLoading.value = false
      }
    } else if (third_material) {
      // 第三方数据参数处理
      const dataKey = sessionStorage.getItem('material_cache_data')
      const token = sessionStorage.getItem('third_token')
      if (dataKey && token) {
        isTableEmpty.value = true
        const params = {
          token: token,
          bluen_data_key: dataKey,
        }
        const res = await getThirdData(params)
        if (res?.data?.plank_data?.length) {
          store.commit('setImportCount', 1)
          let arr = dealThinkerxMaterialData(res.data.plank_data)
          initData(arr)
          emptyShow.value = false
        }
      }
    } else if (general_material) {
      const generalMaterialData = await dealGeneralMaterialData()
      if (generalMaterialData) {
        store.commit('setImportCount', 1)
        dealJsonData(generalMaterialData, importCount.value > 1)
        emptyShow.value = false
      }
    }
  } catch (error) {
    console.log('onMounted', error)
  } finally {
    // 加载偏好设置
    hasLoadData.value = true
    // 新增菜单项默认收起数据处理
    handleDefaultFoldData(currentPreferenceSetting.value.isDefaultFoldData)
    isTaskLoading.value = false
  }
})

/**
 * 组件卸载前
 */

// 离开页面时给preLayout赋值
onBeforeUnmount(() => {
  // removeBusEvent()
  const preLayoutData = getAllParts(plankList.value)
  // 只有正确加载完数据后才会对prelayoutData重新赋值
  if (hasLoadData.value) {
    store.commit('setPreLayoutData', preLayoutData)
    store.commit('setFilterMaterialList', filterPlankList.value)
  }
  EventBus.$off(EventBusKey.REFRESH_MATERIAL_LIST)
  filterPlankList.value = null as any
  plankList.value = null as any
  changeData.value = []
})

// 修边显示
// function showTrimText(surplus: any) {
//   // 如果是异形余料或者L形余料显示 ‘/’
//   if (surplus.shape !== 0) return '/'
//   if (!surplus.surplus_trim_edge) {
//     // 显示默认修边的内容
//     const surplus_trim_data = storePreferencesSetting.value.surplus_trim_data
//     if (
//       !surplus_trim_data ||
//       !surplus_trim_data.trimmingMethod ||
//       surplus_trim_data.trimmingMethod === 'follow'
//     ) {
//       return '/'
//     }
//     return surplus_trim_data.isCustomTrim
//       ? `${surplus_trim_data.topTrim},${surplus_trim_data.bottomTrim},${surplus_trim_data.leftTrim},${surplus_trim_data.rightTrim}`
//       : surplus_trim_data.trimValue
//   }
//   return surplus.surplus_trim_edge
// }

return { __sfc: true,vm, proxy, route, router, store, overSizeTipContent, storePreferencesSetting, specialRemarksForProcessLabel, highPlankOptions, isFirstLoadJson, isTaskLoading, importCount, dataFrom, hasSelectSpecialShapeSurplus, hasSendToTask, sendTaskModal, getPopupContainer, drawScale, drawObj, showSupplusShape, handleBackToTask, handleCancelToTask, needFreezeProp, plankList, filterPlankList, setPlankList, sortTypeObj, handleSort, changeData, changeFilterPlankList, setFilterPlankList, materialTableData, inputFileRef, isImportLoading, handleOpenFile, lackTableString, isLinkLogin, getFileData, showMIncorrectFormat, showTableDialog, isShowLackNeedTableHeaderData, isShowLackNeedTableHeader, necessaryTableLackString, necessaryTableIncorrectFormat, handleClearMIncorrectFormatData, handleClearMissingData, checkImportData, isNumericPositive, selectedParts, bujianDataForPaiban, awaitStoreDataForPaiban, hasBrandPartForPaiban, extraBrandPartsForPaiban, getParticipationPartsForPaiban, updateHasBrandPartForPaiban, isShowDeletePartModal, isDeletePartLoading, handleOpenDeletePartModal, handleConfirmDeletePart, handleDeletePart, handleDeleteAllParts, deletePart, handleCopyLine, getSelectedData, getAllParts, paibanData, handleGoPaiban, handleDownloadSample, texDirMap, expandPartsForDownload, buildPartDownloadRow, dealDownloadData, isExportHoleSlotPdf, isExportHoleSlotDxf, handleExportHoleSlotPdf, exportHoleSlotPdf, exportThreeView, handleExportHoleSlotDxf, customTableHeaderModalRef, handleSettingTableHeader, handleConfirmChangeTableHeader, searchCondition, handleChangeSize, throttleChangeSize, searchOptionsList, syncSearchOptionsListCustomLabels, currentSearchKeyType, handleChangeSearchKeyType, handleSearchKeyword, isShowSaveHistoryModal, historyName, handleOPenSaveHistoryModal, isSavePaiBanLoading, handleSaveHistory, saveMaterialPaiban, recodeSelectPart, selectedSurplus, ncSetting, ossFilesParams, isShowAddAWaitStoreDialog, isAddAwaitStoreLoading, awaitStoreRef, handleOpenPushStoreDialog, handleStorageToAwaitStore, isShowSurplusList, surplusInfo, isCustomSurplusEdge, surplusList, surplusListRef, surplusSortable, destroySurplusSortable, initSurplusSortable, handleAddNewSurplus, isSelectedAllSurplus, getSurplusList, handleSurplusLockShow, handleSelectSurplus, handleSelectAllSurplus, recordSelectSurplus, checkSurplusNum, onChangeIsShowSurplusList, surplusCellRefs, handleBujianPlanks, dealGGid, emptyShow, isShowSample, samPleFormData, samPleConfig, isTableEmpty, filterObj, dealPlankListForcomputed, virtualHeadRowWidth, handleGetTableWidth, needReviewData, confirmAddPart, openModal, newPlankInfo, isShowAddPartDrawer, isAddLoading, handleOpenAddDrawer, handleCloseDrawer, handleConfirmAddPart, clearNewPlankInfo, addPart, materialColorList, materialColorOptions, matCodeList, handleSelectMatCode, isLoadingColors, handleCreateMatCode, handleSelectTexture, handleCreateTexture, onBeforeFilter, inputCheck, handleSelectTexDir, showAddBaseMModal, isShowPlateDetails, showAddSpecialPlate, showBigPlateDetail, plankErrVisible, plankErrMsg, showSyncGuiguiBaseMModal, BaseMIsSame, syncGuiguiBaseMLoading, syncGuiguiBaseM, detectGuiguiBaseMIsUpdate, paibanParams, proLineList, isShowPaibanModal, preLayoutSetting, handleOpenPaibanModal, isShowMixPaibanPlanModal, handleOpenMixPaibanPlanModal, hasMixPaibanPlansChanged, selectedMixPaibanPlans, currentMixPaibanPlans, handleMixPaibanPlanOk, countParts, detactionPlank, showSaveDialog, handleCancelPiaban, isPaibanErr, isNotSawKnife, handleCancelPaibanTimeout, isConfirmLoading, resetPaibanData, paibanFormData, showPartDetail, paibanMessage, handleShowPartDetail, handleClosePartDetail, paibanSettingState, isCreateTask, handleStartPaiban, isShowSpecialAndFiveSix, continueJudgeSpecialShape, handleConfirmContinuePaiban, handleCancelContinuePaiban, isError, dealPlateErr, updateMaterialData, dealLayoutData, genFinalRecordFn, extraLongPlates, extraLongPlatesIndex, currentExtraLongPlatesItem, bigPlateList, calculateBigPlateList, handleViewExtralPlateList, handleCloseAddSpecialPlate, isAddBigPlateLoading, handleAddBigPlate, saveSpecialPlank, handleDelBigPlate, handleCheckSpecialPlateSize, handleGoBackToAddExtraLongPlates, autoAddSpecialPlate, handleViewExtralPlateDetail, handleToBaseMaterial, handleGoBack, handleToggleExtraPlate, materialInfo, needBaseMaterials, judgePlateKnife, oldFiveSixXYTip, checkPlankIsAvailable, errorPathPlankID, isNewLayout, dealMaterialKnife, dealReadPaibanData, handleSurplusLock, dealSurplusParams, prePaibanData, saveTaskOperationRecord, getPaibanData, beforePaibanDataDeal, isCanContinue, orderIds, proucePopupState, isShowOrderMark, paibanSettingRef, bujianTableRef, handleOrderMarkOk, handleOrderMarkCancel, handleShowOrderMark, trialRef, customizeFolderSetting, userInfo, NCUrls, folderChooseModalRef, handleProlineIsElectronicSaw, repeatFileNameList, repeatFolderNameList, repeatNameList, isShowWarningModal, downloadFile, autoSaveHistory, sendNcFileToFactory, OrderTypeMap, dealWebToQtData, dealElectronicSawData, checkFolderName, getLabelPaibanImg, drawParts, drawText, wrapText, calcTextSize, isShowSendToFactoryModal, handleSendToFactory, handleConfirmSend, setProLineList, selectProLine, handleSelectProLine, getSelectLine, selectStandardPlank, filterProps, filterProp, filterSearchVal, filterVisible, searchVal, isHighGlossPlankVisible, handlePlankFilter, isCheckAll, checkedKeys, filterKeys, getAllKeys, handleSelectAll, highlightProps, getFilterItem, getParentKey, expandedKeys, searchValue, autoExpandParent, onExpand, dataList, generateList, onChange, handleCancleHighGlossFilter, handleResetHighGlossFilter, handleConfirmHighGlossFilter, handleConfirmFilter, handleCloseFilterModal, handleResetFilter, addFilterPropValue, onAfterFilterClose, isShowBatchChangePropsModal, isUpdating, handleCancelEdit, handleOpenBatchChangeModal, plankEditorModalRef, tips, extraWarningTips, deleteHolesSlotsDataList, handleConfirmEdit, addOperateRecord, saveOperateRecord, resetOperateRecord, reClassifyProps, needClearHoleSlotsProps, needClearFrameDoorIdentityProps, affectTextureProps, shouldClearFrameDoorIdentity, partHasFrameDoorIdentity, clearFrameDoorIdentityIfPresent, batchUpdateProps, clearPlankObjHoleSlotsInfo, dealSurplusShape, handleTrialProductConfirm, isTrialProduct, trailProductState, preferencesSetting, currentPreferenceSetting, handleDefaultFoldData, CurrentPerfSettingMap, allPerfSettingMap, savePreferences, handleBury, thirdPlankData, batchPaiban, preLayoutData, orderInfo, dealJsonData, dealDataFromGuigui, handleTrailState, getLayoutData, isFromLbl, dealDataFromLbl, currentHeadPropList, typeColumnHeadDisplayText, checkIsSpecial, needFixTypeProps, nowInputWord, clearTextureGrainInfoInPage, handleTexturePropChangeConfirm, handleInputBlur, collectChangeProp, handleDealChangePartData, handleSelectChange, updateBlur, handleClickCell, plankSpecialDeal, assignPart, fixPlankDataType, virtualListRef, handleFocusPlankTexDir, changeTexDir, rotatePlank, changeProp, handleToggleFold, isShowHSInfoModal, currentPart, handleOpenHSInfoModal, handleCloseHSInfoModal, ListTileType, toggleListTile, handleChangeListTile, handleSelectTablePlank, handleComputedIsAllSelect, computedIsAllSelect, isSelectedAllPlank, handleChangeAllPlank, changeAllPart, tempOrderInfo, updatePreference, initData, fetchAndSetBrandInfo, hasLoadData, BaseFrom, loading, DrawItem, DrawSupplus, GBaseModal, GCopyLine, GFolderChooseModal, GOrderProductionMarking, GPaidFeature, GTableDialog, GWarningModal, holesSlotsPopUp, virtualList, newContent, USER_PERMISSION_KEY, translateLang, judgeIsMergeFrameDoor, matchHighlightBoardName, translate, MTryProductionDialog, Tooltip, MAwaitPaibanStore, MBujianTable, MCustomizeTableHeader, CustomizeTableHeader, MIncorrectFormat, mMixPaibanPlanModal, MNotPaibanDetail, plankEditor, plankFilter, paibanSetting, doorOptions, surplusHeaders, texDirOptions, extraPartsTableConfig, calculatePlankAmount, calculatePlankArea, processLabelFn, showMaterialHingeinfo }
}

})